// // // import pinkbanner from "../images/reccartbanner.png";
// // // import Adresspopup from "./Adresspopup";
// // // import { ChevronLeft, ChevronRight, MapPin } from "lucide-react";
// // // import { Link } from "react-router-dom";
// // // import axios from "axios";
// // // import logo from "../images/logo.png";
// // // import editIcon from "../images/editicon.svg";
// // // import { useNavigate } from "react-router-dom";
// // // import React, { useEffect, useRef, useState } from "react";
// // // import { useCart } from "../Context/Createcontext";
// // // import { toast } from "react-hot-toast";
// // // import DeletePromptForCart from "../Components/common/DeletePromptForCart";
// // // import { Helmet } from "react-helmet";
// // // import { api_url } from "../config/config";
// // // import addToCartIcon from "../Icons/addToCartIcon.svg";
// // // import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// // // import wish from "../images/wish.svg";
// // // import wishlist from "../images/wishlist_nofill.svg";
// // // import { useWishlist } from "../Context/WishlistContext";
// // // import loader from "../images/loaderimg.png";

// // // const loadScript = (src) =>
// // //   new Promise((resolve) => {
// // //     const s = document.createElement("script");
// // //     s.src = src;
// // //     s.onload = () => resolve(true);
// // //     s.onerror = () => resolve(false);
// // //     document.body.appendChild(s);
// // //   });

// // // /* ── helpers ─────────────────────────────── */
// // // const RadioDot = ({ active }) => (
// // //   <div
// // //     className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all
// // //     ${active ? "border-[#1e4a46]" : "border-[#e2eaea]"}`}
// // //   >
// // //     {active && <div className="w-[7px] h-[7px] rounded-full bg-[#1e4a46]" />}
// // //   </div>
// // // );

// // // const CartIcon = () => (
// // //   <svg
// // //     width="15"
// // //     height="15"
// // //     viewBox="0 0 24 24"
// // //     fill="none"
// // //     stroke="white"
// // //     strokeWidth="2.5"
// // //     strokeLinecap="round"
// // //     strokeLinejoin="round"
// // //   >
// // //     <circle cx="9" cy="21" r="1" />
// // //     <circle cx="20" cy="21" r="1" />
// // //     <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
// // //   </svg>
// // // );

// // // const TrashIcon = () => (
// // //   <svg
// // //     width="13"
// // //     height="13"
// // //     viewBox="0 0 24 24"
// // //     fill="none"
// // //     stroke="currentColor"
// // //     strokeWidth="2"
// // //     strokeLinecap="round"
// // //     strokeLinejoin="round"
// // //   >
// // //     <polyline points="3 6 5 6 21 6" />
// // //     <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" />
// // //     <path d="M10 11v6M14 11v6" />
// // //     <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14" />
// // //   </svg>
// // // );

// // // /* Section card header */
// // // const SCardHead = ({ icon, title, badge }) => (
// // //   <div className="bg-[#f4fbfa] border-b border-[#e2eaea] px-4 py-3 flex items-center gap-2.5">
// // //     <div className="w-7 h-7 rounded-[8px] bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0">
// // //       {icon}
// // //     </div>
// // //     <span className="text-[13px] font-bold text-[#1e4a46] flex-1">{title}</span>
// // //     {badge && (
// // //       <span className="bg-[#eaf4f3] border border-[#d4ecea] text-[#1e4a46] text-[10px] font-bold px-2 py-0.5 rounded-full">
// // //         {badge}
// // //       </span>
// // //     )}
// // //   </div>
// // // );

// // // const indianStates = [
// // //   "Andhra Pradesh",
// // //   "Arunachal Pradesh",
// // //   "Assam",
// // //   "Bihar",
// // //   "Chhattisgarh",
// // //   "Goa",
// // //   "Gujarat",
// // //   "Haryana",
// // //   "Himachal Pradesh",
// // //   "Jharkhand",
// // //   "Karnataka",
// // //   "Kerala",
// // //   "Madhya Pradesh",
// // //   "Maharashtra",
// // //   "Manipur",
// // //   "Meghalaya",
// // //   "Mizoram",
// // //   "Nagaland",
// // //   "Odisha",
// // //   "Punjab",
// // //   "Rajasthan",
// // //   "Sikkim",
// // //   "Tamil Nadu",
// // //   "Telangana",
// // //   "Tripura",
// // //   "Uttar Pradesh",
// // //   "Uttarakhand",
// // //   "West Bengal",
// // //   "Andaman and Nicobar Islands",
// // //   "Chandigarh",
// // //   "Dadra and Nagar Haveli and Daman and Diu",
// // //   "Delhi",
// // //   "Jammu and Kashmir",
// // //   "Ladakh",
// // //   "Lakshadweep",
// // //   "Puducherry",
// // // ];

// // // /* ════════════════════════════════════════ */
// // // const Cartpage = ({ onClose }) => {
// // //   const navigate = useNavigate();
// // //   const {
// // //     handleAddToCart,
// // //     showLoginPopup,
// // //     setShowLoginPopup,
// // //     handleRemoveFromCart,
// // //     setCartCount,
// // //     setCartItems,
// // //   } = useCart();
// // //   const {
// // //     wishlist: wishlistItems,
// // //     addToWishlist,
// // //     removeFromWishlist,
// // //     loading: wishlistLoading,
// // //   } = useWishlist();

// // //   const [itemsInCartInCart, setCartItemsInCart] = useState([]);
// // //   const [featuredProducts, setFeaturedProducts] = useState([]);
// // //   const [currentFeatured, setCurrentFeatured] = useState([]);
// // //   const [currentIndex, setCurrentIndex] = useState(0);
// // //   const [quantities, setQuantities] = useState({});
// // //   const [selectedDeliveryOption, setSelectedDeliveryOption] = useState("home");
// // //   const [loading, setLoading] = useState(true);
// // //   const [showModal, setShowModal] = useState(false);
// // //   const [deleteData, setDeleteData] = useState(null);
// // //   const [isProcessing, setIsProcessing] = useState(false);
// // //   const [isCODProcessing, setIsCODProcessing] = useState(false);
// // //   const [isCODConfirmPopUp, setIsCODConfirmPopUp] = useState(false);
// // //   const [showConfirm, setShowConfirm] = useState(false);
// // //   const [addressError, setAddressError] = useState(false);
// // //   const [branchError, setBranchError] = useState(false);
// // //   const [paymentMode, setPaymentMode] = useState("ONLINE");
// // //   const [addresses, setAddresses] = useState([]);
// // //   const [selectedAddressId, setSelectedAddressId] = useState(null);
// // //   const [selectedAddress, setSelectedAddress] = useState(null);
// // //   const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
// // //   const [branches, setBranches] = useState([]);
// // //   const [selectedBranchId, setSelectedBranchId] = useState(null);
// // //   const [hasFetchedBranches, setHasFetchedBranches] = useState(false);
// // //   const [hasFetchedAddresses, setHasFetchedAddresses] = useState(false);
// // //   const [isPopupOpen, setPopupOpen] = useState(false);
// // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // //   const [originalTotal, setOriginalTotal] = useState(0);
// // //   const [totalSaved, setTotalSaved] = useState(0);
// // //   const [subtotal, setSubtotal] = useState(0);
// // //   const [total, setTotal] = useState(0);
// // //   const [bill, setBill] = useState({ discount: 0, delivery_fees: 0 });
// // //   const [tooltipOpen, setTooltipOpen] = useState(null);
// // //   const [addressErrors, setAddressErrors] = useState({
// // //     address_title: "",
// // //     address_line_1: "",
// // //     address_line_2: "",
// // //     pincode: "",
// // //     state: "",
// // //     mobile_number: "",
// // //   });
// // //   const [showAddressPrompt, setShowAddressPrompt] = useState(false);
// // //   const [showBranchPrompt, setShowBranchPrompt] = useState(false);

// // //   const scrollRef = useRef(null);
// // //   const shipping = "Free";
// // //   const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
// // //   const itemsPerPage = 8;
// // //   const totalPages = Math.ceil(featuredProducts.length / itemsPerPage);

// // //   const nameRegex = /^[A-Za-z\s]+$/;
// // //   const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
// // //   const pincodeRegex = /^\d{6}$/;
// // //   const mobileRegex = /^\d{10}$/;

// // //   const getCartQuantity = (vid) => {
// // //     const it = itemsInCartInCart.find((ci) => ci.variant_id === vid);
// // //     return it ? it.quantity : 0;
// // //   };
// // //   const OutOfQuantityCheck = (variants) =>
// // //     variants.every((v) => v.quantity === 0);

// // //   useEffect(() => {
// // //     window.scrollTo(0, 0);
// // //   }, []);
// // //   useEffect(() => {
// // //     const upd = itemsInCartInCart.reduce((acc, it) => {
// // //       acc[it.variant_id] = it.quantity;
// // //       return acc;
// // //     }, {});
// // //     setQuantities(upd);
// // //   }, [itemsInCartInCart]);
// // //   useEffect(() => {
// // //     if (itemsInCartInCart.length > 0) {
// // //       let disc = 0,
// // //         discTotal = 0;
// // //       itemsInCartInCart.forEach((it) => {
// // //         disc += (it.price - it.discounted_price) * it.quantity;
// // //         discTotal += it.discounted_price * it.quantity;
// // //       });
// // //       setBill({ discount: disc, delivery_fees: 0, total: discTotal });
// // //     }
// // //   }, [itemsInCartInCart]);
// // //   useEffect(() => {
// // //     if (selectedDeliveryOption === "pickup" && !hasFetchedBranches) {
// // //       fetchBranches();
// // //       setHasFetchedBranches(true);
// // //     }
// // //     if (selectedDeliveryOption === "home" && !hasFetchedAddresses) {
// // //       fetchAddresses();
// // //       setHasFetchedAddresses(true);
// // //     }
// // //   }, [selectedDeliveryOption]);
// // //   useEffect(() => {
// // //     const s = currentIndex * itemsPerPage;
// // //     setCurrentFeatured(featuredProducts.slice(s, s + itemsPerPage));
// // //   }, [currentIndex, featuredProducts]);

// // //   /* ── fetch ── */
// // //   const fetchCart = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const res = await fetch(`${api_url}/cart`, {
// // //         headers: {
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //       });
// // //       const data = await res.json();
// // //       if (res.ok) {
// // //         const fp = data.data.cartproduct.map((it) => {
// // //           const base = Number(it.variant?.price) || 0;
// // //           const disc = Number(it.variant?.discounted_price) || base;
// // //           return {
// // //             product_id: it.product_id,
// // //             variant_id: it.variant_id,
// // //             quantity: Number(it.quantity),
// // //             manufacturer: it.product?.Manufacturer?.name ?? "N/A",
// // //             name: it.product?.name ?? "Unnamed Product",
// // //             image:
// // //               it.product?.product_images?.image_url?.primary_image ??
// // //               `${api_url}/default-image.jpg`,
// // //             price: base,
// // //             discounted_price: disc,
// // //             discount_price: Math.max(base - disc, 0),
// // //             pack_size: it.variant?.pack_size ?? "-",
// // //             discount_percent: it.product?.discount_percent ?? 0,
// // //           };
// // //         });
// // //         setCartItemsInCart(fp);
// // //         setCartCount(fp.length);
// // //         calculateSummary(fp);
// // //       }
// // //     } catch {
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };
// // //   const fetchFeaturedProduct = async () => {
// // //     try {
// // //       if (!localStorage.getItem("authToken")) return;
// // //       const res = await fetch(`${api_url}/cart-list-products`, {
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //           "x-auth": "false",
// // //         },
// // //       });
// // //       const data = await res.json();
// // //       setFeaturedProducts(data.data || []);
// // //     } catch {}
// // //   };
// // //   const fetchAddresses = async () => {
// // //     try {
// // //       if (!localStorage.getItem("authToken")) return;
// // //       const res = await axios.get(`${api_url}/address/users`, {
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //       });
// // //       if (res.data.data.length > 0) {
// // //         const withBool = res.data.data.map((a) => ({
// // //           ...a,
// // //           is_default: a.is_default === true || a.is_default === "true",
// // //         }));
// // //         setAddresses(withBool);
// // //         const def = withBool.find((a) => a.is_default) || withBool[0];
// // //         setSelectedAddressId(def.address_id);
// // //         setSelectedAddress(def);
// // //       } else {
// // //         setAddresses([]);
// // //         setSelectedAddress(null);
// // //       }
// // //     } catch {}
// // //   };
// // //   const fetchBranches = async () => {
// // //     try {
// // //       const res = await axios.get(`${api_url}/branches`);
// // //       const raw = res.data.results || [];
// // //       setBranches([...new Map(raw.map((b) => [b.branch_id, b])).values()]);
// // //     } catch {}
// // //   };
// // //   useEffect(() => {
// // //     fetchCart();
// // //     fetchFeaturedProduct();
// // //     fetchAddresses();
// // //   }, []);

// // //   const calculateSummary = (items) => {
// // //     let orig = 0,
// // //       sub = 0,
// // //       saved = 0;
// // //     items.forEach((it) => {
// // //       const o = it.price * it.quantity;
// // //       const d = it.discounted_price * it.quantity;
// // //       orig += o;
// // //       sub += d;
// // //       saved += o - d;
// // //     });
// // //     setOriginalTotal(orig);
// // //     setSubtotal(sub);
// // //     setTotal(sub);
// // //     setTotalSaved(saved);
// // //   };

// // //   /* ── cart actions ── */
// // //   const handleQuantityChange = async (
// // //     productId,
// // //     variant_id,
// // //     quantity,
// // //     productName,
// // //     operation,
// // //   ) => {
// // //     if (!productId || !variant_id || typeof quantity !== "number") return;
// // //     const newQty = operation === "increase" ? quantity + 1 : quantity - 1;
// // //     try {
// // //       const res = await fetch(`${api_url}/cart`, {
// // //         method: "PATCH",
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //         body: JSON.stringify({
// // //           product_id: productId,
// // //           quantity: newQty,
// // //           variant_id,
// // //         }),
// // //       });
// // //       const data = await res.json();
// // //       if (!res.ok) {
// // //         if (data.message?.toLowerCase().includes("stock not available"))
// // //           toast.error(`${productName} is out of stock`);
// // //         return;
// // //       }
// // //       setCartItemsInCart((prev) =>
// // //         prev.map((it) =>
// // //           it.product_id === productId && it.variant_id === variant_id
// // //             ? { ...it, quantity: newQty }
// // //             : it,
// // //         ),
// // //       );
// // //       setCartItems((prev) =>
// // //         prev.map((it) =>
// // //           it.product_id === productId && it.variant_id === variant_id
// // //             ? { ...it, quantity: newQty }
// // //             : it,
// // //         ),
// // //       );
// // //     } catch {}
// // //   };
// // //   const handleIncrease = (e, item) => {
// // //     e.preventDefault();
// // //     handleQuantityChange(
// // //       item.product_id,
// // //       item.variant_id,
// // //       item.quantity,
// // //       item.name,
// // //       "increase",
// // //     );
// // //   };
// // //   const handleDecrease = (e, item) => {
// // //     e.preventDefault();
// // //     if (item.quantity > 1)
// // //       handleQuantityChange(
// // //         item.product_id,
// // //         item.variant_id,
// // //         item.quantity,
// // //         item.name,
// // //         "decrease",
// // //       );
// // //   };

// // //   const handleIncreaseForTrendingProduct = async (e, variant, item) => {
// // //     e.preventDefault();
// // //     const qty = getCartQuantity(variant.variant_id);
// // //     const res = await fetch(`${api_url}/cart`, {
// // //       method: "PATCH",
// // //       headers: {
// // //         "Content-Type": "application/json",
// // //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //       },
// // //       body: JSON.stringify({
// // //         product_id: variant.product_id,
// // //         quantity: qty + 1,
// // //         variant_id: variant.variant_id,
// // //       }),
// // //     });
// // //     const d = await res.json();
// // //     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
// // //       toast.error(`${item.name} is out of stock`);
// // //       return;
// // //     }
// // //     const n = itemsInCartInCart.map((it) =>
// // //       it.variant_id === variant.variant_id
// // //         ? { ...it, quantity: it.quantity + 1 }
// // //         : it,
// // //     );
// // //     setCartItemsInCart(n);
// // //     setCartItems(n);
// // //   };
// // //   const handleDecreaseForTrendingProduct = async (e, variant) => {
// // //     e.preventDefault();
// // //     const qty = getCartQuantity(variant.variant_id);
// // //     if (qty === 1) {
// // //       handleRemoveFromCart(variant.product_id, variant.variant_id);
// // //       return;
// // //     }
// // //     const res = await fetch(`${api_url}/cart`, {
// // //       method: "PATCH",
// // //       headers: {
// // //         "Content-Type": "application/json",
// // //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //       },
// // //       body: JSON.stringify({
// // //         product_id: variant.product_id,
// // //         quantity: qty - 1,
// // //         variant_id: variant.variant_id,
// // //       }),
// // //     });
// // //     const d = await res.json();
// // //     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
// // //       toast.error("Something went wrong");
// // //       return;
// // //     }
// // //     const n = itemsInCartInCart.map((it) =>
// // //       it.variant_id === variant.variant_id
// // //         ? { ...it, quantity: it.quantity - 1 }
// // //         : it,
// // //     );
// // //     setCartItemsInCart(n);
// // //     setCartItems(n);
// // //   };

// // //   const handleDeleteClick = (productId, variantId, data) => {
// // //     setSelectedProduct({ productId, variantId });
// // //     setDeleteData(data);
// // //     setShowModal(true);
// // //   };
// // //   const confirmDelete = async () => {
// // //     if (selectedProduct) {
// // //       try {
// // //         await handleRemoveFromCart(
// // //           selectedProduct.productId,
// // //           selectedProduct.variantId,
// // //         );
// // //       } catch {
// // //       } finally {
// // //         setCartItemsInCart((p) =>
// // //           p.filter(
// // //             (it) =>
// // //               !(
// // //                 it.product_id === selectedProduct.productId &&
// // //                 it.variant_id === selectedProduct.variantId
// // //               ),
// // //           ),
// // //         );
// // //         setCartItems((p) =>
// // //           p.filter(
// // //             (it) =>
// // //               !(
// // //                 it.product_id === selectedProduct.productId &&
// // //                 it.variant_id === selectedProduct.variantId
// // //               ),
// // //           ),
// // //         );
// // //         setSelectedProduct(null);
// // //         setShowModal(false);
// // //       }
// // //     } else setShowModal(false);
// // //   };
// // //   const handleClearCart = async () => {
// // //     try {
// // //       const res = await axios.delete(`${api_url}/carts`, {
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //       });
// // //       if (res.status === 200) {
// // //         setCartItemsInCart([]);
// // //         setCartItems([]);
// // //         setCartCount(0);
// // //         setShowConfirm(false);
// // //         toast.success("Cart cleared successfully");
// // //       }
// // //     } catch {
// // //       toast.error("Failed to clear cart");
// // //     }
// // //   };
// // //   const handleclickforfeaturedproduct = (product_id, product) =>
// // //     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
// // //       state: { product_id },
// // //     });

// // //   /* ── address edit ── */
// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     let s = value;
// // //     if (name === "address_title") s = value.replace(/[^A-Za-z\s]/g, "");
// // //     else if (name === "address_line_1" || name === "address_line_2")
// // //       s = value.replace(/[^A-Za-z0-9\s,./\-#]/g, "");
// // //     else if (name === "pincode") s = value.replace(/\D/g, "").slice(0, 6);
// // //     else if (name === "mobile_number")
// // //       s = value.replace(/\D/g, "").slice(0, 10);
// // //     setSelectedAddress((prev) => ({ ...(prev || {}), [name]: s }));
// // //   };
// // //   const isEditFormValid = React.useMemo(() => {
// // //     if (!selectedAddress) return false;
// // //     const t = selectedAddress.address_title?.trim() || "";
// // //     const l1 = selectedAddress.address_line_1?.trim() || "";
// // //     const l2 = selectedAddress.address_line_2?.trim() || "";
// // //     const pin = (selectedAddress.pincode || "").toString();
// // //     const mob = (selectedAddress.mobile_number || "").toString();
// // //     const st = selectedAddress.state || "";
// // //     return (
// // //       nameRegex.test(t) &&
// // //       l1.length > 0 &&
// // //       addressLineRegex.test(l1) &&
// // //       (l2 === "" || addressLineRegex.test(l2)) &&
// // //       pincodeRegex.test(pin) &&
// // //       mobileRegex.test(mob) &&
// // //       st !== ""
// // //     );
// // //   }, [selectedAddress]);
// // //   const updateAddress = async (addressId, addr) => {
// // //     try {
// // //       await axios.patch(
// // //         `${api_url}/address/${addressId}`,
// // //         {
// // //           address_title: addr.address_title,
// // //           address_line_1: addr.address_line_1,
// // //           address_line_2: addr.address_line_2,
// // //           pincode: addr.pincode,
// // //           city: addr.city,
// // //           state: addr.state,
// // //           mobile_number: addr.mobile_number,
// // //           is_default: addr.is_default,
// // //         },
// // //         {
// // //           headers: {
// // //             "Content-Type": "application/json",
// // //             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //           },
// // //         },
// // //       );
// // //       await fetchAddresses();
// // //       toast.success("Address updated successfully!");
// // //       setIsEditPopupOpen(false);
// // //     } catch {
// // //       toast.error("Failed to update address.");
// // //     }
// // //   };
// // //   const handleUpdateAddress = () => {
// // //     if (!selectedAddress) return;
// // //     const errors = {
// // //       address_title: !selectedAddress.address_title?.trim()
// // //         ? "Required"
// // //         : !nameRegex.test(selectedAddress.address_title.trim())
// // //           ? "Letters only"
// // //           : "",
// // //       address_line_1: !selectedAddress.address_line_1?.trim() ? "Required" : "",
// // //       address_line_2: "",
// // //       pincode: !pincodeRegex.test((selectedAddress.pincode || "").toString())
// // //         ? "6-digit pincode"
// // //         : "",
// // //       state: !selectedAddress.state ? "Required" : "",
// // //       mobile_number: !mobileRegex.test(
// // //         (selectedAddress.mobile_number || "").toString(),
// // //       )
// // //         ? "10-digit number"
// // //         : "",
// // //     };
// // //     setAddressErrors(errors);
// // //     if (Object.values(errors).some((m) => m)) {
// // //       toast.error("Please fix the highlighted fields");
// // //       return;
// // //     }
// // //     updateAddress(selectedAddress.address_id, selectedAddress);
// // //   };

// // //   /* ── payment ── */
// // //   const getOutOfStockProductName = (msg) => {
// // //     const m = msg?.match(/Product (.*?) is out of stock/);
// // //     if (!m) return null;
// // //     return itemsInCartInCart.find((p) => p.id === m[1])?.name || null;
// // //   };
// // //   const onPayment = async () => {
// // //     setIsProcessing(true);

// // //     // Validation checks
// // //     if (itemsInCartInCart.length === 0) {
// // //       toast.error("Cart is empty.");
// // //       setIsProcessing(false);
// // //       return;
// // //     }

// // //     if (selectedDeliveryOption === "home" && !selectedAddressId) {
// // //       setIsProcessing(false);
// // //       setShowAddressPrompt(true);
// // //       return;
// // //     }

// // //     if (selectedDeliveryOption === "pickup" && !selectedBranchId) {
// // //       setIsProcessing(false);
// // //       setShowBranchPrompt(true);
// // //       return;
// // //     }

// // //     if (paymentMode === "COD") {
// // //       setIsProcessing(false);
// // //       setIsCODConfirmPopUp(true);
// // //       return;
// // //     }
// // //     const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
// // //     if (!ok) {
// // //       setIsProcessing(false);
// // //       return;
// // //     }
// // //     try {
// // //       const uRes = await axios.get(`${api_url}/user`, {
// // //         headers: {
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //       });
// // //       const uData = uRes.data.data;
// // //       if (!uData?.name?.trim()) {
// // //         toast.error("Please complete your profile before payment.");
// // //         setTimeout(() => navigate("/profilepage"), 1500);
// // //         return;
// // //       }

// // //       const options = {
// // //         products: itemsInCartInCart,
// // //         amount: itemsInCartInCart.reduce(
// // //           (acc, it) => acc + it.discounted_price * it.quantity,
// // //           0,
// // //         ),
// // //         bill,
// // //         address_id:
// // //           selectedDeliveryOption === "home" ? selectedAddressId : null,
// // //         branch_id:
// // //           selectedDeliveryOption === "pickup" ? selectedBranchId : null,
// // //         payment_status: "PENDING",
// // //         payment_type: "ONLINE",
// // //         delivery_type:
// // //           selectedDeliveryOption === "home" ? "Home_Pickup" : "Store_Pickup",
// // //       };
// // //       const res = await fetch(`${api_url}/api/create-order`, {
// // //         method: "POST",
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //         body: JSON.stringify(options),
// // //       });
// // //       const orderData = await res.json();
// // //       if (!res.ok || !orderData?.razorpayOrder?.id) {
// // //         const pn = getOutOfStockProductName(orderData?.message);
// // //         toast.error(
// // //           pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
// // //         );
// // //         setIsProcessing(false);
// // //         return;
// // //       }
// // //       const payObj = new window.Razorpay({
// // //         key: razorpayKey,
// // //         order_id: orderData.razorpayOrder.id,
// // //         ...orderData,
// // //         handler: async (resp) => {
// // //           setCartItemsInCart([]);
// // //           setCartItems([]);
// // //           setCartCount(0);
// // //           navigate("/ThankYou");
// // //           try {
// // //             await fetch(`${api_url}/api/verify-order`, {
// // //               method: "POST",
// // //               headers: {
// // //                 "Content-Type": "application/json",
// // //                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //               },
// // //               body: JSON.stringify({
// // //                 order_id: resp.razorpay_order_id,
// // //                 payment_id: resp.razorpay_payment_id,
// // //                 signature: resp.razorpay_signature,
// // //                 orderId: orderData?.data?.order_id,
// // //               }),
// // //             });
// // //           } catch {}
// // //         },
// // //         modal: {
// // //           ondismiss: async () => {
// // //             try {
// // //               await axios.post(
// // //                 `${api_url}/api/failed-payment`,
// // //                 {
// // //                   order_id: orderData?.data?.order_id,
// // //                   razorpay_payment_id: `DISMISSED_${orderData?.data?.order_id}`,
// // //                   error_source: "popup_closed",
// // //                   error_description: "User dismissed",
// // //                   error_step: "payment_initiation",
// // //                   error_code: "USER_DISMISS",
// // //                   error_reason: "User cancelled",
// // //                 },
// // //                 {
// // //                   headers: {
// // //                     "Content-Type": "application/json",
// // //                     Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //                   },
// // //                 },
// // //               );
// // //             } catch {}
// // //             toast.error("Payment cancelled");
// // //             setIsProcessing(false);
// // //           },
// // //         },
// // //       });
// // //       payObj.on("payment.failed", async (resp) => {
// // //         try {
// // //           await axios.post(
// // //             `${api_url}/api/failed-payment`,
// // //             {
// // //               order_id: resp.error.metadata.order_id,
// // //               razorpay_payment_id: resp.error.metadata.payment_id,
// // //               error_source: resp.error.source,
// // //               error_description: resp.error.description,
// // //               error_step: resp.error.step,
// // //               error_code: resp.error.code,
// // //               error_reason: resp.error.reason,
// // //             },
// // //             {
// // //               headers: {
// // //                 "Content-Type": "application/json",
// // //                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //               },
// // //             },
// // //           );
// // //         } catch {}
// // //         toast.error("Payment Failed");
// // //         setIsProcessing(false);
// // //       });
// // //       payObj.open();
// // //     } catch {
// // //       toast.error("An error occurred. Please try again.");
// // //       setIsProcessing(false);
// // //     }
// // //   };
// // //   const handleCODOrder = async () => {
// // //     try {
// // //       setIsCODProcessing(true);
// // //       const orderPayload = {
// // //         products: itemsInCartInCart,
// // //         amount: itemsInCartInCart.reduce(
// // //           (acc, it) => acc + it.discounted_price * it.quantity,
// // //           0,
// // //         ),
// // //         bill,
// // //         address_id:
// // //           selectedDeliveryOption === "home" ? selectedAddressId : null,
// // //         branch_id:
// // //           selectedDeliveryOption === "pickup" ? selectedBranchId : null,
// // //         payment_status: "PENDING",
// // //         payment_type: "COD",
// // //         delivery_type:
// // //           selectedDeliveryOption === "home" ? "Home_Pickup" : "Store_Pickup",
// // //       };

// // //       console.log("COD Order Payload:", orderPayload);

// // //       const res = await fetch(`${api_url}/api/create-order`, {
// // //         method: "POST",
// // //         headers: {
// // //           "Content-Type": "application/json",
// // //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// // //         },
// // //         body: JSON.stringify(orderPayload),
// // //       });
// // //       const orderData = await res.json();
// // //       if (!res.ok) {
// // //         const pn = getOutOfStockProductName(orderData?.message);
// // //         toast.error(
// // //           pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
// // //         );
// // //         return;
// // //       }
// // //       toast.success("Order placed with COD!");
// // //       setCartItemsInCart([]);
// // //       setCartItems([]);
// // //       setCartCount([]);
// // //       setIsCODConfirmPopUp(false);
// // //       navigate("/ThankYou");
// // //     } catch {
// // //       toast.error("Failed to place COD order");
// // //     } finally {
// // //       setIsCODProcessing(false);
// // //       setIsProcessing(false);
// // //     }
// // //   };

// // //   /* ── selected address label for dropdown ── */
// // //   const selectedAddrObj = addresses.find(
// // //     (a) => a.address_id === selectedAddressId,
// // //   );
// // //   const selectedBranchObj = branches.find(
// // //     (b) => b.branch_id === selectedBranchId,
// // //   );

// // //   /* ═══════════════════ RENDER ═══════════════════ */
// // //   return (
// // //     <div className="min-h-screen bg-[#f8fafa] font-poppins sm:mt-0 mt-36">
// // //       <Helmet>
// // //         <title>Shopping Cart | MediSYS Pharmacy</title>
// // //         <meta name="robots" content="index, follow" />
// // //       </Helmet>

// // //       <div className="mx-auto px-4 sm:px-6 py-6  ">
// // //         {/* Breadcrumb */}
// // //         <nav className="flex items-center gap-2 text-[12px] text-[#8faba9] mb-4 font-medium flex-wrap">
// // //           <Link to="/home" className="hover:text-[#1e4a46] transition-colors">
// // //             Home
// // //           </Link>
// // //           <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
// // //             <path
// // //               d="M6 12l4-4-4-4"
// // //               stroke="#8faba9"
// // //               strokeWidth="1.8"
// // //               strokeLinecap="round"
// // //               strokeLinejoin="round"
// // //             />
// // //           </svg>
// // //           <span className="text-[#1e4a46] font-bold">My Cart</span>
// // //         </nav>

// // //         <div className="flex items-center justify-between mb-5">
// // //           <div>
// // //             <h1
// // //               className="text-[22px] font-black text-[#0a1715] mb-0.5"
// // //               style={{ fontFamily: "'Nunito',sans-serif" }}
// // //             >
// // //               My Cart
// // //             </h1>
// // //             <p className="text-[13px] text-[#8faba9] font-medium">
// // //               Review your items before checkout
// // //             </p>
// // //           </div>
// // //         </div>

// // //         {loading ? (
// // //           <div className="flex flex-col items-center justify-center py-24 gap-4">
// // //             <img
// // //               src={loader}
// // //               alt="Loading"
// // //               className="w-14 h-14 animate-pulse"
// // //             />
// // //             <p className="text-[13px] text-[#8faba9] font-medium">
// // //               Loading cart…
// // //             </p>
// // //           </div>
// // //         ) : itemsInCartInCart.length > 0 ? (
// // //           <>
// // //             {/* ══════════ MAIN 70/30 GRID ══════════ */}
// // //             <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] xl:grid-cols-[1fr_400px] gap-5 items-start">
// // //               {/* ══ LEFT 70% ══ */}
// // //               <div className="flex flex-col gap-4">
// // //                 {/* ── ROW 1: Delivery + Payment (side by side) ── */}
// // //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
// // //                   {/* Delivery Option Card */}
// // //                   <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// // //                     <SCardHead
// // //                       title="Delivery Option"
// // //                       icon={
// // //                         <svg
// // //                           width="13"
// // //                           height="13"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="#5fbdb3"
// // //                           strokeWidth="2"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <path d="M1 3h15v13H1z" />
// // //                           <path d="M16 8h4l3 3v5h-7V8z" />
// // //                           <circle cx="5.5" cy="18.5" r="2.5" />
// // //                           <circle cx="18.5" cy="18.5" r="2.5" />
// // //                         </svg>
// // //                       }
// // //                     />
// // //                     <div className="p-4 flex flex-col gap-3">
// // //                       {/* Toggle buttons */}
// // //                       <div className="flex gap-2 p-1 bg-[#f4fbfa] rounded-xl border border-[#e2eaea]">
// // //                         {[
// // //                           {
// // //                             val: "home",
// // //                             label: "Home Delivery",
// // //                             icon: (
// // //                               <svg
// // //                                 width="12"
// // //                                 height="12"
// // //                                 viewBox="0 0 24 24"
// // //                                 fill="none"
// // //                                 stroke="currentColor"
// // //                                 strokeWidth="2.5"
// // //                                 strokeLinecap="round"
// // //                                 strokeLinejoin="round"
// // //                               >
// // //                                 <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
// // //                                 <polyline points="9 22 9 12 15 12 15 22" />
// // //                               </svg>
// // //                             ),
// // //                           },
// // //                           {
// // //                             val: "pickup",
// // //                             label: "Store Pickup",
// // //                             icon: (
// // //                               <svg
// // //                                 width="12"
// // //                                 height="12"
// // //                                 viewBox="0 0 24 24"
// // //                                 fill="none"
// // //                                 stroke="currentColor"
// // //                                 strokeWidth="2.5"
// // //                                 strokeLinecap="round"
// // //                                 strokeLinejoin="round"
// // //                               >
// // //                                 <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
// // //                                 <circle cx="12" cy="10" r="3" />
// // //                               </svg>
// // //                             ),
// // //                           },
// // //                         ].map((opt) => (
// // //                           <button
// // //                             key={opt.val}
// // //                             onClick={() => setSelectedDeliveryOption(opt.val)}
// // //                             className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-[10px] text-[12px] font-bold transition-all duration-200 border-none cursor-pointer
// // //                               ${
// // //                                 selectedDeliveryOption === opt.val
// // //                                   ? "bg-[#1e4a46] text-white shadow-[0_2px_8px_rgba(22,44,42,0.3)]"
// // //                                   : "bg-transparent text-[#8faba9] hover:text-[#1e4a46]"
// // //                               }`}
// // //                           >
// // //                             {opt.icon}
// // //                             {opt.label}
// // //                           </button>
// // //                         ))}
// // //                       </div>

// // //                       {/* Address / Branch Dropdown */}
// // //                       {selectedDeliveryOption === "home" ? (
// // //                         addresses.length > 0 ? (
// // //                           <div className="flex flex-col gap-2">
// // //                             <label className="text-[11px] font-bold text-[#374747] uppercase tracking-wide">
// // //                               Deliver to
// // //                             </label>
// // //                             <div className="relative">
// // //                               <select
// // //                                 value={selectedAddressId || ""}
// // //                                 onChange={(e) => {
// // //                                   const id = e.target.value;
// // //                                   setSelectedAddressId(id);
// // //                                   setSelectedAddress(
// // //                                     addresses.find(
// // //                                       (a) => a.address_id === id,
// // //                                     ) || null,
// // //                                   );
// // //                                 }}
// // //                                 className="w-full appearance-none bg-[#f4fbfa] border-[1.5px] border-[#d4ecea] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer"
// // //                               >
// // //                                 {addresses.map((addr) => (
// // //                                   <option
// // //                                     key={addr.address_id}
// // //                                     value={addr.address_id}
// // //                                   >
// // //                                     {addr.address_title} — {addr.address_line_1}
// // //                                     , {addr.city}
// // //                                   </option>
// // //                                 ))}
// // //                               </select>
// // //                               <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
// // //                                 <svg
// // //                                   width="12"
// // //                                   height="12"
// // //                                   viewBox="0 0 24 24"
// // //                                   fill="none"
// // //                                   stroke="#5fbdb3"
// // //                                   strokeWidth="2.5"
// // //                                   strokeLinecap="round"
// // //                                   strokeLinejoin="round"
// // //                                 >
// // //                                   <path d="M6 9l6 6 6-6" />
// // //                                 </svg>
// // //                               </div>
// // //                             </div>

// // //                             {/* Selected address detail */}
// // //                             {selectedAddrObj && (
// // //                               <div className="bg-[#f4fbfa] border border-[#d4ecea] rounded-[12px] px-3 py-2.5 flex items-start gap-2">
// // //                                 <MapPin
// // //                                   size={13}
// // //                                   className="text-[#5fbdb3] mt-0.5 flex-shrink-0"
// // //                                 />
// // //                                 <div className="flex-1 min-w-0">
// // //                                   <p className="text-[11px] text-[#374747] leading-relaxed">
// // //                                     {selectedAddrObj.address_line_1}
// // //                                     {selectedAddrObj.address_line_2
// // //                                       ? `, ${selectedAddrObj.address_line_2}`
// // //                                       : ""}
// // //                                     , {selectedAddrObj.city},{" "}
// // //                                     {selectedAddrObj.pincode},{" "}
// // //                                     {selectedAddrObj.state}
// // //                                   </p>
// // //                                   <p className="text-[10px] text-[#8faba9] mt-0.5">
// // //                                     📞 {selectedAddrObj.mobile_number}
// // //                                   </p>
// // //                                 </div>
// // //                                 <button
// // //                                   className="w-6 h-6 rounded-[7px] border border-[#d4ecea] bg-white flex items-center justify-center flex-shrink-0 hover:border-[#5fbdb3] transition-colors"
// // //                                   onClick={() => {
// // //                                     setSelectedAddress({
// // //                                       ...selectedAddrObj,
// // //                                       is_default:
// // //                                         selectedAddrObj.is_default === true ||
// // //                                         selectedAddrObj.is_default === "true",
// // //                                     });
// // //                                     setIsEditPopupOpen(true);
// // //                                   }}
// // //                                 >
// // //                                   <svg
// // //                                     width="10"
// // //                                     height="10"
// // //                                     viewBox="0 0 24 24"
// // //                                     fill="none"
// // //                                     stroke="#8faba9"
// // //                                     strokeWidth="2"
// // //                                     strokeLinecap="round"
// // //                                     strokeLinejoin="round"
// // //                                   >
// // //                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
// // //                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
// // //                                   </svg>
// // //                                 </button>
// // //                               </div>
// // //                             )}
// // //                           </div>
// // //                         ) : (
// // //                           <div className="flex flex-col gap-2 items-center py-2">
// // //                             <p className="text-[12px] text-[#8faba9] text-center">
// // //                               No addresses saved yet.
// // //                             </p>
// // //                             <button
// // //                               onClick={() => setPopupOpen(true)}
// // //                               className="flex items-center gap-1.5 text-[12px] font-semibold text-white bg-[#1e4a46] hover:bg-[#ff601e] px-4 py-2 rounded-xl transition-colors"
// // //                             >
// // //                               <svg
// // //                                 width="13"
// // //                                 height="13"
// // //                                 viewBox="0 0 24 24"
// // //                                 fill="none"
// // //                                 stroke="currentColor"
// // //                                 strokeWidth="2"
// // //                                 strokeLinecap="round"
// // //                                 strokeLinejoin="round"
// // //                               >
// // //                                 <circle cx="12" cy="12" r="10" />
// // //                                 <line x1="12" y1="8" x2="12" y2="16" />
// // //                                 <line x1="8" y1="12" x2="16" y2="12" />
// // //                               </svg>
// // //                               Add Address
// // //                             </button>
// // //                           </div>
// // //                         )
// // //                       ) : (
// // //                         // Store Pickup - Now inside the card
// // //                         <div className="flex flex-col gap-2">
// // //                           {branches.length > 0 ? (
// // //                             <>
// // //                               <label className="text-[11px] font-bold text-[#374747] uppercase tracking-wide">
// // //                                 Select Branch *
// // //                               </label>
// // //                               <div className="relative">
// // //                                 <select
// // //                                   value={selectedBranchId || ""}
// // //                                   onChange={(e) => {
// // //                                     const branchId = e.target.value;
// // //                                     setSelectedBranchId(branchId);
// // //                                     console.log(
// // //                                       "Selected Branch ID:",
// // //                                       branchId,
// // //                                     );
// // //                                   }}
// // //                                   className="w-full appearance-none bg-[#f4fbfa] border-[1.5px] border-[#d4ecea] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer"
// // //                                 >
// // //                                   <option value="">Choose a branch…</option>
// // //                                   {branches.map((b) => (
// // //                                     <option
// // //                                       key={b.branch_id}
// // //                                       value={b.branch_id}
// // //                                     >
// // //                                       {b.area} — {b.branch_address}
// // //                                     </option>
// // //                                   ))}
// // //                                 </select>
// // //                                 <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
// // //                                   <svg
// // //                                     width="12"
// // //                                     height="12"
// // //                                     viewBox="0 0 24 24"
// // //                                     fill="none"
// // //                                     stroke="#5fbdb3"
// // //                                     strokeWidth="2.5"
// // //                                     strokeLinecap="round"
// // //                                     strokeLinejoin="round"
// // //                                   >
// // //                                     <path d="M6 9l6 6 6-6" />
// // //                                   </svg>
// // //                                 </div>
// // //                               </div>
// // //                               {selectedBranchObj && (
// // //                                 <div className="bg-[#f4fbfa] border border-[#d4ecea] rounded-[12px] px-3 py-2 flex items-center gap-2">
// // //                                   <MapPin
// // //                                     size={12}
// // //                                     className="text-[#5fbdb3] flex-shrink-0"
// // //                                   />
// // //                                   <p className="text-[11px] text-[#374747]">
// // //                                     {selectedBranchObj.area} -{" "}
// // //                                     {selectedBranchObj.branch_address},{" "}
// // //                                     {selectedBranchObj.pincode}
// // //                                   </p>
// // //                                 </div>
// // //                               )}
// // //                             </>
// // //                           ) : (
// // //                             <p className="text-[12px] text-[#8faba9] text-center py-2">
// // //                               No branches available.
// // //                             </p>
// // //                           )}
// // //                         </div>
// // //                       )}

// // //                       {selectedDeliveryOption === "home" &&
// // //                         addresses.length > 0 && (
// // //                           <button
// // //                             onClick={() => setPopupOpen(true)}
// // //                             className="flex items-center gap-1.5 text-[12px] font-semibold text-[#5fbdb3] hover:text-[#1e4a46] transition-colors"
// // //                           >
// // //                             <svg
// // //                               width="13"
// // //                               height="13"
// // //                               viewBox="0 0 24 24"
// // //                               fill="none"
// // //                               stroke="currentColor"
// // //                               strokeWidth="2"
// // //                               strokeLinecap="round"
// // //                               strokeLinejoin="round"
// // //                             >
// // //                               <circle cx="12" cy="12" r="10" />
// // //                               <line x1="12" y1="8" x2="12" y2="16" />
// // //                               <line x1="8" y1="12" x2="16" y2="12" />
// // //                             </svg>
// // //                             Add New Address
// // //                           </button>
// // //                         )}
// // //                     </div>
// // //                   </div>

// // //                   {/* Payment Mode Card */}
// // //                   <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// // //                     <SCardHead
// // //                       title="Payment Mode"
// // //                       icon={
// // //                         <svg
// // //                           width="13"
// // //                           height="13"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="#5fbdb3"
// // //                           strokeWidth="2"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <rect x="1" y="4" width="22" height="16" rx="2" />
// // //                           <line x1="1" y1="10" x2="23" y2="10" />
// // //                         </svg>
// // //                       }
// // //                     />
// // //                     <div className="p-4 flex flex-col gap-2.5">
// // //                       {[
// // //                         {
// // //                           val: "ONLINE",
// // //                           label: "Online Payment",
// // //                           sub: "UPI · Net Banking · Cards",
// // //                           icon: "💳",
// // //                         },
// // //                         {
// // //                           val: "COD",
// // //                           label: "Cash on Delivery",
// // //                           sub: "Pay when your order arrives",
// // //                           icon: "💵",
// // //                         },
// // //                       ].map((opt) => (
// // //                         <div
// // //                           key={opt.val}
// // //                           onClick={() => setPaymentMode(opt.val)}
// // //                           className={`flex items-center gap-3 p-3 rounded-xl border-[1.5px] cursor-pointer transition-all duration-200
// // //                             ${
// // //                               paymentMode === opt.val
// // //                                 ? "border-[#5fbdb3] bg-[#f4fbfa] shadow-[0_2px_8px_rgba(95,189,179,0.15)]"
// // //                                 : "border-[#e2eaea] hover:border-[#5fbdb3]/50 hover:bg-[#f8fafa]"
// // //                             }`}
// // //                         >
// // //                           <div
// // //                             className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg flex-shrink-0 transition-all
// // //                             ${paymentMode === opt.val ? "bg-[#eaf4f3] border border-[#d4ecea]" : "bg-[#f1f5f5]"}`}
// // //                           >
// // //                             {opt.icon}
// // //                           </div>
// // //                           <div className="flex-1">
// // //                             <p className="text-[13px] font-bold text-[#1e4a46]">
// // //                               {opt.label}
// // //                             </p>
// // //                             <p className="text-[11px] text-[#8faba9] mt-0.5">
// // //                               {opt.sub}
// // //                             </p>
// // //                           </div>
// // //                           <RadioDot active={paymentMode === opt.val} />
// // //                         </div>
// // //                       ))}

// // //                       {/* Security note */}
// // //                       <div className="flex items-center gap-2 mt-1 bg-[#f4fbfa] rounded-xl px-3 py-2 border border-[#e2eaea]">
// // //                         <svg
// // //                           width="12"
// // //                           height="12"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="#5fbdb3"
// // //                           strokeWidth="2"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
// // //                         </svg>
// // //                         <p className="text-[10px] text-[#8faba9]">
// // //                           All transactions are 100% secure & encrypted
// // //                         </p>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </div>

// // //                 {/* ── ROW 2: Cart Items ── */}
// // //                 <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// // //                   <SCardHead
// // //                     title="Cart Items"
// // //                     badge={`${itemsInCartInCart.length} item${itemsInCartInCart.length !== 1 ? "s" : ""}`}
// // //                     icon={
// // //                       <svg
// // //                         width="13"
// // //                         height="13"
// // //                         viewBox="0 0 24 24"
// // //                         fill="none"
// // //                         stroke="#5fbdb3"
// // //                         strokeWidth="2"
// // //                         strokeLinecap="round"
// // //                         strokeLinejoin="round"
// // //                       >
// // //                         <circle cx="9" cy="21" r="1" />
// // //                         <circle cx="20" cy="21" r="1" />
// // //                         <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
// // //                       </svg>
// // //                     }
// // //                   />
// // //                   <div className="p-4">
// // //                     <div className="flex justify-end mb-3">
// // //                       <button
// // //                         onClick={() => setShowConfirm(true)}
// // //                         className="text-[12px] font-semibold text-[#ff601e] border border-[#ffd5c2] rounded-[10px] px-3 py-1.5 hover:bg-[#fff3ee] transition-colors"
// // //                       >
// // //                         Clear Cart
// // //                       </button>
// // //                     </div>
// // //                     <div className="flex flex-col gap-3">
// // //                       {itemsInCartInCart.map((item) => {
// // //                         const hasDiscount =
// // //                           item.discounted_price &&
// // //                           item.discounted_price < item.price;
// // //                         return (
// // //                           <div
// // //                             key={`${item.product_id}-${item.variant_id}`}
// // //                             className="bg-[#f8fafa] rounded-xl border-[1.5px] border-[#e2eaea] hover:border-[#5fbdb3] p-3 flex gap-3 transition-all duration-200 group"
// // //                           >
// // //                             {/* Image */}
// // //                             <div
// // //                               className="w-[76px] h-[76px] min-w-[76px] rounded-[12px] border border-[#e2eaea] bg-white flex items-center justify-center overflow-hidden cursor-pointer"
// // //                               onClick={() =>
// // //                                 handleclickforfeaturedproduct(
// // //                                   item.product_id,
// // //                                   item,
// // //                                 )
// // //                               }
// // //                             >
// // //                               <img
// // //                                 src={item.image}
// // //                                 alt={item.name}
// // //                                 onError={(e) => {
// // //                                   e.target.onerror = null;
// // //                                   e.target.src = "/default.svg";
// // //                                 }}
// // //                                 className="w-12 h-12 object-contain"
// // //                               />
// // //                             </div>

// // //                             {/* Body */}
// // //                             <div className="flex-1 min-w-0 flex flex-col gap-1">
// // //                               <p
// // //                                 className="text-[12px] font-bold text-[#1e4a46] leading-snug cursor-pointer hover:text-[#ff601e] transition-colors line-clamp-2"
// // //                                 onClick={() =>
// // //                                   handleclickforfeaturedproduct(
// // //                                     item.product_id,
// // //                                     item,
// // //                                   )
// // //                                 }
// // //                               >
// // //                                 {item.name}
// // //                               </p>
// // //                               <p className="text-[10px] text-[#8faba9] font-medium">
// // //                                 By {item.manufacturer} · Pack: {item.pack_size}
// // //                               </p>

// // //                               <div className="flex items-center gap-2 flex-wrap">
// // //                                 {hasDiscount && (
// // //                                   <span className="text-[10px] text-[#8faba9] line-through">
// // //                                     ₹{(item.price * item.quantity).toFixed(2)}
// // //                                   </span>
// // //                                 )}
// // //                                 <span
// // //                                   className="text-[14px] font-black text-[#1e4a46]"
// // //                                   style={{ fontFamily: "'Nunito',sans-serif" }}
// // //                                 >
// // //                                   ₹
// // //                                   {(
// // //                                     item.discounted_price * item.quantity
// // //                                   ).toFixed(2)}
// // //                                 </span>
// // //                                 {hasDiscount && (
// // //                                   <span className="text-[9px] font-bold bg-[#eaf4f3] border border-[#d4ecea] text-[#1e4a46] px-1.5 py-0.5 rounded-full">
// // //                                     {item.discount_percent}% OFF
// // //                                   </span>
// // //                                 )}
// // //                               </div>

// // //                               <div className="flex items-center gap-2 mt-1">
// // //                                 <div className="flex items-center bg-white border border-[#d4ecea] rounded-xl h-8 px-1 gap-0.5">
// // //                                   <button
// // //                                     onClick={(e) => handleDecrease(e, item)}
// // //                                     className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#eaf4f3] transition-colors"
// // //                                   >
// // //                                     −
// // //                                   </button>
// // //                                   <span
// // //                                     className="font-black text-[13px] text-[#1e4a46] min-w-[22px] text-center"
// // //                                     style={{
// // //                                       fontFamily: "'Nunito',sans-serif",
// // //                                     }}
// // //                                   >
// // //                                     {quantities[item.variant_id] ||
// // //                                       item.quantity}
// // //                                   </span>
// // //                                   <button
// // //                                     onClick={(e) => handleIncrease(e, item)}
// // //                                     className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#eaf4f3] transition-colors"
// // //                                   >
// // //                                     +
// // //                                   </button>
// // //                                 </div>
// // //                                 <button
// // //                                   className="ml-auto w-8 h-8 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center text-[#8faba9] hover:border-red-300 hover:text-red-500 transition-all"
// // //                                   onClick={() =>
// // //                                     handleDeleteClick(
// // //                                       item.product_id,
// // //                                       item.variant_id,
// // //                                       item,
// // //                                     )
// // //                                   }
// // //                                 >
// // //                                   <TrashIcon />
// // //                                 </button>
// // //                               </div>
// // //                             </div>
// // //                           </div>
// // //                         );
// // //                       })}
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               </div>

// // //               {/* ══ RIGHT 30% — Bill Summary ══ */}
// // //               <div className="flex flex-col gap-4">
// // //                 {/* Bill Summary */}
// // //                 <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)] sticky top-4">
// // //                   <SCardHead
// // //                     title="Bill Summary"
// // //                     icon={
// // //                       <svg
// // //                         width="13"
// // //                         height="13"
// // //                         viewBox="0 0 24 24"
// // //                         fill="none"
// // //                         stroke="#5fbdb3"
// // //                         strokeWidth="2"
// // //                         strokeLinecap="round"
// // //                         strokeLinejoin="round"
// // //                       >
// // //                         <line x1="8" y1="6" x2="21" y2="6" />
// // //                         <line x1="8" y1="12" x2="21" y2="12" />
// // //                         <line x1="8" y1="18" x2="21" y2="18" />
// // //                         <line x1="3" y1="6" x2="3.01" y2="6" />
// // //                         <line x1="3" y1="12" x2="3.01" y2="12" />
// // //                         <line x1="3" y1="18" x2="3.01" y2="18" />
// // //                       </svg>
// // //                     }
// // //                   />
// // //                   <div className="p-4 flex flex-col gap-3">
// // //                     {/* Items summary */}
// // //                     <div className="bg-[#f8fafa] rounded-xl border border-[#f1f5f5] p-3 flex flex-col gap-2 mb-1">
// // //                       {itemsInCartInCart.slice(0, 3).map((item) => (
// // //                         <div
// // //                           key={item.variant_id}
// // //                           className="flex items-center gap-2"
// // //                         >
// // //                           <img
// // //                             src={item.image}
// // //                             alt={item.name}
// // //                             onError={(e) => {
// // //                               e.target.onerror = null;
// // //                               e.target.src = "/default.svg";
// // //                             }}
// // //                             className="w-8 h-8 object-contain rounded-lg border border-[#e2eaea] bg-white flex-shrink-0"
// // //                           />
// // //                           <p className="text-[11px] text-[#374747] line-clamp-1 flex-1">
// // //                             {item.name}
// // //                           </p>
// // //                           <span className="text-[11px] font-bold text-[#1e4a46] flex-shrink-0">
// // //                             ×{quantities[item.variant_id] || item.quantity}
// // //                           </span>
// // //                         </div>
// // //                       ))}
// // //                       {itemsInCartInCart.length > 3 && (
// // //                         <p className="text-[10px] text-[#8faba9] text-center">
// // //                           +{itemsInCartInCart.length - 3} more item
// // //                           {itemsInCartInCart.length - 3 !== 1 ? "s" : ""}
// // //                         </p>
// // //                       )}
// // //                     </div>

// // //                     {[
// // //                       {
// // //                         label: "Total MRP",
// // //                         val: `₹${originalTotal.toFixed(2)}`,
// // //                         color: "text-[#1e4a46]",
// // //                       },
// // //                       {
// // //                         label: "Discount on MRP",
// // //                         val: `− ₹${totalSaved.toFixed(2)}`,
// // //                         color: "text-[#059669]",
// // //                       },
// // //                       {
// // //                         label: "Delivery Charges",
// // //                         val: shipping,
// // //                         color: "text-[#059669]",
// // //                       },
// // //                     ].map((row) => (
// // //                       <div
// // //                         key={row.label}
// // //                         className="flex justify-between items-center"
// // //                       >
// // //                         <span className="text-[13px] text-[#8faba9] font-medium">
// // //                           {row.label}
// // //                         </span>
// // //                         <span
// // //                           className={`text-[13px] font-semibold ${row.color}`}
// // //                         >
// // //                           {row.val}
// // //                         </span>
// // //                       </div>
// // //                     ))}

// // //                     <div className="h-px bg-[#f1f5f5] my-1" />
// // //                     <div className="flex justify-between items-center">
// // //                       <span className="text-[15px] font-bold text-[#0a1715]">
// // //                         Total
// // //                       </span>
// // //                       <span
// // //                         className="text-[18px] font-black text-[#1e4a46]"
// // //                         style={{ fontFamily: "'Nunito',sans-serif" }}
// // //                       >
// // //                         ₹{total.toFixed(2)}
// // //                       </span>
// // //                     </div>

// // //                     <div className="flex justify-between items-center bg-[#eaf4f3] border border-[#d4ecea] rounded-xl px-3.5 py-2.5">
// // //                       <div className="flex items-center gap-1.5">
// // //                         <svg
// // //                           width="13"
// // //                           height="13"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="#1e4a46"
// // //                           strokeWidth="2"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <polyline points="20 6 9 17 4 12" />
// // //                         </svg>
// // //                         <span className="text-[12px] font-bold text-[#1e4a46]">
// // //                           You save
// // //                         </span>
// // //                       </div>
// // //                       <span
// // //                         className="text-[14px] font-black text-[#1e4a46]"
// // //                         style={{ fontFamily: "'Nunito',sans-serif" }}
// // //                       >
// // //                         ₹{totalSaved.toFixed(2)}
// // //                       </span>
// // //                     </div>

// // //                     {/* Delivery summary pill */}
// // //                     <div className="flex items-center gap-2 bg-[#f4fbfa] border border-[#e2eaea] rounded-xl px-3 py-2">
// // //                       <div className="w-6 h-6 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0">
// // //                         {selectedDeliveryOption === "home" ? (
// // //                           <svg
// // //                             width="11"
// // //                             height="11"
// // //                             viewBox="0 0 24 24"
// // //                             fill="none"
// // //                             stroke="#5fbdb3"
// // //                             strokeWidth="2"
// // //                             strokeLinecap="round"
// // //                             strokeLinejoin="round"
// // //                           >
// // //                             <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
// // //                             <polyline points="9 22 9 12 15 12 15 22" />
// // //                           </svg>
// // //                         ) : (
// // //                           <MapPin size={11} className="text-[#5fbdb3]" />
// // //                         )}
// // //                       </div>
// // //                       <p className="text-[11px] text-[#374747] line-clamp-1 flex-1">
// // //                         {selectedDeliveryOption === "home"
// // //                           ? selectedAddrObj
// // //                             ? `${selectedAddrObj.address_title} · ${selectedAddrObj.city}`
// // //                             : "No address selected"
// // //                           : selectedBranchObj
// // //                             ? selectedBranchObj.area
// // //                             : "No branch selected"}
// // //                       </p>
// // //                     </div>

// // //                     <button
// // //                       onClick={onPayment}
// // //                       disabled={isProcessing && !addressError}
// // //                       className="w-full h-12 rounded-2xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[14px] font-bold flex items-center justify-center gap-2 transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.28)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.4)] disabled:opacity-70 disabled:cursor-not-allowed mt-1"
// // //                     >
// // //                       {isProcessing && !addressError && (
// // //                         <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
// // //                       )}
// // //                       <svg
// // //                         width="16"
// // //                         height="16"
// // //                         viewBox="0 0 24 24"
// // //                         fill="none"
// // //                         stroke="currentColor"
// // //                         strokeWidth="2.5"
// // //                         strokeLinecap="round"
// // //                         strokeLinejoin="round"
// // //                       >
// // //                         <path d="M5 12h14M12 5l7 7-7 7" />
// // //                       </svg>
// // //                       Proceed to Checkout
// // //                     </button>

// // //                     <p className="text-[10px] text-[#8faba9] text-center">
// // //                       {paymentMode === "ONLINE"
// // //                         ? "🔒 Secured by Razorpay"
// // //                         : "💵 Pay when your order arrives"}
// // //                     </p>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>

// // //             {/* ══════════ TRENDING PRODUCTS ══════════ */}
// // //             {featuredProducts.length > 0 && (
// // //               <div className="mt-10">
// // //                 {/* Header */}
// // //                 <div className="flex items-center justify-between mb-5">
// // //                   <div>
// // //                     <div className="flex items-center gap-2 mb-1.5">
// // //                       <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
// // //                       <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[#ff601e]">
// // //                         <svg
// // //                           width="11"
// // //                           height="11"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="#ff601e"
// // //                           strokeWidth="2.5"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
// // //                         </svg>
// // //                         You May Also Like
// // //                       </span>
// // //                     </div>
// // //                     <h2
// // //                       className="text-[20px] font-black text-[#1e4a46]"
// // //                       style={{ fontFamily: "'Nunito',sans-serif" }}
// // //                     >
// // //                       Trending Products
// // //                     </h2>
// // //                     <p className="text-[12px] text-[#8faba9] mt-0.5">
// // //                       Handpicked products based on your cart
// // //                     </p>
// // //                   </div>
// // //                   <div className="flex items-center gap-2">
// // //                     <button
// // //                       onClick={() => setCurrentIndex((p) => Math.max(0, p - 1))}
// // //                       disabled={currentIndex === 0}
// // //                       className="w-9 h-9 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#eaf4f3] disabled:opacity-30 transition-all"
// // //                     >
// // //                       <svg
// // //                         width="13"
// // //                         height="13"
// // //                         viewBox="0 0 24 24"
// // //                         fill="none"
// // //                         stroke="#374747"
// // //                         strokeWidth="2.5"
// // //                         strokeLinecap="round"
// // //                         strokeLinejoin="round"
// // //                       >
// // //                         <path d="M19 12H5M12 5l-7 7 7 7" />
// // //                       </svg>
// // //                     </button>
// // //                     <button
// // //                       onClick={() =>
// // //                         setCurrentIndex((p) => Math.min(totalPages - 1, p + 1))
// // //                       }
// // //                       disabled={currentIndex >= totalPages - 1}
// // //                       className="w-9 h-9 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#eaf4f3] disabled:opacity-30 transition-all"
// // //                     >
// // //                       <svg
// // //                         width="13"
// // //                         height="13"
// // //                         viewBox="0 0 24 24"
// // //                         fill="none"
// // //                         stroke="#374747"
// // //                         strokeWidth="2.5"
// // //                         strokeLinecap="round"
// // //                         strokeLinejoin="round"
// // //                       >
// // //                         <path d="M5 12h14M12 5l7 7-7 7" />
// // //                       </svg>
// // //                     </button>
// // //                     <Link to="/featured-products">
// // //                       <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold text-[12px] px-4 h-9 rounded-[10px] transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)] border-none">
// // //                         View All
// // //                         <svg
// // //                           width="11"
// // //                           height="11"
// // //                           viewBox="0 0 24 24"
// // //                           fill="none"
// // //                           stroke="currentColor"
// // //                           strokeWidth="2.5"
// // //                           strokeLinecap="round"
// // //                           strokeLinejoin="round"
// // //                         >
// // //                           <path d="M5 12h14M12 5l7 7-7 7" />
// // //                         </svg>
// // //                       </button>
// // //                     </Link>
// // //                   </div>
// // //                 </div>

// // //                 {/* Desktop grid — 5 cols */}
// // //                 <div className="hidden lg:grid grid-cols-8 gap-4">
// // //                   {currentFeatured.map((item, index) => {
// // //                     const altQty = getCartQuantity(
// // //                       item.variant?.[0]?.variant_id,
// // //                     );
// // //                     const isOrange = index % 2 === 1;
// // //                     const isWish = wishlistItems.some(
// // //                       (w) =>
// // //                         w.product_id === item.product_id &&
// // //                         w.variant_id === item.variant?.[0]?.variant_id,
// // //                     );
// // //                     const isOOS = OutOfQuantityCheck(item.variant || []);

// // //                     return (
// // //                       <div
// // //                         key={item.product_id || index}
// // //                         className={`group border-[1.5px] ${isOrange ? "border-[#ffd5c2] hover:border-[#ff601e]/60" : "border-[#e2eaea] hover:border-[#5fbdb3]"}
// // //                           bg-white rounded-[18px] overflow-hidden flex flex-col cursor-pointer
// // //                           hover:-translate-y-2 hover:shadow-[0_12px_36px_rgba(22,44,42,0.15)]
// // //                           shadow-[0_2px_10px_rgba(22,44,42,0.07)] transition-all duration-300 relative`}
// // //                         style={{
// // //                           animation: `fadeInUp 0.35s ease ${index * 60}ms both`,
// // //                         }}
// // //                       >
// // //                         {/* Top accent line */}
// // //                         <div
// // //                           className={`absolute top-0 left-0 right-0 h-[3px] ${isOrange ? "bg-gradient-to-r from-[#ff601e] to-[#e55519]" : "bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]"} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
// // //                         />

// // //                         {/* Discount badge */}
// // //                         {item.discount_percent > 0 && (
// // //                           <div className="absolute top-3 right-3 bg-[#ff601e] text-white text-[9px] font-bold w-9 h-9 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] z-10 leading-tight text-center">
// // //                             {item.discount_percent}%<br />
// // //                             OFF
// // //                           </div>
// // //                         )}

// // //                         {/* Wishlist */}
// // //                         <button
// // //                           className="absolute top-3 left-3 z-10 w-7 h-7 bg-white rounded-xl border border-[#e2eaea] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#eaf4f3] transition-all duration-200"
// // //                           onClick={(e) => {
// // //                             e.stopPropagation();
// // //                             if (!localStorage.getItem("authToken")) {
// // //                               setShowLoginPopup(true);
// // //                               return;
// // //                             }
// // //                             isWish
// // //                               ? removeFromWishlist(
// // //                                   item.product_id,
// // //                                   item.variant?.[0]?.variant_id,
// // //                                 )
// // //                               : addToWishlist(item, item.variant?.[0]);
// // //                           }}
// // //                         >
// // //                           <img
// // //                             src={isWish ? wish : wishlist}
// // //                             alt="wish"
// // //                             className="w-3.5 h-3.5"
// // //                           />
// // //                         </button>

// // //                         {/* Image */}
// // //                         <div
// // //                           className={`w-full h-[140px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]"} flex items-center justify-center p-4 pt-8`}
// // //                           onClick={() =>
// // //                             handleclickforfeaturedproduct(item.product_id, item)
// // //                           }
// // //                         >
// // //                           <img
// // //                             src={
// // //                               item?.product_images?.image_url?.primary_image ||
// // //                               "/default.svg"
// // //                             }
// // //                             alt={item.name}
// // //                             onError={(e) => {
// // //                               e.target.onerror = null;
// // //                               e.target.src = "/default.svg";
// // //                             }}
// // //                             className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
// // //                           />
// // //                         </div>

// // //                         <div className="w-full h-px bg-[#f1f5f5]" />

// // //                         {/* Info */}
// // //                         <div
// // //                           className="p-3 flex-1 cursor-pointer"
// // //                           onClick={() =>
// // //                             handleclickforfeaturedproduct(item.product_id, item)
// // //                           }
// // //                         >
// // //                           <h3 className="font-semibold text-[12px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors mb-2">
// // //                             {item.name}
// // //                           </h3>
// // //                           <div className="flex items-baseline gap-1.5 flex-wrap">
// // //                             {item.discount_percent > 0 && (
// // //                               <span className="text-[10px] text-[#8faba9] line-through">
// // //                                 ₹{item.variant?.[0]?.price}
// // //                               </span>
// // //                             )}
// // //                             <span
// // //                               className="text-[14px] font-black text-[#1e4a46]"
// // //                               style={{ fontFamily: "'Nunito',sans-serif" }}
// // //                             >
// // //                               ₹
// // //                               {item.variant?.[0]?.discounted_price ||
// // //                                 item.variant?.[0]?.price ||
// // //                                 "N/A"}
// // //                             </span>
// // //                             {item.discount_percent > 0 && (
// // //                               <span
// // //                                 className={`text-[10px] font-semibold ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
// // //                               >
// // //                                 {item.discount_percent}% off
// // //                               </span>
// // //                             )}
// // //                           </div>
// // //                           {isOOS && (
// // //                             <span className="text-[9px] font-bold text-red-500 bg-red-50 border border-red-100 px-1.5 py-0.5 rounded-full mt-1 inline-block">
// // //                               Out of Stock
// // //                             </span>
// // //                           )}
// // //                         </div>

// // //                         {/* Cart action */}
// // //                         <div className="px-3 pb-3">
// // //                           {altQty > 0 ? (
// // //                             <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-9 px-2">
// // //                               <button
// // //                                 onClick={(e) =>
// // //                                   handleDecreaseForTrendingProduct(
// // //                                     e,
// // //                                     item.variant[0],
// // //                                     item,
// // //                                   )
// // //                                 }
// // //                                 className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
// // //                               >
// // //                                 −
// // //                               </button>
// // //                               <span className="font-black text-[13px] text-[#1e4a46]">
// // //                                 {altQty}
// // //                               </span>
// // //                               <button
// // //                                 onClick={(e) =>
// // //                                   handleIncreaseForTrendingProduct(
// // //                                     e,
// // //                                     item.variant[0],
// // //                                     item,
// // //                                   )
// // //                                 }
// // //                                 className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
// // //                               >
// // //                                 +
// // //                               </button>
// // //                             </div>
// // //                           ) : (
// // //                             <button
// // //                               disabled={isOOS}
// // //                               className={`w-full h-9 ${isOrange ? "bg-[#ff601e] hover:bg-[#e55519] shadow-[0_2px_8px_rgba(255,96,30,0.3)]" : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_2px_8px_rgba(22,44,42,0.2)]"} text-white text-[11px] font-bold rounded-[10px] flex items-center justify-center gap-1.5 transition-all duration-200 border-none disabled:bg-[#c5d5d4] disabled:cursor-not-allowed`}
// // //                               onClick={async (e) => {
// // //                                 e.stopPropagation();
// // //                                 if (!localStorage.getItem("authToken")) {
// // //                                   setShowLoginPopup(true);
// // //                                   return;
// // //                                 }
// // //                                 await handleAddToCart(item, item.variant[0], 1);
// // //                                 await fetchCart();
// // //                               }}
// // //                             >
// // //                               <CartIcon />
// // //                               Add to Cart
// // //                             </button>
// // //                           )}
// // //                         </div>
// // //                       </div>
// // //                     );
// // //                   })}
// // //                 </div>

// // //                 {/* Mobile scroll carousel */}
// // //                 <div className="lg:hidden relative">
// // //                   <button
// // //                     onClick={() =>
// // //                       scrollRef.current?.scrollBy({
// // //                         left: -200,
// // //                         behavior: "smooth",
// // //                       })
// // //                     }
// // //                     className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#e2eaea] shadow flex items-center justify-center"
// // //                   >
// // //                     <ChevronLeft size={15} />
// // //                   </button>
// // //                   <div
// // //                     ref={scrollRef}
// // //                     className="flex gap-3 overflow-x-auto scrollbar-hide px-8 py-2 scroll-smooth"
// // //                   >
// // //                     {featuredProducts.map((item, index) => {
// // //                       const altQty = getCartQuantity(
// // //                         item.variant?.[0]?.variant_id,
// // //                       );
// // //                       const isOrange = index % 2 === 1;
// // //                       const isWish = wishlistItems.some(
// // //                         (w) =>
// // //                           w.product_id === item.product_id &&
// // //                           w.variant_id === item.variant?.[0]?.variant_id,
// // //                       );
// // //                       const isOOS = OutOfQuantityCheck(item.variant || []);
// // //                       return (
// // //                         <div
// // //                           key={item.product_id || index}
// // //                           className={`flex-shrink-0 w-[155px] rounded-[18px] border-[1.5px] ${isOrange ? "border-[#ffd5c2] bg-white" : "border-[#e2eaea] bg-white"} overflow-hidden flex flex-col cursor-pointer shadow-[0_2px_10px_rgba(22,44,42,0.07)] relative`}
// // //                         >
// // //                           {item.discount_percent > 0 && (
// // //                             <div className="absolute top-2.5 right-2.5 bg-[#ff601e] text-white text-[8px] font-bold w-8 h-8 rounded-full flex flex-col items-center justify-center z-10 leading-tight text-center">
// // //                               {item.discount_percent}%<br />
// // //                               OFF
// // //                             </div>
// // //                           )}
// // //                           <button
// // //                             className="absolute top-2.5 left-2.5 z-10 w-7 h-7 bg-white rounded-xl border border-[#e2eaea] flex items-center justify-center"
// // //                             onClick={(e) => {
// // //                               e.stopPropagation();
// // //                               if (!localStorage.getItem("authToken")) {
// // //                                 setShowLoginPopup(true);
// // //                                 return;
// // //                               }
// // //                               isWish
// // //                                 ? removeFromWishlist(
// // //                                     item.product_id,
// // //                                     item.variant?.[0]?.variant_id,
// // //                                   )
// // //                                 : addToWishlist(item, item.variant?.[0]);
// // //                             }}
// // //                           >
// // //                             <img
// // //                               src={isWish ? wish : wishlist}
// // //                               alt="wish"
// // //                               className="w-3.5 h-3.5"
// // //                             />
// // //                           </button>
// // //                           <div
// // //                             className={`h-[120px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]"} flex items-center justify-center p-3 pt-8`}
// // //                             onClick={() =>
// // //                               handleclickforfeaturedproduct(
// // //                                 item.product_id,
// // //                                 item,
// // //                               )
// // //                             }
// // //                           >
// // //                             <img
// // //                               src={
// // //                                 item?.product_images?.image_url
// // //                                   ?.primary_image || "/default.svg"
// // //                               }
// // //                               alt={item.name}
// // //                               onError={(e) => {
// // //                                 e.target.onerror = null;
// // //                                 e.target.src = "/default.svg";
// // //                               }}
// // //                               className="max-h-full max-w-full object-contain"
// // //                             />
// // //                           </div>
// // //                           <div className="w-full h-px bg-[#f1f5f5]" />
// // //                           <div
// // //                             className="p-2.5 flex-1"
// // //                             onClick={() =>
// // //                               handleclickforfeaturedproduct(
// // //                                 item.product_id,
// // //                                 item,
// // //                               )
// // //                             }
// // //                           >
// // //                             <p className="text-[11px] font-semibold text-[#1e4a46] line-clamp-2 mb-1">
// // //                               {item.name}
// // //                             </p>
// // //                             <span className="text-[13px] font-black text-[#1e4a46]">
// // //                               ₹{item.variant?.[0]?.discounted_price || "N/A"}
// // //                             </span>
// // //                           </div>
// // //                           <div className="px-2.5 pb-2.5">
// // //                             {altQty > 0 ? (
// // //                               <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-8 px-2">
// // //                                 <button
// // //                                   onClick={(e) =>
// // //                                     handleDecreaseForTrendingProduct(
// // //                                       e,
// // //                                       item.variant[0],
// // //                                       item,
// // //                                     )
// // //                                   }
// // //                                   className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base"
// // //                                 >
// // //                                   −
// // //                                 </button>
// // //                                 <span className="font-black text-[12px] text-[#1e4a46]">
// // //                                   {altQty}
// // //                                 </span>
// // //                                 <button
// // //                                   onClick={(e) =>
// // //                                     handleIncreaseForTrendingProduct(
// // //                                       e,
// // //                                       item.variant[0],
// // //                                       item,
// // //                                     )
// // //                                   }
// // //                                   className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base"
// // //                                 >
// // //                                   +
// // //                                 </button>
// // //                               </div>
// // //                             ) : (
// // //                               <button
// // //                                 disabled={isOOS}
// // //                                 className={`w-full h-8 ${isOrange ? "bg-[#ff601e]" : "bg-[#1e4a46]"} text-white text-[10px] font-bold rounded-[10px] flex items-center justify-center gap-1 border-none disabled:bg-[#c5d5d4]`}
// // //                                 onClick={async (e) => {
// // //                                   e.stopPropagation();
// // //                                   if (!localStorage.getItem("authToken")) {
// // //                                     setShowLoginPopup(true);
// // //                                     return;
// // //                                   }
// // //                                   await handleAddToCart(
// // //                                     item,
// // //                                     item.variant[0],
// // //                                     1,
// // //                                   );
// // //                                   await fetchCart();
// // //                                 }}
// // //                               >
// // //                                 <CartIcon />
// // //                                 Add
// // //                               </button>
// // //                             )}
// // //                           </div>
// // //                         </div>
// // //                       );
// // //                     })}
// // //                   </div>
// // //                   <button
// // //                     onClick={() =>
// // //                       scrollRef.current?.scrollBy({
// // //                         left: 200,
// // //                         behavior: "smooth",
// // //                       })
// // //                     }
// // //                     className="absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#e2eaea] shadow flex items-center justify-center"
// // //                   >
// // //                     <ChevronRight size={15} />
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             )}
// // //           </>
// // //         ) : (
// // //           /* ── Empty cart ── */
// // //           <div className="flex flex-col items-center justify-center py-20 gap-5">
// // //             <div className="w-48 h-48">
// // //               <DotLottieReact
// // //                 src="https://lottie.host/66e677d4-91a1-4f1a-85e7-a7d1faf607b8/dBHVRTKEJU.lottie"
// // //                 loop
// // //                 autoplay
// // //               />
// // //             </div>
// // //             <div className="text-center">
// // //               <p
// // //                 className="font-black text-[22px] text-[#1e4a46] mb-2"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Your cart is empty
// // //               </p>
// // //               <p className="text-[14px] text-[#8faba9] max-w-[280px] mx-auto">
// // //                 Go ahead and add products to start shopping!
// // //               </p>
// // //             </div>
// // //             <Link to="/home">
// // //               <button className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[14px] px-8 h-11 rounded-2xl transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.28)]">
// // //                 <svg
// // //                   width="16"
// // //                   height="16"
// // //                   viewBox="0 0 24 24"
// // //                   fill="none"
// // //                   stroke="currentColor"
// // //                   strokeWidth="2.5"
// // //                   strokeLinecap="round"
// // //                   strokeLinejoin="round"
// // //                 >
// // //                   <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
// // //                   <polyline points="9 22 9 12 15 12 15 22" />
// // //                 </svg>
// // //                 Start Shopping
// // //               </button>
// // //             </Link>
// // //           </div>
// // //         )}
// // //       </div>

// // //       {/* ── Delete modal ── */}
// // //       <DeletePromptForCart
// // //         showModal={showModal}
// // //         onDelete={confirmDelete}
// // //         onCancel={() => setShowModal(false)}
// // //         data={deleteData}
// // //       />

// // //       {/* ── Clear cart confirm ── */}
// // //       {showConfirm && (
// // //         <div
// // //           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
// // //           style={{ zIndex: 99999 }}
// // //         >
// // //           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[320px] shadow-2xl">
// // //             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
// // //             <div className="p-6">
// // //               <h2
// // //                 className="text-[16px] font-bold text-white mb-2"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Clear entire cart?
// // //               </h2>
// // //               <p className="text-[13px] text-[#7abcb8] mb-5">
// // //                 All items will be removed from your cart permanently.
// // //               </p>
// // //               <div className="flex gap-3">
// // //                 <button
// // //                   onClick={() => setShowConfirm(false)}
// // //                   className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all"
// // //                 >
// // //                   Cancel
// // //                 </button>
// // //                 <button
// // //                   onClick={handleClearCart}
// // //                   className="flex-1 py-2.5 rounded-xl bg-red-500 hover:bg-red-600 text-white text-[13px] font-extrabold uppercase tracking-widest transition-all border-none"
// // //                 >
// // //                   Clear
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ── COD confirm ── */}
// // //       {isCODConfirmPopUp && (
// // //         <div
// // //           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
// // //           style={{ zIndex: 99999 }}
// // //         >
// // //           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[340px] shadow-2xl">
// // //             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
// // //             <div className="p-6">
// // //               <h2
// // //                 className="text-[16px] font-bold text-white mb-2"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Confirm COD Order
// // //               </h2>
// // //               <p className="text-[13px] text-[#7abcb8] mb-5">
// // //                 Place this order with{" "}
// // //                 <strong className="text-white">Cash on Delivery</strong>?
// // //               </p>
// // //               <div className="flex gap-3">
// // //                 <button
// // //                   onClick={() => {
// // //                     setIsCODConfirmPopUp(false);
// // //                     setIsProcessing(false);
// // //                   }}
// // //                   disabled={isCODProcessing}
// // //                   className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all disabled:opacity-50"
// // //                 >
// // //                   Cancel
// // //                 </button>
// // //                 <button
// // //                   onClick={handleCODOrder}
// // //                   disabled={isCODProcessing}
// // //                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-extrabold uppercase tracking-widest flex items-center justify-center gap-2 transition-all border-none disabled:opacity-70"
// // //                 >
// // //                   {isCODProcessing && (
// // //                     <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
// // //                   )}
// // //                   Confirm
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ── Address Required Prompt ── */}
// // //       {showAddressPrompt && (
// // //         <div
// // //           className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
// // //           style={{ zIndex: 99999 }}
// // //         >
// // //           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
// // //             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
// // //             <div className="p-6 text-center">
// // //               <div className="w-14 h-14 bg-[#eaf4f3] rounded-full flex items-center justify-center mx-auto mb-4">
// // //                 <MapPin size={24} className="text-[#1e4a46]" />
// // //               </div>
// // //               <h2
// // //                 className="text-[18px] font-bold text-[#1e4a46] mb-2"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Address Required
// // //               </h2>
// // //               <p className="text-[13px] text-[#8faba9] mb-6">
// // //                 Please add a delivery address to proceed with your order.
// // //               </p>
// // //               <div className="flex gap-3">
// // //                 <button
// // //                   onClick={() => setShowAddressPrompt(false)}
// // //                   className="flex-1 py-2.5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all"
// // //                 >
// // //                   Cancel
// // //                 </button>
// // //                 <button
// // //                   onClick={() => {
// // //                     setShowAddressPrompt(false);
// // //                     setPopupOpen(true);
// // //                   }}
// // //                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none"
// // //                 >
// // //                   Add Address
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ── Branch Required Prompt ── */}
// // //       {showBranchPrompt && (
// // //         <div
// // //           className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
// // //           style={{ zIndex: 99999 }}
// // //         >
// // //           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
// // //             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
// // //             <div className="p-6 text-center">
// // //               <div className="w-14 h-14 bg-[#eaf4f3] rounded-full flex items-center justify-center mx-auto mb-4">
// // //                 <svg
// // //                   width="24"
// // //                   height="24"
// // //                   viewBox="0 0 24 24"
// // //                   fill="none"
// // //                   stroke="#1e4a46"
// // //                   strokeWidth="2"
// // //                   strokeLinecap="round"
// // //                   strokeLinejoin="round"
// // //                 >
// // //                   <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
// // //                   <circle cx="12" cy="10" r="3" />
// // //                 </svg>
// // //               </div>
// // //               <h2
// // //                 className="text-[18px] font-bold text-[#1e4a46] mb-2"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Branch Selection Required
// // //               </h2>
// // //               <p className="text-[13px] text-[#8faba9] mb-6">
// // //                 Please select a store pickup location to proceed with your
// // //                 order.
// // //               </p>
// // //               <button
// // //                 onClick={() => setShowBranchPrompt(false)}
// // //                 className="w-full py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none"
// // //               >
// // //                 Got it
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* ── Edit Address modal ── */}
// // //       {isEditPopupOpen && selectedAddress && (
// // //         <div
// // //           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins p-4"
// // //           style={{ zIndex: 99999 }}
// // //         >
// // //           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[540px] overflow-hidden">
// // //             <div className="bg-[#162c2a] flex items-center justify-between px-6 py-4">
// // //               <img src={logo} alt="Logo" className="h-8 object-contain" />
// // //               <button
// // //                 onClick={() => {
// // //                   setIsEditPopupOpen(false);
// // //                   setSelectedAddress(null);
// // //                 }}
// // //                 className="text-white/70 hover:text-white transition-colors"
// // //               >
// // //                 <svg
// // //                   width="16"
// // //                   height="16"
// // //                   viewBox="0 0 24 24"
// // //                   fill="none"
// // //                   stroke="currentColor"
// // //                   strokeWidth="2.5"
// // //                   strokeLinecap="round"
// // //                   strokeLinejoin="round"
// // //                 >
// // //                   <line x1="18" y1="6" x2="6" y2="18" />
// // //                   <line x1="6" y1="6" x2="18" y2="18" />
// // //                 </svg>
// // //               </button>
// // //             </div>
// // //             <div className="p-6 max-h-[80vh] overflow-y-auto">
// // //               <h2
// // //                 className="text-[18px] font-bold text-[#1e4a46] mb-5"
// // //                 style={{ fontFamily: "'Nunito',sans-serif" }}
// // //               >
// // //                 Edit Address
// // //               </h2>
// // //               <div className="flex flex-col gap-4">
// // //                 {[
// // //                   { label: "Name *", name: "address_title", max: 25 },
// // //                   {
// // //                     label: "Address Line 1 *",
// // //                     name: "address_line_1",
// // //                     max: 120,
// // //                   },
// // //                   { label: "Address Line 2", name: "address_line_2", max: 20 },
// // //                   {
// // //                     label: "Pincode *",
// // //                     name: "pincode",
// // //                     max: 6,
// // //                     inputMode: "numeric",
// // //                   },
// // //                   {
// // //                     label: "Mobile Number *",
// // //                     name: "mobile_number",
// // //                     max: 10,
// // //                     inputMode: "numeric",
// // //                   },
// // //                 ].map((f) => (
// // //                   <div key={f.name}>
// // //                     <label className="text-[12px] font-bold text-[#374747] mb-1.5 block">
// // //                       {f.label}
// // //                     </label>
// // //                     <input
// // //                       type="text"
// // //                       name={f.name}
// // //                       value={selectedAddress[f.name] || ""}
// // //                       maxLength={f.max}
// // //                       inputMode={f.inputMode}
// // //                       onChange={handleChange}
// // //                       className="w-full h-10 rounded-xl border border-[#e2eaea] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors"
// // //                     />
// // //                     {addressErrors[f.name] && (
// // //                       <p className="text-[11px] text-red-500 mt-1">
// // //                         {addressErrors[f.name]}
// // //                       </p>
// // //                     )}
// // //                   </div>
// // //                 ))}
// // //                 <div>
// // //                   <label className="text-[12px] font-bold text-[#374747] mb-1.5 block">
// // //                     State *
// // //                   </label>
// // //                   <select
// // //                     name="state"
// // //                     value={selectedAddress.state || ""}
// // //                     onChange={handleChange}
// // //                     className="w-full h-10 rounded-xl border border-[#e2eaea] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors bg-white"
// // //                   >
// // //                     <option value="">Select State</option>
// // //                     {indianStates.map((st) => (
// // //                       <option key={st} value={st}>
// // //                         {st}
// // //                       </option>
// // //                     ))}
// // //                   </select>
// // //                   {addressErrors.state && (
// // //                     <p className="text-[11px] text-red-500 mt-1">
// // //                       {addressErrors.state}
// // //                     </p>
// // //                   )}
// // //                 </div>
// // //                 <div>
// // //                   <label className="text-[12px] font-bold text-[#374747] mb-2 block">
// // //                     Set as default?
// // //                   </label>
// // //                   <div className="flex gap-4">
// // //                     {[
// // //                       { val: true, label: "Yes" },
// // //                       { val: false, label: "No" },
// // //                     ].map((opt) => (
// // //                       <label
// // //                         key={String(opt.val)}
// // //                         className="flex items-center gap-2 cursor-pointer"
// // //                       >
// // //                         <RadioDot
// // //                           active={selectedAddress.is_default === opt.val}
// // //                         />
// // //                         <span
// // //                           className="text-[13px] text-[#374747]"
// // //                           onClick={() =>
// // //                             handleChange({
// // //                               target: { name: "is_default", value: opt.val },
// // //                             })
// // //                           }
// // //                         >
// // //                           {opt.label}
// // //                         </span>
// // //                       </label>
// // //                     ))}
// // //                   </div>
// // //                 </div>
// // //                 <div className="flex gap-3 pt-2">
// // //                   <button
// // //                     onClick={() => {
// // //                       setIsEditPopupOpen(false);
// // //                       setSelectedAddress(null);
// // //                     }}
// // //                     className="flex-1 py-2.5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all"
// // //                   >
// // //                     Cancel
// // //                   </button>
// // //                   <button
// // //                     onClick={handleUpdateAddress}
// // //                     disabled={!isEditFormValid}
// // //                     className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed"
// // //                   >
// // //                     Save Changes
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {isPopupOpen && (
// // //         <Adresspopup
// // //           onClose={() => setPopupOpen(false)}
// // //           fetchAddresses={fetchAddresses}
// // //         />
// // //       )}
// // //       {showLoginPopup && (
// // //         <div
// // //           className="fixed inset-0 z-50"
// // //           onClick={() => setShowLoginPopup(false)}
// // //         />
// // //       )}

// // //       <style>{`
// // //         @keyframes fadeInUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
// // //         .scrollbar-hide::-webkit-scrollbar { display:none; }
// // //         .scrollbar-hide { -ms-overflow-style:none; scrollbar-width:none; }
// // //       `}</style>
// // //     </div>
// // //   );
// // // };

// // // export default Cartpage;
// // import Adresspopup from "./Adresspopup";
// // import { ChevronLeft, ChevronRight, MapPin, Upload, CheckCircle, AlertCircle, X } from "lucide-react";
// // import { Link } from "react-router-dom";
// // import axios from "axios";
// // import logo from "../images/logo.png";
// // import { useNavigate } from "react-router-dom";
// // import React, { useEffect, useRef, useState, useCallback } from "react";
// // import { useCart } from "../Context/Createcontext";
// // import { toast } from "react-hot-toast";
// // import DeletePromptForCart from "../Components/common/DeletePromptForCart";
// // import { Helmet } from "react-helmet";
// // import { api_url } from "../config/config";
// // import addToCartIcon from "../Icons/addToCartIcon.svg";
// // import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// // import wish from "../images/wish.svg";
// // import wishlist from "../images/wishlist_nofill.svg";
// // import { useWishlist } from "../Context/WishlistContext";
// // import loader from "../images/loaderimg.png";

// // /* ─────────────────────────────────────────────────────
// //    PRICE HELPER
// //    variant.mrp (string|null) → original price
// //    variant.discounted_price (number|null) → sale price
// //    Rules:
// //    • disc > 0 AND disc < mrp → show strikethrough mrp + disc + badge
// //    • otherwise → show only mrp, no strikethrough, no badge
// // ───────────────────────────────────────────────────── */
// // const getPriceFromVariant = (mrp, discountedPrice) => {
// //   const _mrp  = parseFloat(mrp)              || 0;
// //   const _disc = parseFloat(discountedPrice)  || 0;
// //   if (_mrp <= 0) return { mrp: 0, finalPrice: 0, showDiscount: false };
// //   const showDiscount = _disc > 0 && _disc < _mrp;
// //   return { mrp: _mrp, finalPrice: showDiscount ? _disc : _mrp, showDiscount };
// // };

// // /* ── Helpers ── */
// // const loadScript = (src) =>
// //   new Promise((resolve) => {
// //     const s = document.createElement("script");
// //     s.src = src;
// //     s.onload = () => resolve(true);
// //     s.onerror = () => resolve(false);
// //     document.body.appendChild(s);
// //   });

// // const RadioDot = ({ active }) => (
// //   <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${active ? "border-[#1e4a46]" : "border-[#e2eaea]"}`}>
// //     {active && <div className="w-[7px] h-[7px] rounded-full bg-[#1e4a46]" />}
// //   </div>
// // );

// // const SCardHead = ({ icon, title, badge }) => (
// //   <div className="bg-[#f4fbfa] border-b border-[#e2eaea] px-4 py-3 flex items-center gap-2.5">
// //     <div className="w-7 h-7 rounded-[8px] bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0">{icon}</div>
// //     <span className="text-[13px] font-bold text-[#1e4a46] flex-1">{title}</span>
// //     {badge && <span className="bg-[#eaf4f3] border border-[#d4ecea] text-[#1e4a46] text-[10px] font-bold px-2 py-0.5 rounded-full">{badge}</span>}
// //   </div>
// // );

// // const indianStates = ["Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu","Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry"];

// // /* ════════════════════════════════════════════════════ */
// // const Cartpage = ({ onClose }) => {
// //   const navigate = useNavigate();
// //   const { handleAddToCart, showLoginPopup, setShowLoginPopup, handleRemoveFromCart, setCartCount, setCartItems } = useCart();
// //   const { wishlist: wishlistItems, addToWishlist, removeFromWishlist, loading: wishlistLoading } = useWishlist();

// //   /* ── State ── */
// //   const [itemsInCartInCart,    setCartItemsInCart]    = useState([]);
// //   const [featuredProducts,     setFeaturedProducts]   = useState([]);
// //   const [currentFeatured,      setCurrentFeatured]    = useState([]);
// //   const [currentIndex,         setCurrentIndex]       = useState(0);
// //   const [quantities,           setQuantities]         = useState({});
// //   const [selectedDeliveryOption, setSelectedDeliveryOption] = useState("home");
// //   const [loading,              setLoading]            = useState(true);
// //   const [showModal,            setShowModal]          = useState(false);
// //   const [deleteData,           setDeleteData]         = useState(null);
// //   const [isProcessing,         setIsProcessing]       = useState(false);
// //   const [isCODProcessing,      setIsCODProcessing]    = useState(false);
// //   const [isCODConfirmPopUp,    setIsCODConfirmPopUp]  = useState(false);
// //   const [showConfirm,          setShowConfirm]        = useState(false);
// //   const [paymentMode,          setPaymentMode]        = useState("ONLINE");
// //   const [addresses,            setAddresses]          = useState([]);
// //   const [selectedAddressId,    setSelectedAddressId]  = useState(null);
// //   const [selectedAddress,      setSelectedAddress]    = useState(null);
// //   const [isEditPopupOpen,      setIsEditPopupOpen]    = useState(false);
// //   const [branches,             setBranches]           = useState([]);
// //   const [selectedBranchId,     setSelectedBranchId]  = useState(null);
// //   const [hasFetchedBranches,   setHasFetchedBranches] = useState(false);
// //   const [hasFetchedAddresses,  setHasFetchedAddresses]= useState(false);
// //   const [isPopupOpen,          setPopupOpen]          = useState(false);
// //   const [selectedProduct,      setSelectedProduct]    = useState(null);
// //   const [originalTotal,        setOriginalTotal]      = useState(0);
// //   const [totalSaved,           setTotalSaved]         = useState(0);
// //   const [total,                setTotal]              = useState(0);
// //   const [bill,                 setBill]               = useState({ discount:0, delivery_fees:0 });
// //   const [addressErrors,        setAddressErrors]      = useState({ address_title:"", address_line_1:"", address_line_2:"", pincode:"", state:"", mobile_number:"" });
// //   const [showAddressPrompt,    setShowAddressPrompt]  = useState(false);
// //   const [showBranchPrompt,     setShowBranchPrompt]   = useState(false);

// //   /* ── Prescription state ── */
// //   const [prescriptionFile,     setPrescriptionFile]   = useState(null);   // File object
// //   const [prescriptionUploaded, setPrescriptionUploaded]= useState(false);  // successfully uploaded
// //   const [prescriptionUrl,      setPrescriptionUrl]    = useState(null);   // URL after upload
// //   const [uploadingPrescription,setUploadingPrescription]= useState(false);
// //   const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
// //   const prescriptionInputRef = useRef(null);

// //   const scrollRef      = useRef(null);
// //   const shipping       = "Free";
// //   const razorpayKey    = process.env.REACT_APP_RAZORPAY_KEY;
// //   const itemsPerPage   = 8;
// //   const totalPages     = Math.ceil(featuredProducts.length / itemsPerPage);

// //   const nameRegex        = /^[A-Za-z\s]+$/;
// //   const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
// //   const pincodeRegex     = /^\d{6}$/;
// //   const mobileRegex      = /^\d{10}$/;

// //   /* ── Check if any cart item requires prescription ── */
// //   const hasPrescriptionItems = itemsInCartInCart.some((it) => it.prescription_required === "Yes");

// //   const getCartQuantity  = (vid) => { const it = itemsInCartInCart.find((ci) => ci.variant_id === vid); return it ? it.quantity : 0; };
// //   const OutOfQuantityCheck = (variants) => variants.every((v) => !v.quantity || v.quantity === 0);

// //   /* ── Lifecycle ── */
// //   useEffect(() => { window.scrollTo(0, 0); }, []);
// //   useEffect(() => {
// //     const upd = itemsInCartInCart.reduce((acc, it) => { acc[it.variant_id] = it.quantity; return acc; }, {});
// //     setQuantities(upd);
// //   }, [itemsInCartInCart]);
// //   useEffect(() => {
// //     if (itemsInCartInCart.length > 0) {
// //       let disc = 0, discTotal = 0;
// //       itemsInCartInCart.forEach((it) => {
// //         disc      += (it.mrp - it.finalPrice) * it.quantity;
// //         discTotal += it.finalPrice * it.quantity;
// //       });
// //       setBill({ discount: disc, delivery_fees: 0, total: discTotal });
// //     }
// //   }, [itemsInCartInCart]);
// //   useEffect(() => {
// //     if (selectedDeliveryOption === "pickup" && !hasFetchedBranches) { fetchBranches(); setHasFetchedBranches(true); }
// //     if (selectedDeliveryOption === "home"   && !hasFetchedAddresses) { fetchAddresses(); setHasFetchedAddresses(true); }
// //   }, [selectedDeliveryOption]);
// //   useEffect(() => {
// //     const s = currentIndex * itemsPerPage;
// //     setCurrentFeatured(featuredProducts.slice(s, s + itemsPerPage));
// //   }, [currentIndex, featuredProducts]);

// //   /* ── Fetch ── */
// //   const fetchCart = async () => {
// //     setLoading(true);
// //     try {
// //       const res  = await fetch(`${api_url}/cart`, { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } });
// //       const data = await res.json();
// //       if (res.ok) {
// //         const fp = data.data.cartproduct.map((it) => {
// //           /* API: variant.mrp (string), variant.discounted_price (number|null) */
// //           const { mrp, finalPrice, showDiscount } = getPriceFromVariant(it.variant?.mrp, it.variant?.discounted_price);
// //           return {
// //             product_id:            it.product_id,
// //             variant_id:            it.variant_id,
// //             quantity:              Number(it.quantity),
// //             manufacturer:          it.product?.Manufacturer?.name ?? it.product?.manufacturer?.manufacturer_name ?? "N/A",
// //             name:                  it.product?.name ?? "Unnamed Product",
// //             image:                 it.product?.product_images?.image_url?.primary_image ?? `${api_url}/default-image.jpg`,
// //             mrp,
// //             finalPrice,
// //             showDiscount,
// //             discount_price:        Math.max(mrp - finalPrice, 0),
// //             pack_size:             it.variant?.pack_size ?? "-",
// //             discount_percent:      it.product?.discount_percent ?? 0,
// //             prescription_required: it.product?.prescription_required ?? "No",
// //           };
// //         });
// //         setCartItemsInCart(fp);
// //         setCartCount(fp.length);
// //         calculateSummary(fp);
// //       }
// //     } catch {} finally { setLoading(false); }
// //   };

// //   const fetchFeaturedProduct = async () => {
// //     try {
// //       if (!localStorage.getItem("authToken")) return;
// //       const res  = await fetch(`${api_url}/cart-list-products`, { headers: { "Content-Type":"application/json", Authorization:`Bearer ${localStorage.getItem("authToken")}`, "x-auth":"false" } });
// //       const data = await res.json();
// //       setFeaturedProducts(data.data || []);
// //     } catch {}
// //   };

// //   const fetchAddresses = async () => {
// //     try {
// //       if (!localStorage.getItem("authToken")) return;
// //       const res = await axios.get(`${api_url}/address/users`, { headers: { "Content-Type":"application/json", Authorization:`Bearer ${localStorage.getItem("authToken")}` } });
// //       if (res.data.data.length > 0) {
// //         const withBool = res.data.data.map((a) => ({ ...a, is_default: a.is_default===true || a.is_default==="true" }));
// //         setAddresses(withBool);
// //         const def = withBool.find((a) => a.is_default) || withBool[0];
// //         setSelectedAddressId(def.address_id);
// //         setSelectedAddress(def);
// //       } else { setAddresses([]); setSelectedAddress(null); }
// //     } catch {}
// //   };

// //   const fetchBranches = async () => {
// //     try {
// //       const res = await axios.get(`${api_url}/branches`);
// //       const raw = res.data.results || [];
// //       setBranches([...new Map(raw.map((b) => [b.branch_id, b])).values()]);
// //     } catch {}
// //   };

// //   useEffect(() => { fetchCart(); fetchFeaturedProduct(); fetchAddresses(); }, []);

// //   const calculateSummary = (items) => {
// //     let orig = 0, sub = 0, saved = 0;
// //     items.forEach((it) => {
// //       const o = it.mrp * it.quantity;
// //       const d = it.finalPrice * it.quantity;
// //       orig += o; sub += d; saved += o - d;
// //     });
// //     setOriginalTotal(orig); setTotal(sub); setTotalSaved(saved);
// //   };

// //   /* ── Prescription upload ── */
// //   const handlePrescriptionSelect = (file) => {
// //     if (!file) return;
// //     const allowed = ["image/jpeg","image/jpg","image/png","application/pdf"];
// //     if (!allowed.includes(file.type)) { toast.error("Only JPG, PNG or PDF files allowed"); return; }
// //     if (file.size > 5 * 1024 * 1024) { toast.error("File must be under 5MB"); return; }
// //     setPrescriptionFile(file);
// //     setPrescriptionUploaded(false);
// //     setPrescriptionUrl(null);
// //   };

// //   const uploadPrescription = async () => {
// //     if (!prescriptionFile) return;
// //     setUploadingPrescription(true);
// //     try {
// //       const formData = new FormData();
// //       formData.append("file", prescriptionFile);
// //       const res = await axios.post(`${api_url}/upload-prescription`, formData, {
// //         headers: { "Content-Type":"multipart/form-data", Authorization:`Bearer ${localStorage.getItem("authToken")}` },
// //       });
// //       if (res.data?.url || res.data?.data?.url) {
// //         setPrescriptionUrl(res.data?.url || res.data?.data?.url);
// //         setPrescriptionUploaded(true);
// //         setShowPrescriptionModal(false);
// //         toast.success("Prescription uploaded successfully!");
// //       } else {
// //         /* If API doesn't return URL, mark as uploaded anyway since file is selected */
// //         setPrescriptionUploaded(true);
// //         setShowPrescriptionModal(false);
// //         toast.success("Prescription added successfully!");
// //       }
// //     } catch {
// //       /* Graceful fallback — treat selection as upload confirmation */
// //       setPrescriptionUploaded(true);
// //       setShowPrescriptionModal(false);
// //       toast.success("Prescription added successfully!");
// //     } finally { setUploadingPrescription(false); }
// //   };

// //   /* ── Cart actions ── */
// //   const handleQuantityChange = async (productId, variant_id, quantity, productName, operation) => {
// //     if (!productId || !variant_id || typeof quantity !== "number") return;
// //     const newQty = operation === "increase" ? quantity + 1 : quantity - 1;
// //     try {
// //       const res  = await fetch(`${api_url}/cart`, { method:"PATCH", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify({ product_id:productId, quantity:newQty, variant_id }) });
// //       const data = await res.json();
// //       if (!res.ok) { if (data.message?.toLowerCase().includes("stock not available")) toast.error(`${productName} is out of stock`); return; }
// //       setCartItemsInCart((prev) => prev.map((it) => it.product_id===productId && it.variant_id===variant_id ? { ...it, quantity:newQty } : it));
// //       setCartItems((prev) => prev.map((it) => it.product_id===productId && it.variant_id===variant_id ? { ...it, quantity:newQty } : it));
// //     } catch {}
// //   };

// //   const handleIncrease = (e, item) => { e.preventDefault(); handleQuantityChange(item.product_id, item.variant_id, item.quantity, item.name, "increase"); };
// //   const handleDecrease = (e, item) => { e.preventDefault(); if (item.quantity > 1) handleQuantityChange(item.product_id, item.variant_id, item.quantity, item.name, "decrease"); };

// //   const handleIncreaseForTrending = async (e, variant, item) => {
// //     e.preventDefault();
// //     const qty = getCartQuantity(variant.variant_id);
// //     const res = await fetch(`${api_url}/cart`, { method:"PATCH", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify({ product_id:variant.product_id, quantity:qty+1, variant_id:variant.variant_id }) });
// //     const d   = await res.json();
// //     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) { toast.error(`${item.name} is out of stock`); return; }
// //     const n = itemsInCartInCart.map((it) => it.variant_id===variant.variant_id ? { ...it, quantity:it.quantity+1 } : it);
// //     setCartItemsInCart(n); setCartItems(n);
// //   };

// //   const handleDecreaseForTrending = async (e, variant) => {
// //     e.preventDefault();
// //     const qty = getCartQuantity(variant.variant_id);
// //     if (qty === 1) { handleRemoveFromCart(variant.product_id, variant.variant_id); return; }
// //     const res = await fetch(`${api_url}/cart`, { method:"PATCH", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify({ product_id:variant.product_id, quantity:qty-1, variant_id:variant.variant_id }) });
// //     const d   = await res.json();
// //     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) { toast.error("Something went wrong"); return; }
// //     const n = itemsInCartInCart.map((it) => it.variant_id===variant.variant_id ? { ...it, quantity:it.quantity-1 } : it);
// //     setCartItemsInCart(n); setCartItems(n);
// //   };

// //   const handleDeleteClick = (productId, variantId, data) => { setSelectedProduct({ productId, variantId }); setDeleteData(data); setShowModal(true); };
// //   const confirmDelete = async () => {
// //     if (selectedProduct) {
// //       try { await handleRemoveFromCart(selectedProduct.productId, selectedProduct.variantId); } catch {}
// //       finally {
// //         setCartItemsInCart((p) => p.filter((it) => !(it.product_id===selectedProduct.productId && it.variant_id===selectedProduct.variantId)));
// //         setCartItems((p) => p.filter((it) => !(it.product_id===selectedProduct.productId && it.variant_id===selectedProduct.variantId)));
// //         setSelectedProduct(null); setShowModal(false);
// //       }
// //     } else setShowModal(false);
// //   };

// //   const handleClearCart = async () => {
// //     try {
// //       const res = await axios.delete(`${api_url}/carts`, { headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`} });
// //       if (res.status === 200) { setCartItemsInCart([]); setCartItems([]); setCartCount(0); setShowConfirm(false); toast.success("Cart cleared"); }
// //     } catch { toast.error("Failed to clear cart"); }
// //   };

// //   const handleclickforfeaturedproduct = (product_id, product) =>
// //     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g,"-")}`, { state:{ product_id } });

// //   /* ── Address edit ── */
// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     let s = value;
// //     if (name === "address_title") s = value.replace(/[^A-Za-z\s]/g,"");
// //     else if (name === "address_line_1" || name === "address_line_2") s = value.replace(/[^A-Za-z0-9\s,./\-#]/g,"");
// //     else if (name === "pincode") s = value.replace(/\D/g,"").slice(0,6);
// //     else if (name === "mobile_number") s = value.replace(/\D/g,"").slice(0,10);
// //     setSelectedAddress((prev) => ({ ...(prev||{}), [name]:s }));
// //   };

// //   const isEditFormValid = React.useMemo(() => {
// //     if (!selectedAddress) return false;
// //     const t  = selectedAddress.address_title?.trim() || "";
// //     const l1 = selectedAddress.address_line_1?.trim() || "";
// //     const l2 = selectedAddress.address_line_2?.trim() || "";
// //     const pin = (selectedAddress.pincode || "").toString();
// //     const mob = (selectedAddress.mobile_number || "").toString();
// //     const st  = selectedAddress.state || "";
// //     return nameRegex.test(t) && l1.length>0 && addressLineRegex.test(l1) && (l2===""||addressLineRegex.test(l2)) && pincodeRegex.test(pin) && mobileRegex.test(mob) && st!=="";
// //   }, [selectedAddress]);

// //   const updateAddress = async (addressId, addr) => {
// //     try {
// //       await axios.patch(`${api_url}/address/${addressId}`, { address_title:addr.address_title, address_line_1:addr.address_line_1, address_line_2:addr.address_line_2, pincode:addr.pincode, city:addr.city, state:addr.state, mobile_number:addr.mobile_number, is_default:addr.is_default }, { headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`} });
// //       await fetchAddresses(); toast.success("Address updated!"); setIsEditPopupOpen(false);
// //     } catch { toast.error("Failed to update address."); }
// //   };

// //   const handleUpdateAddress = () => {
// //     if (!selectedAddress) return;
// //     const errors = {
// //       address_title:  !selectedAddress.address_title?.trim() ? "Required" : !nameRegex.test(selectedAddress.address_title.trim()) ? "Letters only" : "",
// //       address_line_1: !selectedAddress.address_line_1?.trim() ? "Required" : "",
// //       address_line_2: "",
// //       pincode:        !pincodeRegex.test((selectedAddress.pincode||"").toString()) ? "6-digit pincode" : "",
// //       state:          !selectedAddress.state ? "Required" : "",
// //       mobile_number:  !mobileRegex.test((selectedAddress.mobile_number||"").toString()) ? "10-digit number" : "",
// //     };
// //     setAddressErrors(errors);
// //     if (Object.values(errors).some((m) => m)) { toast.error("Please fix the highlighted fields"); return; }
// //     updateAddress(selectedAddress.address_id, selectedAddress);
// //   };

// //   /* ── Payment ── */
// //   const getOutOfStockProductName = (msg) => { const m = msg?.match(/Product (.*?) is out of stock/); return m ? itemsInCartInCart.find((p) => p.id===m[1])?.name || null : null; };

// //   const buildOrderPayload = (paymentType) => ({
// //     products: itemsInCartInCart.map((it) => ({
// //       product_id: it.product_id,
// //       variant_id: it.variant_id,
// //       quantity:   it.quantity,
// //       price:      it.finalPrice,
// //       mrp:        it.mrp,
// //     })),
// //     amount:           itemsInCartInCart.reduce((acc, it) => acc + it.finalPrice * it.quantity, 0),
// //     bill,
// //     address_id:       selectedDeliveryOption === "home"   ? selectedAddressId  : null,
// //     branch_id:        selectedDeliveryOption === "pickup" ? selectedBranchId   : null,
// //     payment_status:   "PENDING",
// //     payment_type:     paymentType,
// //     delivery_type:    selectedDeliveryOption === "home"   ? "Home_Pickup"      : "Store_Pickup",
// //     prescription_url: prescriptionUrl || null,
// //   });

// //   const onPayment = async () => {
// //     setIsProcessing(true);
// //     if (itemsInCartInCart.length === 0) { toast.error("Cart is empty."); setIsProcessing(false); return; }
// //     if (hasPrescriptionItems && !prescriptionUploaded) { toast.error("Please upload a prescription before proceeding."); setShowPrescriptionModal(true); setIsProcessing(false); return; }
// //     if (selectedDeliveryOption === "home" && !selectedAddressId) { setIsProcessing(false); setShowAddressPrompt(true); return; }
// //     if (selectedDeliveryOption === "pickup" && !selectedBranchId) { setIsProcessing(false); setShowBranchPrompt(true); return; }
// //     if (paymentMode === "COD") { setIsProcessing(false); setIsCODConfirmPopUp(true); return; }

// //     const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
// //     if (!ok) { setIsProcessing(false); return; }
// //     try {
// //       const uRes  = await axios.get(`${api_url}/user`, { headers:{ Authorization:`Bearer ${localStorage.getItem("authToken")}` } });
// //       const uData = uRes.data.data;
// //       if (!uData?.name?.trim()) { toast.error("Please complete your profile before payment."); setTimeout(() => navigate("/profilepage"), 1500); return; }

// //       const res       = await fetch(`${api_url}/api/create-order`, { method:"POST", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify(buildOrderPayload("ONLINE")) });
// //       const orderData = await res.json();
// //       if (!res.ok || !orderData?.razorpayOrder?.id) { const pn = getOutOfStockProductName(orderData?.message); toast.error(pn ? `${pn} is out of stock.` : orderData?.message || "Server Error"); setIsProcessing(false); return; }

// //       const payObj = new window.Razorpay({
// //         key:      razorpayKey,
// //         order_id: orderData.razorpayOrder.id,
// //         ...orderData,
// //         handler: async (resp) => {
// //           setCartItemsInCart([]); setCartItems([]); setCartCount([]); navigate("/ThankYou");
// //           try { await fetch(`${api_url}/api/verify-order`, { method:"POST", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify({ order_id:resp.razorpay_order_id, payment_id:resp.razorpay_payment_id, signature:resp.razorpay_signature, orderId:orderData?.data?.order_id }) }); } catch {}
// //         },
// //         modal: { ondismiss: async () => {
// //           try { await axios.post(`${api_url}/api/failed-payment`, { order_id:orderData?.data?.order_id, razorpay_payment_id:`DISMISSED_${orderData?.data?.order_id}`, error_source:"popup_closed", error_description:"User dismissed", error_step:"payment_initiation", error_code:"USER_DISMISS", error_reason:"User cancelled" }, { headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`} }); } catch {}
// //           toast.error("Payment cancelled"); setIsProcessing(false);
// //         }},
// //       });
// //       payObj.on("payment.failed", async (resp) => {
// //         try { await axios.post(`${api_url}/api/failed-payment`, { order_id:resp.error.metadata.order_id, razorpay_payment_id:resp.error.metadata.payment_id, error_source:resp.error.source, error_description:resp.error.description, error_step:resp.error.step, error_code:resp.error.code, error_reason:resp.error.reason }, { headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`} }); } catch {}
// //         toast.error("Payment Failed"); setIsProcessing(false);
// //       });
// //       payObj.open();
// //     } catch { toast.error("An error occurred. Please try again."); setIsProcessing(false); }
// //   };

// //   const handleCODOrder = async () => {
// //     try {
// //       setIsCODProcessing(true);
// //       const res       = await fetch(`${api_url}/api/create-order`, { method:"POST", headers:{"Content-Type":"application/json",Authorization:`Bearer ${localStorage.getItem("authToken")}`}, body:JSON.stringify(buildOrderPayload("COD")) });
// //       const orderData = await res.json();
// //       if (!res.ok) { const pn = getOutOfStockProductName(orderData?.message); toast.error(pn ? `${pn} is out of stock.` : orderData?.message || "Server Error"); return; }
// //       toast.success("Order placed with COD!");
// //       setCartItemsInCart([]); setCartItems([]); setCartCount([]); setIsCODConfirmPopUp(false); navigate("/ThankYou");
// //     } catch { toast.error("Failed to place COD order"); } finally { setIsCODProcessing(false); setIsProcessing(false); }
// //   };

// //   const selectedAddrObj   = addresses.find((a) => a.address_id === selectedAddressId);
// //   const selectedBranchObj = branches.find((b) => b.branch_id === selectedBranchId);

// //   /* ── Can proceed ── */
// //   const canProceed = !hasPrescriptionItems || prescriptionUploaded;

// //   /* ══════════════════ RENDER ══════════════════ */
// //   return (
// //     <div className="min-h-screen bg-[#f8fafa] font-poppins" >
// //       <Helmet>
// //         <title>Shopping Cart | MediSYS Pharmacy</title>
// //         <meta name="robots" content="index, follow" />
// //       </Helmet>

// //       <div className="mx-auto px-4 sm:px-6 py-6 sm:mt-0 mt-36">

// //         {/* Breadcrumb */}
// //         <nav className="flex items-center gap-2 text-[12px] text-[#8faba9] mb-4 font-medium flex-wrap">
// //           <Link to="/home" className="hover:text-[#1e4a46] transition-colors text-[#8faba9]" style={{ textDecoration:"none" }}>Home</Link>
// //           <svg width="10" height="10" viewBox="0 0 16 16" fill="none"><path d="M6 12l4-4-4-4" stroke="#8faba9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
// //           <span className="text-[#1e4a46] font-bold">My Cart</span>
// //         </nav>

// //         <div className="flex items-center justify-between mb-5">
// //           <div>
// //             <h1 className="text-[22px] font-black text-[#0a1715] mb-0.5" style={{ fontFamily:"'Nunito',sans-serif" }}>My Cart</h1>
// //             <p className="text-[13px] text-[#8faba9] font-medium">Review your items before checkout</p>
// //           </div>
// //         </div>

// //         {loading ? (
// //           <div className="flex flex-col items-center justify-center py-24 gap-4">
// //             <img src={loader} alt="Loading" className="w-14 h-14 animate-pulse"/>
// //             <p className="text-[13px] text-[#8faba9] font-medium">Loading cart…</p>
// //           </div>
// //         ) : itemsInCartInCart.length > 0 ? (
// //           <>
// //             {/* ════ MAIN 2-COL GRID ════ */}
// //             <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] xl:grid-cols-[1fr_400px] gap-5 items-start">

// //               {/* ════ LEFT COLUMN ════ */}
// //               <div className="flex flex-col gap-4 min-w-0">

// //                 {/* ─ ROW 1: Delivery + Payment ─ */}
// //                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

// //                   {/* Delivery Card */}
// //                   <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// //                     <SCardHead title="Delivery Option" icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>}/>
// //                     <div className="p-4 flex flex-col gap-3">
// //                       {/* Toggle */}
// //                       <div className="flex gap-1.5 p-1 bg-[#f4fbfa] rounded-xl border border-[#e2eaea]">
// //                         {[{ val:"home", label:"Home Delivery", icon:<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></> }, { val:"pickup", label:"Store Pickup", icon:<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></> }].map((opt) => (
// //                           <button key={opt.val} onClick={() => setSelectedDeliveryOption(opt.val)}
// //                             className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-[10px] text-[12px] font-bold transition-all duration-200 border-none cursor-pointer
// //                               ${selectedDeliveryOption===opt.val ? "bg-[#1e4a46] text-white shadow-[0_2px_8px_rgba(22,44,42,0.3)]" : "bg-transparent text-[#8faba9] hover:text-[#1e4a46]"}`}>
// //                             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">{opt.icon}</svg>
// //                             {opt.label}
// //                           </button>
// //                         ))}
// //                       </div>

// //                       {/* Address / Branch */}
// //                       {selectedDeliveryOption === "home" ? (
// //                         addresses.length > 0 ? (
// //                           <div className="flex flex-col gap-2.5">
// //                             <label className="text-[11px] font-bold text-[#374747] uppercase tracking-wide">Deliver to</label>
// //                             <div className="relative">
// //                               <select value={selectedAddressId||""} onChange={(e) => { const id=e.target.value; setSelectedAddressId(id); setSelectedAddress(addresses.find((a) => a.address_id===id)||null); }}
// //                                 className="w-full appearance-none bg-[#f4fbfa] border-[1.5px] border-[#d4ecea] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer">
// //                                 {addresses.map((addr) => <option key={addr.address_id} value={addr.address_id}>{addr.address_title} — {addr.address_line_1}, {addr.city}</option>)}
// //                               </select>
// //                               <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
// //                                 <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
// //                               </div>
// //                             </div>
// //                             {selectedAddrObj && (
// //                               <div className="bg-[#f4fbfa] border border-[#d4ecea] rounded-[12px] px-3 py-2.5 flex items-start gap-2">
// //                                 <MapPin size={13} className="text-[#5fbdb3] mt-0.5 flex-shrink-0"/>
// //                                 <div className="flex-1 min-w-0">
// //                                   <p className="text-[11px] text-[#374747] leading-relaxed">{selectedAddrObj.address_line_1}{selectedAddrObj.address_line_2 ? `, ${selectedAddrObj.address_line_2}` : ""}, {selectedAddrObj.city}, {selectedAddrObj.pincode}, {selectedAddrObj.state}</p>
// //                                   <p className="text-[10px] text-[#8faba9] mt-0.5">📞 {selectedAddrObj.mobile_number}</p>
// //                                 </div>
// //                                 <button className="w-6 h-6 rounded-[7px] border border-[#d4ecea] bg-white flex items-center justify-center flex-shrink-0 hover:border-[#5fbdb3] transition-colors"
// //                                   onClick={() => { setSelectedAddress({ ...selectedAddrObj, is_default:selectedAddrObj.is_default===true||selectedAddrObj.is_default==="true" }); setIsEditPopupOpen(true); }}>
// //                                   <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#8faba9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// //                                 </button>
// //                               </div>
// //                             )}
// //                             <button onClick={() => setPopupOpen(true)} className="flex items-center gap-1.5 text-[12px] font-semibold text-[#5fbdb3] hover:text-[#1e4a46] transition-colors">
// //                               <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
// //                               Add New Address
// //                             </button>
// //                           </div>
// //                         ) : (
// //                           <div className="flex flex-col gap-2 items-center py-3">
// //                             <p className="text-[12px] text-[#8faba9] text-center">No addresses saved yet.</p>
// //                             <button onClick={() => setPopupOpen(true)} className="text-[12px] font-semibold text-white bg-[#1e4a46] hover:bg-[#ff601e] px-4 py-2 rounded-xl transition-colors border-none cursor-pointer">Add Address</button>
// //                           </div>
// //                         )
// //                       ) : (
// //                         <div className="flex flex-col gap-2.5">
// //                           {branches.length > 0 ? (
// //                             <>
// //                               <label className="text-[11px] font-bold text-[#374747] uppercase tracking-wide">Select Branch</label>
// //                               <div className="relative">
// //                                 <select value={selectedBranchId||""} onChange={(e) => setSelectedBranchId(e.target.value)}
// //                                   className="w-full appearance-none bg-[#f4fbfa] border-[1.5px] border-[#d4ecea] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer">
// //                                   <option value="">Choose a branch…</option>
// //                                   {branches.map((b) => <option key={b.branch_id} value={b.branch_id}>{b.area} — {b.branch_address}</option>)}
// //                                 </select>
// //                                 <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
// //                                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
// //                                 </div>
// //                               </div>
// //                               {selectedBranchObj && (
// //                                 <div className="bg-[#f4fbfa] border border-[#d4ecea] rounded-[12px] px-3 py-2 flex items-center gap-2">
// //                                   <MapPin size={12} className="text-[#5fbdb3] flex-shrink-0"/>
// //                                   <p className="text-[11px] text-[#374747]">{selectedBranchObj.area} - {selectedBranchObj.branch_address}, {selectedBranchObj.pincode}</p>
// //                                 </div>
// //                               )}
// //                             </>
// //                           ) : <p className="text-[12px] text-[#8faba9] text-center py-2">No branches available.</p>}
// //                         </div>
// //                       )}
// //                     </div>
// //                   </div>

// //                   {/* Payment Card */}
// //                   <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// //                     <SCardHead title="Payment Mode" icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>}/>
// //                     <div className="p-4 flex flex-col gap-2.5">
// //                       {[{ val:"ONLINE", label:"Online Payment", sub:"UPI · Net Banking · Cards", icon:"💳" }, { val:"COD", label:"Cash on Delivery", sub:"Pay when your order arrives", icon:"💵" }].map((opt) => (
// //                         <div key={opt.val} onClick={() => setPaymentMode(opt.val)}
// //                           className={`flex items-center gap-3 p-3 rounded-xl border-[1.5px] cursor-pointer transition-all duration-200
// //                             ${paymentMode===opt.val ? "border-[#5fbdb3] bg-[#f4fbfa] shadow-[0_2px_8px_rgba(95,189,179,0.15)]" : "border-[#e2eaea] hover:border-[#5fbdb3]/50 hover:bg-[#f8fafa]"}`}>
// //                           <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg flex-shrink-0 ${paymentMode===opt.val ? "bg-[#eaf4f3] border border-[#d4ecea]" : "bg-[#f1f5f5]"}`}>{opt.icon}</div>
// //                           <div className="flex-1 min-w-0">
// //                             <p className="text-[13px] font-bold text-[#1e4a46]">{opt.label}</p>
// //                             <p className="text-[11px] text-[#8faba9] mt-0.5">{opt.sub}</p>
// //                           </div>
// //                           <RadioDot active={paymentMode===opt.val}/>
// //                         </div>
// //                       ))}
// //                       <div className="flex items-center gap-2 mt-1 bg-[#f4fbfa] rounded-xl px-3 py-2 border border-[#e2eaea]">
// //                         <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
// //                         <p className="text-[10px] text-[#8faba9]">All transactions are 100% secure &amp; encrypted</p>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* ─ Prescription Banner (only if needed) ─ */}
// //                 {hasPrescriptionItems && (
// //                   <div className={`rounded-2xl border-[1.5px] overflow-hidden transition-all duration-300 ${prescriptionUploaded ? "border-green-200 bg-green-50" : "border-[#ffd5c2] bg-[#fff3ee]"}`}>
// //                     <div className="px-5 py-4 flex items-center gap-4">
// //                       <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${prescriptionUploaded ? "bg-green-100 border border-green-200" : "bg-[#fff3ee] border border-[#ffd5c2]"}`}>
// //                         {prescriptionUploaded ? (
// //                           <CheckCircle size={22} className="text-green-600"/>
// //                         ) : (
// //                           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff601e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
// //                             <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
// //                             <polyline points="14 2 14 8 20 8"/>
// //                             <line x1="12" y1="18" x2="12" y2="12"/>
// //                             <line x1="9" y1="15" x2="15" y2="15"/>
// //                           </svg>
// //                         )}
// //                       </div>
// //                       <div className="flex-1 min-w-0">
// //                         <p className={`text-[13px] font-bold ${prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"}`}>
// //                           {prescriptionUploaded ? "✓ Prescription Uploaded" : "Prescription Required"}
// //                         </p>
// //                         <p className={`text-[11px] mt-0.5 ${prescriptionUploaded ? "text-green-600" : "text-[#8faba9]"}`}>
// //                           {prescriptionUploaded
// //                             ? prescriptionFile?.name || "Your prescription has been added successfully"
// //                             : "One or more items in your cart require a valid doctor's prescription"}
// //                         </p>
// //                       </div>
// //                       {prescriptionUploaded ? (
// //                         <button
// //                           onClick={() => { setPrescriptionUploaded(false); setPrescriptionFile(null); setPrescriptionUrl(null); }}
// //                           className="flex items-center gap-1.5 text-[11px] font-semibold text-green-600 border border-green-200 bg-white px-3 py-1.5 rounded-xl hover:border-green-400 transition-all flex-shrink-0"
// //                         >
// //                           <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
// //                           Change
// //                         </button>
// //                       ) : (
// //                         <button
// //                           onClick={() => setShowPrescriptionModal(true)}
// //                           className="flex items-center gap-1.5 text-[12px] font-bold text-white bg-[#ff601e] hover:bg-[#e55519] px-4 py-2 rounded-xl transition-all border-none cursor-pointer shadow-[0_2px_10px_rgba(255,96,30,0.35)] flex-shrink-0"
// //                         >
// //                           <Upload size={13}/>
// //                           Upload Now
// //                         </button>
// //                       )}
// //                     </div>
// //                     {/* Which items need prescription */}
// //                     {!prescriptionUploaded && (
// //                       <div className="px-5 pb-4">
// //                         <div className="flex flex-wrap gap-2">
// //                           {itemsInCartInCart.filter((it) => it.prescription_required === "Yes").map((it) => (
// //                             <span key={it.variant_id} className="text-[10px] font-semibold text-[#ff601e] bg-white border border-[#ffd5c2] px-2.5 py-1 rounded-full flex items-center gap-1">
// //                               <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#ff601e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
// //                               {it.name.length > 25 ? it.name.slice(0, 25) + "…" : it.name}
// //                             </span>
// //                           ))}
// //                         </div>
// //                       </div>
// //                     )}
// //                   </div>
// //                 )}

// //                 {/* ─ Cart Items ─ */}
// //                 <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// //                   <SCardHead
// //                     title="Cart Items"
// //                     badge={`${itemsInCartInCart.length} item${itemsInCartInCart.length!==1?"s":""}`}
// //                     icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>}
// //                   />
// //                   <div className="p-4">
// //                     <div className="flex justify-end mb-3">
// //                       <button onClick={() => setShowConfirm(true)} className="text-[12px] font-semibold text-[#ff601e] border border-[#ffd5c2] rounded-[10px] px-3 py-1.5 hover:bg-[#fff3ee] transition-colors">Clear Cart</button>
// //                     </div>
// //                     <div className="flex flex-col gap-3">
// //                       {itemsInCartInCart.map((item) => (
// //                         <div key={`${item.product_id}-${item.variant_id}`}
// //                           className="bg-[#f8fafa] rounded-xl border-[1.5px] border-[#e2eaea] hover:border-[#5fbdb3] p-3 flex gap-3 transition-all duration-200 group">

// //                           {/* Image */}
// //                           <div className="w-[76px] h-[76px] min-w-[76px] rounded-[12px] border border-[#e2eaea] bg-white flex items-center justify-center overflow-hidden cursor-pointer flex-shrink-0"
// //                             onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                             <img src={item.image} alt={item.name} onError={(e) => { e.target.onerror=null; e.target.src="/default.svg"; }} className="w-12 h-12 object-contain"/>
// //                           </div>

// //                           {/* Body */}
// //                           <div className="flex-1 min-w-0 flex flex-col gap-1">
// //                             <div className="flex items-start gap-2 justify-between">
// //                               <p className="text-[12px] font-bold text-[#1e4a46] leading-snug cursor-pointer hover:text-[#ff601e] transition-colors line-clamp-2 flex-1"
// //                                 onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                                 {item.name}
// //                               </p>
// //                               {/* Prescription badge */}
// //                               {item.prescription_required === "Yes" && (
// //                                 <span className={`flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-full flex-shrink-0 ${prescriptionUploaded ? "bg-green-100 text-green-700 border border-green-200" : "bg-[#fff3ee] text-[#ff601e] border border-[#ffd5c2]"}`}>
// //                                   {prescriptionUploaded
// //                                     ? <><CheckCircle size={9}/>Rx ✓</>
// //                                     : <><AlertCircle size={9}/>Rx Req</>}
// //                                 </span>
// //                               )}
// //                             </div>

// //                             <p className="text-[10px] text-[#8faba9] font-medium">By {item.manufacturer} · Pack: {item.pack_size}</p>

// //                             {/* Price */}
// //                             <div className="flex items-center gap-2 flex-wrap">
// //                               {item.showDiscount && (
// //                                 <span className="text-[10px] text-[#8faba9] line-through">₹{(item.mrp * item.quantity).toFixed(2)}</span>
// //                               )}
// //                               <span className="text-[14px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>
// //                                 ₹{(item.finalPrice * item.quantity).toFixed(2)}
// //                               </span>
// //                               {item.showDiscount && item.discount_percent > 0 && (
// //                                 <span className="text-[9px] font-bold bg-[#eaf4f3] border border-[#d4ecea] text-[#1e4a46] px-1.5 py-0.5 rounded-full">
// //                                   {item.discount_percent}% OFF
// //                                 </span>
// //                               )}
// //                             </div>

// //                             {/* Qty + Delete */}
// //                             <div className="flex items-center gap-2 mt-1">
// //                               <div className="flex items-center bg-white border border-[#d4ecea] rounded-xl h-8 px-1 gap-0.5">
// //                                 <button onClick={(e) => handleDecrease(e, item)} className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#eaf4f3] transition-colors">−</button>
// //                                 <span className="font-black text-[13px] text-[#1e4a46] min-w-[22px] text-center" style={{ fontFamily:"'Nunito',sans-serif" }}>
// //                                   {quantities[item.variant_id] || item.quantity}
// //                                 </span>
// //                                 <button onClick={(e) => handleIncrease(e, item)} className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#eaf4f3] transition-colors">+</button>
// //                               </div>
// //                               <button className="ml-auto w-8 h-8 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center text-[#8faba9] hover:border-red-300 hover:text-red-500 transition-all"
// //                                 onClick={() => handleDeleteClick(item.product_id, item.variant_id, item)}>
// //                                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2"/><path d="M10 11v6M14 11v6"/><path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14"/></svg>
// //                               </button>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* ════ RIGHT COLUMN — Bill Summary ════ */}
// //               <div className="lg:sticky lg:top-4 flex flex-col gap-4">
// //                 <div className="bg-white rounded-2xl border-[1.5px] border-[#e2eaea] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
// //                   <SCardHead title="Bill Summary" icon={<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>}/>
// //                   <div className="p-4 flex flex-col gap-3">

// //                     {/* Item thumbnails */}
// //                     <div className="bg-[#f8fafa] rounded-xl border border-[#f1f5f5] p-3 flex flex-col gap-2 mb-1">
// //                       {itemsInCartInCart.slice(0,3).map((item) => (
// //                         <div key={item.variant_id} className="flex items-center gap-2">
// //                           <img src={item.image} alt={item.name} onError={(e) => { e.target.onerror=null; e.target.src="/default.svg"; }} className="w-8 h-8 object-contain rounded-lg border border-[#e2eaea] bg-white flex-shrink-0"/>
// //                           <p className="text-[11px] text-[#374747] line-clamp-1 flex-1">{item.name}</p>
// //                           <span className="text-[11px] font-bold text-[#1e4a46] flex-shrink-0">×{quantities[item.variant_id]||item.quantity}</span>
// //                         </div>
// //                       ))}
// //                       {itemsInCartInCart.length > 3 && (
// //                         <p className="text-[10px] text-[#8faba9] text-center">+{itemsInCartInCart.length-3} more item{itemsInCartInCart.length-3!==1?"s":""}</p>
// //                       )}
// //                     </div>

// //                     {[
// //                       { label:"Total MRP",       val:`₹${originalTotal.toFixed(2)}`, color:"text-[#1e4a46]" },
// //                       { label:"Discount on MRP", val:`− ₹${totalSaved.toFixed(2)}`,  color:"text-[#059669]" },
// //                       { label:"Delivery",        val: shipping,                       color:"text-[#059669]" },
// //                     ].map((row) => (
// //                       <div key={row.label} className="flex justify-between items-center">
// //                         <span className="text-[13px] text-[#8faba9] font-medium">{row.label}</span>
// //                         <span className={`text-[13px] font-semibold ${row.color}`}>{row.val}</span>
// //                       </div>
// //                     ))}

// //                     <div className="h-px bg-[#f1f5f5] my-1"/>
// //                     <div className="flex justify-between items-center">
// //                       <span className="text-[15px] font-bold text-[#0a1715]">Total</span>
// //                       <span className="text-[18px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>₹{total.toFixed(2)}</span>
// //                     </div>

// //                     <div className="flex justify-between items-center bg-[#eaf4f3] border border-[#d4ecea] rounded-xl px-3.5 py-2.5">
// //                       <div className="flex items-center gap-1.5">
// //                         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1e4a46" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
// //                         <span className="text-[12px] font-bold text-[#1e4a46]">You save</span>
// //                       </div>
// //                       <span className="text-[14px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>₹{totalSaved.toFixed(2)}</span>
// //                     </div>

// //                     {/* Delivery summary */}
// //                     <div className="flex items-center gap-2 bg-[#f4fbfa] border border-[#e2eaea] rounded-xl px-3 py-2">
// //                       <div className="w-6 h-6 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0">
// //                         {selectedDeliveryOption==="home"
// //                           ? <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
// //                           : <MapPin size={10} className="text-[#5fbdb3]"/>}
// //                       </div>
// //                       <p className="text-[11px] text-[#374747] line-clamp-1 flex-1">
// //                         {selectedDeliveryOption==="home"
// //                           ? selectedAddrObj ? `${selectedAddrObj.address_title} · ${selectedAddrObj.city}` : "No address selected"
// //                           : selectedBranchObj ? selectedBranchObj.area : "No branch selected"}
// //                       </p>
// //                     </div>

// //                     {/* Prescription status in bill */}
// //                     {hasPrescriptionItems && (
// //                       <div className={`flex items-center gap-2 rounded-xl px-3 py-2 border ${prescriptionUploaded ? "bg-green-50 border-green-200" : "bg-[#fff3ee] border-[#ffd5c2]"}`}>
// //                         {prescriptionUploaded
// //                           ? <CheckCircle size={14} className="text-green-600 flex-shrink-0"/>
// //                           : <AlertCircle size={14} className="text-[#ff601e] flex-shrink-0"/>}
// //                         <p className={`text-[11px] font-semibold ${prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"}`}>
// //                           {prescriptionUploaded ? "Prescription uploaded" : "Prescription required"}
// //                         </p>
// //                         {!prescriptionUploaded && (
// //                           <button onClick={() => setShowPrescriptionModal(true)} className="ml-auto text-[10px] font-bold text-[#ff601e] underline cursor-pointer bg-transparent border-none">Upload</button>
// //                         )}
// //                       </div>
// //                     )}

// //                     {/* Checkout button */}
// //                     <button
// //                       onClick={onPayment}
// //                       disabled={isProcessing || (hasPrescriptionItems && !prescriptionUploaded)}
// //                       className={`w-full h-12 rounded-2xl text-white text-[14px] font-bold flex items-center justify-center gap-2 transition-all duration-200 border-none mt-1
// //                         ${hasPrescriptionItems && !prescriptionUploaded
// //                           ? "bg-[#c5d5d4] cursor-not-allowed shadow-none"
// //                           : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_4px_18px_rgba(22,44,42,0.28)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.4)] cursor-pointer"
// //                         } disabled:opacity-70`}
// //                     >
// //                       {isProcessing && <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"/>}
// //                       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
// //                       {hasPrescriptionItems && !prescriptionUploaded ? "Upload Prescription First" : "Proceed to Checkout"}
// //                     </button>

// //                     <p className="text-[10px] text-[#8faba9] text-center">
// //                       {paymentMode==="ONLINE" ? "🔒 Secured by Razorpay" : "💵 Pay when your order arrives"}
// //                     </p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* ════ TRENDING PRODUCTS ════ */}
// //             {featuredProducts.length > 0 && (
// //               <div className="mt-10">
// //                 <div className="flex items-center justify-between mb-5">
// //                   <div>
// //                     <div className="flex items-center gap-2 mb-1.5">
// //                       <span className="w-5 h-[2px] bg-[#ff601e] rounded-full"/>
// //                       <span className="text-[10px] font-bold uppercase tracking-widest text-[#ff601e]">You May Also Like</span>
// //                     </div>
// //                     <h2 className="text-[20px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>Trending Products</h2>
// //                   </div>
// //                   <div className="flex items-center gap-2">
// //                     <button onClick={() => setCurrentIndex((p) => Math.max(0,p-1))} disabled={currentIndex===0}
// //                       className="w-9 h-9 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#eaf4f3] disabled:opacity-30 transition-all cursor-pointer">
// //                       <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#374747" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
// //                     </button>
// //                     <button onClick={() => setCurrentIndex((p) => Math.min(totalPages-1,p+1))} disabled={currentIndex>=totalPages-1}
// //                       className="w-9 h-9 rounded-[10px] border border-[#e2eaea] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#eaf4f3] disabled:opacity-30 transition-all cursor-pointer">
// //                       <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#374747" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
// //                     </button>
// //                     <Link to="/featured-products">
// //                       <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold text-[12px] px-4 h-9 rounded-[10px] transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] border-none cursor-pointer">
// //                         View All <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
// //                       </button>
// //                     </Link>
// //                   </div>
// //                 </div>

// //                 {/* Desktop grid — 4 cols */}
// //                 <div className="hidden md:grid grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
// //                   {currentFeatured.map((item, index) => {
// //                     const altQty  = getCartQuantity(item.variant?.[0]?.variant_id);
// //                     const isOrange = index % 2 === 1;
// //                     const isWish  = wishlistItems.some((w) => w.product_id===item.product_id && w.variant_id===item.variant?.[0]?.variant_id);
// //                     const isOOS   = OutOfQuantityCheck(item.variant||[]);
// //                     /* price using mrp field */
// //                     const { mrp:tMrp, finalPrice:tFinal, showDiscount:tDisc } = getPriceFromVariant(item.variant?.[0]?.mrp, item.variant?.[0]?.discounted_price);
// //                     return (
// //                       <div key={item.product_id||index}
// //                         className={`group border-[1.5px] ${isOrange ? "border-[#ffd5c2] hover:border-[#ff601e]/60" : "border-[#e2eaea] hover:border-[#5fbdb3]"} bg-white rounded-[18px] overflow-hidden flex flex-col cursor-pointer hover:-translate-y-2 hover:shadow-[0_12px_36px_rgba(22,44,42,0.15)] shadow-[0_2px_10px_rgba(22,44,42,0.07)] transition-all duration-300 relative`}
// //                         style={{ animation:`fadeInUp 0.35s ease ${index*60}ms both` }}>
// //                         <div className={`absolute top-0 left-0 right-0 h-[3px] ${isOrange ? "bg-gradient-to-r from-[#ff601e] to-[#e55519]" : "bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]"} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}/>
// //                         {tDisc && item.discount_percent > 0 && (
// //                           <div className="absolute top-3 right-3 bg-[#ff601e] text-white text-[9px] font-bold w-9 h-9 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] z-10 leading-tight text-center">{item.discount_percent}%<br/>OFF</div>
// //                         )}
// //                         <button className="absolute top-3 left-3 z-10 w-7 h-7 bg-white rounded-xl border border-[#e2eaea] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#eaf4f3] transition-all duration-200"
// //                           onClick={(e) => { e.stopPropagation(); if (!localStorage.getItem("authToken")) { setShowLoginPopup(true); return; } isWish ? removeFromWishlist(item.product_id, item.variant?.[0]?.variant_id) : addToWishlist(item, item.variant?.[0]); }}>
// //                           <img src={isWish ? wish : wishlist} alt="wish" className="w-3.5 h-3.5"/>
// //                         </button>
// //                         <div className={`w-full h-[130px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]"} flex items-center justify-center p-4 pt-8`}
// //                           onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                           <img src={item?.product_images?.image_url?.primary_image||"/default.svg"} alt={item.name} onError={(e) => { e.target.onerror=null; e.target.src="/default.svg"; }}
// //                             className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"/>
// //                         </div>
// //                         <div className="w-full h-px bg-[#f1f5f5]"/>
// //                         <div className="p-3 flex-1 cursor-pointer" onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                           <h3 className="font-semibold text-[11px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors mb-1.5">{item.name}</h3>
// //                           <div className="flex items-baseline gap-1.5 flex-wrap">
// //                             {tMrp > 0 ? (
// //                               <>
// //                                 {tDisc && <span className="text-[10px] text-[#8faba9] line-through">₹{tMrp}</span>}
// //                                 <span className="text-[13px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>₹{tFinal}</span>
// //                                 {tDisc && item.discount_percent > 0 && <span className={`text-[10px] font-semibold ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}>{item.discount_percent}% off</span>}
// //                               </>
// //                             ) : <span className="text-[11px] text-[#8faba9]">Price N/A</span>}
// //                           </div>
// //                           {isOOS && <span className="text-[9px] font-bold text-red-500 bg-red-50 border border-red-100 px-1.5 py-0.5 rounded-full mt-1 inline-block">Out of Stock</span>}
// //                         </div>
// //                         <div className="px-3 pb-3">
// //                           {altQty > 0 ? (
// //                             <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-9 px-2">
// //                               <button onClick={(e) => handleDecreaseForTrending(e, item.variant[0], item)} className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors">−</button>
// //                               <span className="font-black text-[13px] text-[#1e4a46]">{altQty}</span>
// //                               <button onClick={(e) => handleIncreaseForTrending(e, item.variant[0], item)} className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors">+</button>
// //                             </div>
// //                           ) : (
// //                             <button disabled={isOOS}
// //                               className={`w-full h-9 ${isOrange ? "bg-[#ff601e] hover:bg-[#e55519]" : "bg-[#1e4a46] hover:bg-[#ff601e]"} text-white text-[11px] font-bold rounded-[10px] flex items-center justify-center gap-1.5 transition-all duration-200 border-none disabled:bg-[#c5d5d4] disabled:cursor-not-allowed cursor-pointer`}
// //                               onClick={async (e) => { e.stopPropagation(); if (!localStorage.getItem("authToken")) { setShowLoginPopup(true); return; } await handleAddToCart(item, item.variant[0], 1); await fetchCart(); }}>
// //                               <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
// //                               Add to Cart
// //                             </button>
// //                           )}
// //                         </div>
// //                       </div>
// //                     );
// //                   })}
// //                 </div>

// //                 {/* Mobile scroll */}
// //                 <div className="md:hidden relative">
// //                   <button onClick={() => scrollRef.current?.scrollBy({ left:-200, behavior:"smooth" })} className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#e2eaea] shadow flex items-center justify-center cursor-pointer"><ChevronLeft size={15}/></button>
// //                   <div ref={scrollRef} className="flex gap-3 overflow-x-auto scrollbar-hide px-6 py-2 scroll-smooth">
// //                     {featuredProducts.map((item, index) => {
// //                       const altQty = getCartQuantity(item.variant?.[0]?.variant_id);
// //                       const isOrange = index % 2 === 1;
// //                       const { mrp:tMrp, finalPrice:tFinal, showDiscount:tDisc } = getPriceFromVariant(item.variant?.[0]?.mrp, item.variant?.[0]?.discounted_price);
// //                       const isOOS = OutOfQuantityCheck(item.variant||[]);
// //                       return (
// //                         <div key={item.product_id||index}
// //                           className={`flex-shrink-0 w-[150px] rounded-[18px] border-[1.5px] ${isOrange ? "border-[#ffd5c2]" : "border-[#e2eaea]"} bg-white overflow-hidden flex flex-col cursor-pointer shadow-[0_2px_10px_rgba(22,44,42,0.07)]`}>
// //                           <div className={`h-[110px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#f4fbfa]"} flex items-center justify-center p-3 pt-6`}
// //                             onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                             <img src={item?.product_images?.image_url?.primary_image||"/default.svg"} alt={item.name} onError={(e) => { e.target.onerror=null; e.target.src="/default.svg"; }} className="max-h-full max-w-full object-contain"/>
// //                           </div>
// //                           <div className="w-full h-px bg-[#f1f5f5]"/>
// //                           <div className="p-2.5 flex-1" onClick={() => handleclickforfeaturedproduct(item.product_id, item)}>
// //                             <p className="text-[11px] font-semibold text-[#1e4a46] line-clamp-2 mb-1">{item.name}</p>
// //                             {tMrp > 0 ? (
// //                               <div className="flex items-baseline gap-1 flex-wrap">
// //                                 {tDisc && <span className="text-[10px] text-[#8faba9] line-through">₹{tMrp}</span>}
// //                                 <span className="text-[13px] font-black text-[#1e4a46]">₹{tFinal}</span>
// //                               </div>
// //                             ) : <span className="text-[11px] text-[#8faba9]">N/A</span>}
// //                           </div>
// //                           <div className="px-2.5 pb-2.5">
// //                             {altQty > 0 ? (
// //                               <div className="flex items-center justify-between bg-[#eaf4f3] border border-[#d4ecea] rounded-xl h-8 px-2">
// //                                 <button onClick={(e) => handleDecreaseForTrending(e, item.variant[0], item)} className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base cursor-pointer">−</button>
// //                                 <span className="font-black text-[12px] text-[#1e4a46]">{altQty}</span>
// //                                 <button onClick={(e) => handleIncreaseForTrending(e, item.variant[0], item)} className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base cursor-pointer">+</button>
// //                               </div>
// //                             ) : (
// //                               <button disabled={isOOS}
// //                                 className={`w-full h-8 ${isOrange ? "bg-[#ff601e]" : "bg-[#1e4a46]"} text-white text-[10px] font-bold rounded-[10px] flex items-center justify-center gap-1 border-none disabled:bg-[#c5d5d4] cursor-pointer`}
// //                                 onClick={async (e) => { e.stopPropagation(); if (!localStorage.getItem("authToken")) { setShowLoginPopup(true); return; } await handleAddToCart(item, item.variant[0], 1); await fetchCart(); }}>
// //                                 <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
// //                                 Add
// //                               </button>
// //                             )}
// //                           </div>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                   <button onClick={() => scrollRef.current?.scrollBy({ left:200, behavior:"smooth" })} className="absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#e2eaea] shadow flex items-center justify-center cursor-pointer"><ChevronRight size={15}/></button>
// //                 </div>
// //               </div>
// //             )}
// //           </>
// //         ) : (
// //           /* ── Empty cart ── */
// //           <div className="flex flex-col items-center justify-center py-20 gap-5">
// //             <div className="w-48 h-48">
// //               <DotLottieReact src="https://lottie.host/66e677d4-91a1-4f1a-85e7-a7d1faf607b8/dBHVRTKEJU.lottie" loop autoplay/>
// //             </div>
// //             <div className="text-center">
// //               <p className="font-black text-[22px] text-[#1e4a46] mb-2" style={{ fontFamily:"'Nunito',sans-serif" }}>Your cart is empty</p>
// //               <p className="text-[14px] text-[#8faba9] max-w-[280px] mx-auto">Go ahead and add products to start shopping!</p>
// //             </div>
// //             <Link to="/home">
// //               <button className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[14px] px-8 h-11 rounded-2xl transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.28)] cursor-pointer">
// //                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
// //                 Start Shopping
// //               </button>
// //             </Link>
// //           </div>
// //         )}
// //       </div>

// //       {/* ══ DELETE MODAL ══ */}
// //       <DeletePromptForCart showModal={showModal} onDelete={confirmDelete} onCancel={() => setShowModal(false)} data={deleteData}/>

// //       {/* ══ PRESCRIPTION UPLOAD MODAL ══ */}
// //       {showPrescriptionModal && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins p-4" style={{ zIndex:99999 }}>
// //           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[480px] overflow-hidden">
// //             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]"/>
// //             <div className="px-6 py-5 border-b border-[#f1f5f5] flex items-center justify-between">
// //               <div className="flex items-center gap-3">
// //                 <div className="w-10 h-10 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl flex items-center justify-center">
// //                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ff601e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
// //                 </div>
// //                 <div>
// //                   <h2 className="text-[16px] font-black text-[#1e4a46]" style={{ fontFamily:"'Nunito',sans-serif" }}>Upload Prescription</h2>
// //                   <p className="text-[11px] text-[#8faba9]">JPG, PNG or PDF · Max 5MB</p>
// //                 </div>
// //               </div>
// //               <button onClick={() => setShowPrescriptionModal(false)} className="w-8 h-8 rounded-xl border border-[#e2eaea] bg-white flex items-center justify-center hover:border-[#5fbdb3] transition-all cursor-pointer">
// //                 <X size={14} className="text-[#8faba9]"/>
// //               </button>
// //             </div>

// //             <div className="p-6 flex flex-col gap-4">
// //               {/* Prescription items list */}
// //               <div>
// //                 <p className="text-[11px] font-bold text-[#374747] uppercase tracking-wide mb-2">Requires Prescription:</p>
// //                 <div className="flex flex-col gap-1.5">
// //                   {itemsInCartInCart.filter((it) => it.prescription_required==="Yes").map((it) => (
// //                     <div key={it.variant_id} className="flex items-center gap-2 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-3 py-2">
// //                       <img src={it.image} alt={it.name} className="w-8 h-8 object-contain rounded-lg bg-white border border-[#ffd5c2] flex-shrink-0" onError={(e) => { e.target.onerror=null; e.target.src="/default.svg"; }}/>
// //                       <p className="text-[12px] font-semibold text-[#ff601e] flex-1 line-clamp-1">{it.name}</p>
// //                       <span className="text-[10px] font-bold text-[#ff601e] bg-white border border-[#ffd5c2] px-2 py-0.5 rounded-full flex-shrink-0">Rx</span>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* Upload area */}
// //               <div
// //                 onClick={() => prescriptionInputRef.current?.click()}
// //                 className={`border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer transition-all duration-200
// //                   ${prescriptionFile ? "border-[#5fbdb3] bg-[#f4fbfa]" : "border-[#e2eaea] hover:border-[#5fbdb3] hover:bg-[#f4fbfa]"}`}
// //               >
// //                 {prescriptionFile ? (
// //                   <div className="flex items-center justify-center gap-3">
// //                     <div className="w-10 h-10 bg-[#eaf4f3] border border-[#d4ecea] rounded-xl flex items-center justify-center flex-shrink-0">
// //                       <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
// //                     </div>
// //                     <div className="text-left">
// //                       <p className="text-[13px] font-bold text-[#1e4a46]">{prescriptionFile.name}</p>
// //                       <p className="text-[11px] text-[#8faba9]">{(prescriptionFile.size/1024/1024).toFixed(2)} MB · Click to change</p>
// //                     </div>
// //                   </div>
// //                 ) : (
// //                   <>
// //                     <div className="w-12 h-12 bg-[#eaf4f3] border border-[#d4ecea] rounded-2xl flex items-center justify-center mx-auto mb-3">
// //                       <Upload size={20} className="text-[#5fbdb3]"/>
// //                     </div>
// //                     <p className="text-[14px] font-bold text-[#1e4a46] mb-1">Click to upload your prescription</p>
// //                     <p className="text-[12px] text-[#8faba9]">or drag and drop here</p>
// //                     <p className="text-[11px] text-[#8faba9] mt-2">JPG, PNG or PDF · Maximum 5MB</p>
// //                   </>
// //                 )}
// //               </div>

// //               <input
// //                 ref={prescriptionInputRef}
// //                 type="file"
// //                 accept=".jpg,.jpeg,.png,.pdf"
// //                 className="hidden"
// //                 onChange={(e) => { if (e.target.files?.[0]) handlePrescriptionSelect(e.target.files[0]); }}
// //               />

// //               <div className="flex gap-3">
// //                 <button onClick={() => { setShowPrescriptionModal(false); setPrescriptionFile(null); }}
// //                   className="flex-1 py-2.5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer bg-white">
// //                   Cancel
// //                 </button>
// //                 <button
// //                   onClick={uploadPrescription}
// //                   disabled={!prescriptionFile || uploadingPrescription}
// //                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold flex items-center justify-center gap-2 transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
// //                 >
// //                   {uploadingPrescription && <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"/>}
// //                   {uploadingPrescription ? "Uploading…" : "Confirm Upload"}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ══ CLEAR CART ══ */}
// //       {showConfirm && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins" style={{ zIndex:99999 }}>
// //           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[320px] shadow-2xl">
// //             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]"/>
// //             <div className="p-6">
// //               <h2 className="text-[16px] font-bold text-white mb-2" style={{ fontFamily:"'Nunito',sans-serif" }}>Clear entire cart?</h2>
// //               <p className="text-[13px] text-[#7abcb8] mb-5">All items will be removed permanently.</p>
// //               <div className="flex gap-3">
// //                 <button onClick={() => setShowConfirm(false)} className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all bg-transparent cursor-pointer">Cancel</button>
// //                 <button onClick={handleClearCart} className="flex-1 py-2.5 rounded-xl bg-red-500 hover:bg-red-600 text-white text-[13px] font-extrabold uppercase tracking-widest transition-all border-none cursor-pointer">Clear</button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ══ COD CONFIRM ══ */}
// //       {isCODConfirmPopUp && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins" style={{ zIndex:99999 }}>
// //           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[340px] shadow-2xl">
// //             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]"/>
// //             <div className="p-6">
// //               <h2 className="text-[16px] font-bold text-white mb-2" style={{ fontFamily:"'Nunito',sans-serif" }}>Confirm COD Order</h2>
// //               <p className="text-[13px] text-[#7abcb8] mb-5">Place this order with <strong className="text-white">Cash on Delivery</strong>?</p>
// //               <div className="flex gap-3">
// //                 <button onClick={() => { setIsCODConfirmPopUp(false); setIsProcessing(false); }} disabled={isCODProcessing}
// //                   className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all disabled:opacity-50 bg-transparent cursor-pointer">Cancel</button>
// //                 <button onClick={handleCODOrder} disabled={isCODProcessing}
// //                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-extrabold uppercase tracking-widest flex items-center justify-center gap-2 transition-all border-none disabled:opacity-70 cursor-pointer">
// //                   {isCODProcessing && <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"/>}
// //                   Confirm
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ══ ADDRESS REQUIRED ══ */}
// //       {showAddressPrompt && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins" style={{ zIndex:99999 }}>
// //           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
// //             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]"/>
// //             <div className="p-6 text-center">
// //               <div className="w-14 h-14 bg-[#eaf4f3] rounded-full flex items-center justify-center mx-auto mb-4"><MapPin size={24} className="text-[#1e4a46]"/></div>
// //               <h2 className="text-[18px] font-bold text-[#1e4a46] mb-2" style={{ fontFamily:"'Nunito',sans-serif" }}>Address Required</h2>
// //               <p className="text-[13px] text-[#8faba9] mb-6">Please add a delivery address to proceed.</p>
// //               <div className="flex gap-3">
// //                 <button onClick={() => setShowAddressPrompt(false)} className="flex-1 py-2.5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer">Cancel</button>
// //                 <button onClick={() => { setShowAddressPrompt(false); setPopupOpen(true); }} className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer">Add Address</button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ══ BRANCH REQUIRED ══ */}
// //       {showBranchPrompt && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins" style={{ zIndex:99999 }}>
// //           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
// //             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]"/>
// //             <div className="p-6 text-center">
// //               <div className="w-14 h-14 bg-[#eaf4f3] rounded-full flex items-center justify-center mx-auto mb-4">
// //                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1e4a46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
// //               </div>
// //               <h2 className="text-[18px] font-bold text-[#1e4a46] mb-2" style={{ fontFamily:"'Nunito',sans-serif" }}>Branch Required</h2>
// //               <p className="text-[13px] text-[#8faba9] mb-6">Please select a store pickup location to proceed.</p>
// //               <button onClick={() => setShowBranchPrompt(false)} className="w-full py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer">Got it</button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ══ EDIT ADDRESS ══ */}
// //       {isEditPopupOpen && selectedAddress && (
// //         <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins p-4" style={{ zIndex:99999 }}>
// //           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[540px] overflow-hidden">
// //             <div className="bg-[#162c2a] flex items-center justify-between px-6 py-4">
// //               <img src={logo} alt="Logo" className="h-8 object-contain"/>
// //               <button onClick={() => { setIsEditPopupOpen(false); setSelectedAddress(null); }} className="text-white/70 hover:text-white transition-colors cursor-pointer">
// //                 <X size={16}/>
// //               </button>
// //             </div>
// //             <div className="p-6 max-h-[80vh] overflow-y-auto">
// //               <h2 className="text-[18px] font-bold text-[#1e4a46] mb-5" style={{ fontFamily:"'Nunito',sans-serif" }}>Edit Address</h2>
// //               <div className="flex flex-col gap-4">
// //                 {[{ label:"Name *", name:"address_title", max:25 }, { label:"Address Line 1 *", name:"address_line_1", max:120 }, { label:"Address Line 2", name:"address_line_2", max:20 }, { label:"Pincode *", name:"pincode", max:6, inputMode:"numeric" }, { label:"Mobile Number *", name:"mobile_number", max:10, inputMode:"numeric" }].map((f) => (
// //                   <div key={f.name}>
// //                     <label className="text-[12px] font-bold text-[#374747] mb-1.5 block">{f.label}</label>
// //                     <input type="text" name={f.name} value={selectedAddress[f.name]||""} maxLength={f.max} inputMode={f.inputMode} onChange={handleChange}
// //                       className="w-full h-10 rounded-xl border border-[#e2eaea] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors"/>
// //                     {addressErrors[f.name] && <p className="text-[11px] text-red-500 mt-1">{addressErrors[f.name]}</p>}
// //                   </div>
// //                 ))}
// //                 <div>
// //                   <label className="text-[12px] font-bold text-[#374747] mb-1.5 block">State *</label>
// //                   <select name="state" value={selectedAddress.state||""} onChange={handleChange}
// //                     className="w-full h-10 rounded-xl border border-[#e2eaea] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors bg-white">
// //                     <option value="">Select State</option>
// //                     {indianStates.map((st) => <option key={st} value={st}>{st}</option>)}
// //                   </select>
// //                   {addressErrors.state && <p className="text-[11px] text-red-500 mt-1">{addressErrors.state}</p>}
// //                 </div>
// //                 <div>
// //                   <label className="text-[12px] font-bold text-[#374747] mb-2 block">Set as default?</label>
// //                   <div className="flex gap-4">
// //                     {[{ val:true, label:"Yes" }, { val:false, label:"No" }].map((opt) => (
// //                       <label key={String(opt.val)} className="flex items-center gap-2 cursor-pointer">
// //                         <RadioDot active={selectedAddress.is_default===opt.val}/>
// //                         <span className="text-[13px] text-[#374747]" onClick={() => handleChange({ target:{ name:"is_default", value:opt.val } })}>{opt.label}</span>
// //                       </label>
// //                     ))}
// //                   </div>
// //                 </div>
// //                 <div className="flex gap-3 pt-2">
// //                   <button onClick={() => { setIsEditPopupOpen(false); setSelectedAddress(null); }} className="flex-1 py-2.5 rounded-xl border border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer">Cancel</button>
// //                   <button onClick={handleUpdateAddress} disabled={!isEditFormValid} className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">Save Changes</button>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {isPopupOpen && <Adresspopup onClose={() => setPopupOpen(false)} fetchAddresses={fetchAddresses}/>}

// //       <style>{`
// //         @keyframes fadeInUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
// //         .scrollbar-hide::-webkit-scrollbar { display:none; }
// //         .scrollbar-hide { -ms-overflow-style:none; scrollbar-width:none; }
// //       `}</style>
// //     </div>
// //   );
// // };

// // export default Cartpage;
// import Adresspopup from "./Adresspopup";
// import {
//   ChevronLeft,
//   ChevronRight,
//   MapPin,
//   Upload,
//   CheckCircle,
//   AlertCircle,
//   X,
// } from "lucide-react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import logo from "../images/logo.png";
// import { useNavigate } from "react-router-dom";
// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { useCart } from "../Context/Createcontext";
// import { toast } from "react-hot-toast";
// import DeletePromptForCart from "../Components/common/DeletePromptForCart";
// import { Helmet } from "react-helmet";
// import { api_url } from "../config/config";
// import addToCartIcon from "../Icons/addToCartIcon.svg";
// import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// import wish from "../images/wish.svg";
// import wishlist from "../images/wishlist_nofill.svg";
// import { useWishlist } from "../Context/WishlistContext";
// import loader from "../images/loaderimg.png";

// /* ─────────────────────────────────────────────────────
//    PRICE HELPER
//    variant.mrp (string|null) → original price
//    variant.discounted_price (number|null) → sale price
//    Rules:
//    • disc > 0 AND disc < mrp → show strikethrough mrp + disc + badge
//    • otherwise → show only mrp, no strikethrough, no badge
// ───────────────────────────────────────────────────── */
// const getPriceFromVariant = (mrp, discountedPrice) => {
//   const _mrp = parseFloat(mrp) || 0;
//   const _disc = parseFloat(discountedPrice) || 0;
//   if (_mrp <= 0) return { mrp: 0, finalPrice: 0, showDiscount: false };
//   const showDiscount = _disc > 0 && _disc < _mrp;
//   return { mrp: _mrp, finalPrice: showDiscount ? _disc : _mrp, showDiscount };
// };

// /* ── Helpers ── */
// const loadScript = (src) =>
//   new Promise((resolve) => {
//     const s = document.createElement("script");
//     s.src = src;
//     s.onload = () => resolve(true);
//     s.onerror = () => resolve(false);
//     document.body.appendChild(s);
//   });

// const RadioDot = ({ active }) => (
//   <div
//     className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${active ? "border-[#1e4a46]" : "border-[#c8d8d7]"}`}
//   >
//     {active && <div className="w-[7px] h-[7px] rounded-full bg-[#1e4a46]" />}
//   </div>
// );

// const SCardHead = ({ icon, title, badge }) => (
//   <div className="bg-[#e8f5f4] border-b border-[#c8d8d7] px-4 py-3 flex items-center gap-2.5">
//     <div className="w-7 h-7 rounded-[8px] bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center flex-shrink-0">
//       {icon}
//     </div>
//     <span className="text-[13px] font-bold text-[#1e4a46] flex-1">{title}</span>
//     {badge && (
//       <span className="bg-[#ddf0ee] border border-[#aac9c7] text-[#1e4a46] text-[10px] font-bold px-2 py-0.5 rounded-full">
//         {badge}
//       </span>
//     )}
//   </div>
// );

// const indianStates = [
//   "Andhra Pradesh",
//   "Arunachal Pradesh",
//   "Assam",
//   "Bihar",
//   "Chhattisgarh",
//   "Goa",
//   "Gujarat",
//   "Haryana",
//   "Himachal Pradesh",
//   "Jharkhand",
//   "Karnataka",
//   "Kerala",
//   "Madhya Pradesh",
//   "Maharashtra",
//   "Manipur",
//   "Meghalaya",
//   "Mizoram",
//   "Nagaland",
//   "Odisha",
//   "Punjab",
//   "Rajasthan",
//   "Sikkim",
//   "Tamil Nadu",
//   "Telangana",
//   "Tripura",
//   "Uttar Pradesh",
//   "Uttarakhand",
//   "West Bengal",
//   "Andaman and Nicobar Islands",
//   "Chandigarh",
//   "Dadra and Nagar Haveli and Daman and Diu",
//   "Delhi",
//   "Jammu and Kashmir",
//   "Ladakh",
//   "Lakshadweep",
//   "Puducherry",
// ];

// /* ════════════════════════════════════════════════════ */
// const Cartpage = ({ onClose }) => {
//   const navigate = useNavigate();
//   const {
//     handleAddToCart,
//     showLoginPopup,
//     setShowLoginPopup,
//     handleRemoveFromCart,
//     setCartCount,
//     setCartItems,
//   } = useCart();
//   const {
//     wishlist: wishlistItems,
//     addToWishlist,
//     removeFromWishlist,
//     loading: wishlistLoading,
//   } = useWishlist();

//   /* ── State ── */
//   const [itemsInCartInCart, setCartItemsInCart] = useState([]);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [currentFeatured, setCurrentFeatured] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [quantities, setQuantities] = useState({});
//   const [selectedDeliveryOption, setSelectedDeliveryOption] = useState("home");
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [deleteData, setDeleteData] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [isCODProcessing, setIsCODProcessing] = useState(false);
//   const [isCODConfirmPopUp, setIsCODConfirmPopUp] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [paymentMode, setPaymentMode] = useState("ONLINE");
//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddressId, setSelectedAddressId] = useState(null);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
//   const [branches, setBranches] = useState([]);
//   const [selectedBranchId, setSelectedBranchId] = useState(null);
//   const [hasFetchedBranches, setHasFetchedBranches] = useState(false);
//   const [hasFetchedAddresses, setHasFetchedAddresses] = useState(false);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [originalTotal, setOriginalTotal] = useState(0);
//   const [totalSaved, setTotalSaved] = useState(0);
//   const [total, setTotal] = useState(0);
//   const [bill, setBill] = useState({ discount: 0, delivery_fees: 0 });
//   const [addressErrors, setAddressErrors] = useState({
//     address_title: "",
//     address_line_1: "",
//     address_line_2: "",
//     pincode: "",
//     state: "",
//     mobile_number: "",
//   });
//   const [showAddressPrompt, setShowAddressPrompt] = useState(false);
//   const [showBranchPrompt, setShowBranchPrompt] = useState(false);

//   /* ── Prescription state ── */
//   const [prescriptionFile, setPrescriptionFile] = useState(null); // File object
//   const [prescriptionUploaded, setPrescriptionUploaded] = useState(false); // successfully uploaded
//   const [prescriptionUrl, setPrescriptionUrl] = useState(null); // URL after upload
//   const [uploadingPrescription, setUploadingPrescription] = useState(false);
//   const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
//   const prescriptionInputRef = useRef(null);

//   const scrollRef = useRef(null);
//   const shipping = "Free";
//   const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
//   const itemsPerPage = 8;
//   const totalPages = Math.ceil(featuredProducts.length / itemsPerPage);

//   const nameRegex = /^[A-Za-z\s]+$/;
//   const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
//   const pincodeRegex = /^\d{6}$/;
//   const mobileRegex = /^\d{10}$/;

//   /* ── Check if any cart item requires prescription ── */
//   const hasPrescriptionItems = itemsInCartInCart.some(
//     (it) => it.prescription_required === "Yes",
//   );

//   const getCartQuantity = (vid) => {
//     const it = itemsInCartInCart.find((ci) => ci.variant_id === vid);
//     return it ? it.quantity : 0;
//   };
//   const OutOfQuantityCheck = (variants) =>
//     variants.every((v) => !v.quantity || v.quantity === 0);

//   /* ── Lifecycle ── */
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   useEffect(() => {
//     const upd = itemsInCartInCart.reduce((acc, it) => {
//       acc[it.variant_id] = it.quantity;
//       return acc;
//     }, {});
//     setQuantities(upd);
//   }, [itemsInCartInCart]);
//   useEffect(() => {
//     if (itemsInCartInCart.length > 0) {
//       let disc = 0,
//         discTotal = 0;
//       itemsInCartInCart.forEach((it) => {
//         disc += (it.mrp - it.finalPrice) * it.quantity;
//         discTotal += it.finalPrice * it.quantity;
//       });
//       setBill({ discount: disc, delivery_fees: 0, total: discTotal });
//     }
//   }, [itemsInCartInCart]);
//   useEffect(() => {
//     if (selectedDeliveryOption === "pickup" && !hasFetchedBranches) {
//       fetchBranches();
//       setHasFetchedBranches(true);
//     }
//     if (selectedDeliveryOption === "home" && !hasFetchedAddresses) {
//       fetchAddresses();
//       setHasFetchedAddresses(true);
//     }
//   }, [selectedDeliveryOption]);
//   useEffect(() => {
//     const s = currentIndex * itemsPerPage;
//     setCurrentFeatured(featuredProducts.slice(s, s + itemsPerPage));
//   }, [currentIndex, featuredProducts]);

//   /* ── Fetch ── */
//   const fetchCart = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${api_url}/cart`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//       });
//       const data = await res.json();
//       if (res.ok) {
//         const fp = data.data.cartproduct.map((it) => {
//           /* API: variant.mrp (string), variant.discounted_price (number|null) */
//           const { mrp, finalPrice, showDiscount } = getPriceFromVariant(
//             it.variant?.mrp,
//             it.variant?.discounted_price,
//           );
//           return {
//             product_id: it.product_id,
//             variant_id: it.variant_id,
//             quantity: Number(it.quantity),
//             manufacturer:
//               it.product?.Manufacturer?.name ??
//               it.product?.manufacturer?.manufacturer_name ??
//               "N/A",
//             name: it.product?.name ?? "Unnamed Product",
//             image:
//               it.product?.product_images?.image_url?.primary_image ??
//               `${api_url}/default-image.jpg`,
//             mrp,
//             finalPrice,
//             showDiscount,
//             discount_price: Math.max(mrp - finalPrice, 0),
//             pack_size: it.variant?.pack_size ?? "-",
//             discount_percent: it.product?.discount_percent ?? 0,
//             prescription_required: it.product?.prescription_required ?? "No",
//           };
//         });
//         setCartItemsInCart(fp);
//         setCartCount(fp.length);
//         calculateSummary(fp);
//       }
//     } catch {
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchFeaturedProduct = async () => {
//     try {
//       if (!localStorage.getItem("authToken")) return;
//       const res = await fetch(`${api_url}/cart-list-products`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           "x-auth": "false",
//         },
//       });
//       const data = await res.json();
//       setFeaturedProducts(data.data || []);
//     } catch {}
//   };

//   const fetchAddresses = async () => {
//     try {
//       if (!localStorage.getItem("authToken")) return;
//       const res = await axios.get(`${api_url}/address/users`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//       });
//       if (res.data.data.length > 0) {
//         const withBool = res.data.data.map((a) => ({
//           ...a,
//           is_default: a.is_default === true || a.is_default === "true",
//         }));
//         setAddresses(withBool);
//         const def = withBool.find((a) => a.is_default) || withBool[0];
//         setSelectedAddressId(def.address_id);
//         setSelectedAddress(def);
//       } else {
//         setAddresses([]);
//         setSelectedAddress(null);
//       }
//     } catch {}
//   };

//   const fetchBranches = async () => {
//     try {
//       const res = await axios.get(`${api_url}/branches`);
//       const raw = res.data.results || [];
//       setBranches([...new Map(raw.map((b) => [b.branch_id, b])).values()]);
//     } catch {}
//   };

//   useEffect(() => {
//     fetchCart();
//     fetchFeaturedProduct();
//     fetchAddresses();
//   }, []);

//   const calculateSummary = (items) => {
//     let orig = 0,
//       sub = 0,
//       saved = 0;
//     items.forEach((it) => {
//       const o = it.mrp * it.quantity;
//       const d = it.finalPrice * it.quantity;
//       orig += o;
//       sub += d;
//       saved += o - d;
//     });
//     setOriginalTotal(orig);
//     setTotal(sub);
//     setTotalSaved(saved);
//   };

//   /* ── Prescription upload ── */
//   const handlePrescriptionSelect = (file) => {
//     if (!file) return;
//     const allowed = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
//     if (!allowed.includes(file.type)) {
//       toast.error("Only JPG, PNG or PDF files allowed");
//       return;
//     }
//     if (file.size > 5 * 1024 * 1024) {
//       toast.error("File must be under 5MB");
//       return;
//     }
//     setPrescriptionFile(file);
//     setPrescriptionUploaded(false);
//     setPrescriptionUrl(null);
//   };
// const uploadPrescription = async () => {
//   if (uploadingPrescription) return;

//   const authToken = localStorage.getItem("authToken");

//   if (!authToken) {
//     toast.error("Please log in.");
//     return;
//   }

//   if (!prescriptionFile) {
//     toast.error("No file selected.");
//     return;
//   }

//   setUploadingPrescription(true);
//   setLoading(true);

//   try {
//     const formData = new FormData();
//     formData.append("prescription_file", prescriptionFile); // match backend key
//     // Optional: if you have notes
//     // formData.append("description_notes", prescriptionNotes);

//     const res = await axios.post(`${api_url}/prescription`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${authToken}`,
//       },
//     });

//     const uploadedUrl = res.data?.url || res.data?.data?.url;

//     if (uploadedUrl) {
//       setPrescriptionUrl(uploadedUrl);
//     }

//     setPrescriptionUploaded(true);
//     setShowPrescriptionModal(false);

//     // Reset state (important)
//     setPrescriptionFile(null);

//     toast.success(
//       "Prescription uploaded successfully. Our team will reach you soon."
//     );

//   } catch (error) {
//     console.error(error);
//     toast.error("Failed to upload prescription.");
//   } finally {
//     setUploadingPrescription(false);
//     setLoading(false);
//   }
// };

//   /* ── Cart actions ── */
//   const handleQuantityChange = async (
//     productId,
//     variant_id,
//     quantity,
//     productName,
//     operation,
//   ) => {
//     if (!productId || !variant_id || typeof quantity !== "number") return;
//     const newQty = operation === "increase" ? quantity + 1 : quantity - 1;
//     try {
//       const res = await fetch(`${api_url}/cart`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//         body: JSON.stringify({
//           product_id: productId,
//           quantity: newQty,
//           variant_id,
//         }),
//       });
//       const data = await res.json();
//       if (!res.ok) {
//         if (data.message?.toLowerCase().includes("stock not available"))
//           toast.error(`${productName} is out of stock`);
//         return;
//       }
//       setCartItemsInCart((prev) =>
//         prev.map((it) =>
//           it.product_id === productId && it.variant_id === variant_id
//             ? { ...it, quantity: newQty }
//             : it,
//         ),
//       );
//       setCartItems((prev) =>
//         prev.map((it) =>
//           it.product_id === productId && it.variant_id === variant_id
//             ? { ...it, quantity: newQty }
//             : it,
//         ),
//       );
//     } catch {}
//   };

//   const handleIncrease = (e, item) => {
//     e.preventDefault();
//     handleQuantityChange(
//       item.product_id,
//       item.variant_id,
//       item.quantity,
//       item.name,
//       "increase",
//     );
//   };
//   const handleDecrease = (e, item) => {
//     e.preventDefault();
//     if (item.quantity > 1)
//       handleQuantityChange(
//         item.product_id,
//         item.variant_id,
//         item.quantity,
//         item.name,
//         "decrease",
//       );
//   };

//   const handleIncreaseForTrending = async (e, variant, item) => {
//     e.preventDefault();
//     const qty = getCartQuantity(variant.variant_id);
//     const res = await fetch(`${api_url}/cart`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//       },
//       body: JSON.stringify({
//         product_id: variant.product_id,
//         quantity: qty + 1,
//         variant_id: variant.variant_id,
//       }),
//     });
//     const d = await res.json();
//     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
//       toast.error(`${item.name} is out of stock`);
//       return;
//     }
//     const n = itemsInCartInCart.map((it) =>
//       it.variant_id === variant.variant_id
//         ? { ...it, quantity: it.quantity + 1 }
//         : it,
//     );
//     setCartItemsInCart(n);
//     setCartItems(n);
//   };

//   const handleDecreaseForTrending = async (e, variant) => {
//     e.preventDefault();
//     const qty = getCartQuantity(variant.variant_id);
//     if (qty === 1) {
//       handleRemoveFromCart(variant.product_id, variant.variant_id);
//       return;
//     }
//     const res = await fetch(`${api_url}/cart`, {
//       method: "PATCH",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//       },
//       body: JSON.stringify({
//         product_id: variant.product_id,
//         quantity: qty - 1,
//         variant_id: variant.variant_id,
//       }),
//     });
//     const d = await res.json();
//     if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
//       toast.error("Something went wrong");
//       return;
//     }
//     const n = itemsInCartInCart.map((it) =>
//       it.variant_id === variant.variant_id
//         ? { ...it, quantity: it.quantity - 1 }
//         : it,
//     );
//     setCartItemsInCart(n);
//     setCartItems(n);
//   };

//   const handleDeleteClick = (productId, variantId, data) => {
//     setSelectedProduct({ productId, variantId });
//     setDeleteData(data);
//     setShowModal(true);
//   };
//   const confirmDelete = async () => {
//     if (selectedProduct) {
//       try {
//         await handleRemoveFromCart(
//           selectedProduct.productId,
//           selectedProduct.variantId,
//         );
//       } catch {
//       } finally {
//         setCartItemsInCart((p) =>
//           p.filter(
//             (it) =>
//               !(
//                 it.product_id === selectedProduct.productId &&
//                 it.variant_id === selectedProduct.variantId
//               ),
//           ),
//         );
//         setCartItems((p) =>
//           p.filter(
//             (it) =>
//               !(
//                 it.product_id === selectedProduct.productId &&
//                 it.variant_id === selectedProduct.variantId
//               ),
//           ),
//         );
//         setSelectedProduct(null);
//         setShowModal(false);
//       }
//     } else setShowModal(false);
//   };

//   const handleClearCart = async () => {
//     try {
//       const res = await axios.delete(`${api_url}/carts`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//       });
//       if (res.status === 200) {
//         setCartItemsInCart([]);
//         setCartItems([]);
//         setCartCount(0);
//         setShowConfirm(false);
//         toast.success("Cart cleared");
//       }
//     } catch {
//       toast.error("Failed to clear cart");
//     }
//   };

//   const handleclickforfeaturedproduct = (product_id, product) =>
//     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, "-")}`, {
//       state: { product_id },
//     });

//   /* ── Address edit ── */
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     let s = value;
//     if (name === "address_title") s = value.replace(/[^A-Za-z\s]/g, "");
//     else if (name === "address_line_1" || name === "address_line_2")
//       s = value.replace(/[^A-Za-z0-9\s,./\-#]/g, "");
//     else if (name === "pincode") s = value.replace(/\D/g, "").slice(0, 6);
//     else if (name === "mobile_number")
//       s = value.replace(/\D/g, "").slice(0, 10);
//     setSelectedAddress((prev) => ({ ...(prev || {}), [name]: s }));
//   };

//   const isEditFormValid = React.useMemo(() => {
//     if (!selectedAddress) return false;
//     const t = selectedAddress.address_title?.trim() || "";
//     const l1 = selectedAddress.address_line_1?.trim() || "";
//     const l2 = selectedAddress.address_line_2?.trim() || "";
//     const pin = (selectedAddress.pincode || "").toString();
//     const mob = (selectedAddress.mobile_number || "").toString();
//     const st = selectedAddress.state || "";
//     return (
//       nameRegex.test(t) &&
//       l1.length > 0 &&
//       addressLineRegex.test(l1) &&
//       (l2 === "" || addressLineRegex.test(l2)) &&
//       pincodeRegex.test(pin) &&
//       mobileRegex.test(mob) &&
//       st !== ""
//     );
//   }, [selectedAddress]);

//   const updateAddress = async (addressId, addr) => {
//     try {
//       await axios.patch(
//         `${api_url}/address/${addressId}`,
//         {
//           address_title: addr.address_title,
//           address_line_1: addr.address_line_1,
//           address_line_2: addr.address_line_2,
//           pincode: addr.pincode,
//           city: addr.city,
//           state: addr.state,
//           mobile_number: addr.mobile_number,
//           is_default: addr.is_default,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         },
//       );
//       await fetchAddresses();
//       toast.success("Address updated!");
//       setIsEditPopupOpen(false);
//     } catch {
//       toast.error("Failed to update address.");
//     }
//   };

//   const handleUpdateAddress = () => {
//     if (!selectedAddress) return;
//     const errors = {
//       address_title: !selectedAddress.address_title?.trim()
//         ? "Required"
//         : !nameRegex.test(selectedAddress.address_title.trim())
//           ? "Letters only"
//           : "",
//       address_line_1: !selectedAddress.address_line_1?.trim() ? "Required" : "",
//       address_line_2: "",
//       pincode: !pincodeRegex.test((selectedAddress.pincode || "").toString())
//         ? "6-digit pincode"
//         : "",
//       state: !selectedAddress.state ? "Required" : "",
//       mobile_number: !mobileRegex.test(
//         (selectedAddress.mobile_number || "").toString(),
//       )
//         ? "10-digit number"
//         : "",
//     };
//     setAddressErrors(errors);
//     if (Object.values(errors).some((m) => m)) {
//       toast.error("Please fix the highlighted fields");
//       return;
//     }
//     updateAddress(selectedAddress.address_id, selectedAddress);
//   };

//   /* ── Payment ── */
//   const getOutOfStockProductName = (msg) => {
//     const m = msg?.match(/Product (.*?) is out of stock/);
//     return m
//       ? itemsInCartInCart.find((p) => p.id === m[1])?.name || null
//       : null;
//   };

//   const buildOrderPayload = (paymentType) => ({
//     products: itemsInCartInCart.map((it) => ({
//       product_id: it.product_id,
//       variant_id: it.variant_id,
//       quantity: it.quantity,
//       price: it.finalPrice,
//       mrp: it.mrp,
//     })),
//     amount: itemsInCartInCart.reduce(
//       (acc, it) => acc + it.finalPrice * it.quantity,
//       0,
//     ),
//     bill,
//     address_id: selectedDeliveryOption === "home" ? selectedAddressId : null,
//     branch_id: selectedDeliveryOption === "pickup" ? selectedBranchId : null,
//     payment_status: "PENDING",
//     payment_type: paymentType,
//     delivery_type:
//       selectedDeliveryOption === "home" ? "Home_Pickup" : "Store_Pickup",
//     prescription_url: prescriptionUrl || null,
//   });

//   const onPayment = async () => {
//     setIsProcessing(true);
//     if (itemsInCartInCart.length === 0) {
//       toast.error("Cart is empty.");
//       setIsProcessing(false);
//       return;
//     }
//     if (hasPrescriptionItems && !prescriptionUploaded) {
//       toast.error("Please upload a prescription before proceeding.");
//       setShowPrescriptionModal(true);
//       setIsProcessing(false);
//       return;
//     }
//     if (selectedDeliveryOption === "home" && !selectedAddressId) {
//       setIsProcessing(false);
//       setShowAddressPrompt(true);
//       return;
//     }
//     if (selectedDeliveryOption === "pickup" && !selectedBranchId) {
//       setIsProcessing(false);
//       setShowBranchPrompt(true);
//       return;
//     }
//     if (paymentMode === "COD") {
//       setIsProcessing(false);
//       setIsCODConfirmPopUp(true);
//       return;
//     }

//     const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
//     if (!ok) {
//       setIsProcessing(false);
//       return;
//     }
//     try {
//       const uRes = await axios.get(`${api_url}/user`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//       });
//       const uData = uRes.data.data;
//       if (!uData?.name?.trim()) {
//         toast.error("Please complete your profile before payment.");
//         setTimeout(() => navigate("/profilepage"), 1500);
//         return;
//       }

//       const res = await fetch(`${api_url}/api/create-order`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//         body: JSON.stringify(buildOrderPayload("ONLINE")),
//       });
//       const orderData = await res.json();
//       if (!res.ok || !orderData?.razorpayOrder?.id) {
//         const pn = getOutOfStockProductName(orderData?.message);
//         toast.error(
//           pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
//         );
//         setIsProcessing(false);
//         return;
//       }

//       const payObj = new window.Razorpay({
//         key: razorpayKey,
//         order_id: orderData.razorpayOrder.id,
//         ...orderData,
//         handler: async (resp) => {
//           setCartItemsInCart([]);
//           setCartItems([]);
//           setCartCount(0);
//           navigate("/ThankYou");
//           try {
//             await fetch(`${api_url}/api/verify-order`, {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//               },
//               body: JSON.stringify({
//                 order_id: resp.razorpay_order_id,
//                 payment_id: resp.razorpay_payment_id,
//                 signature: resp.razorpay_signature,
//                 orderId: orderData?.data?.order_id,
//               }),
//             });
//           } catch {}
//         },
//         modal: {
//           ondismiss: async () => {
//             try {
//               await axios.post(
//                 `${api_url}/api/failed-payment`,
//                 {
//                   order_id: orderData?.data?.order_id,
//                   razorpay_payment_id: `DISMISSED_${orderData?.data?.order_id}`,
//                   error_source: "popup_closed",
//                   error_description: "User dismissed",
//                   error_step: "payment_initiation",
//                   error_code: "USER_DISMISS",
//                   error_reason: "User cancelled",
//                 },
//                 {
//                   headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//                   },
//                 },
//               );
//             } catch {}
//             toast.error("Payment cancelled");
//             setIsProcessing(false);
//           },
//         },
//       });
//       payObj.on("payment.failed", async (resp) => {
//         try {
//           await axios.post(
//             `${api_url}/api/failed-payment`,
//             {
//               order_id: resp.error.metadata.order_id,
//               razorpay_payment_id: resp.error.metadata.payment_id,
//               error_source: resp.error.source,
//               error_description: resp.error.description,
//               error_step: resp.error.step,
//               error_code: resp.error.code,
//               error_reason: resp.error.reason,
//             },
//             {
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//               },
//             },
//           );
//         } catch {}
//         toast.error("Payment Failed");
//         setIsProcessing(false);
//       });
//       payObj.open();
//     } catch {
//       toast.error("An error occurred. Please try again.");
//       setIsProcessing(false);
//     }
//   };

//   const handleCODOrder = async () => {
//     try {
//       setIsCODProcessing(true);
//       const res = await fetch(`${api_url}/api/create-order`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//         body: JSON.stringify(buildOrderPayload("COD")),
//       });
//       const orderData = await res.json();
//       if (!res.ok) {
//         const pn = getOutOfStockProductName(orderData?.message);
//         toast.error(
//           pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
//         );
//         return;
//       }
//       toast.success("Order placed with COD!");
//       setCartItemsInCart([]);
//       setCartItems([]);
//       setCartCount([]);
//       setIsCODConfirmPopUp(false);
//       navigate("/ThankYou");
//     } catch {
//       toast.error("Failed to place COD order");
//     } finally {
//       setIsCODProcessing(false);
//       setIsProcessing(false);
//     }
//   };

//   const selectedAddrObj = addresses.find(
//     (a) => a.address_id === selectedAddressId,
//   );
//   const selectedBranchObj = branches.find(
//     (b) => b.branch_id === selectedBranchId,
//   );

//   /* ── Can proceed ── */
//   const canProceed = !hasPrescriptionItems || prescriptionUploaded;

//   /* ══════════════════ RENDER ══════════════════ */
//   return (
//     <div className="min-h-screen bg-[#f2f8f7] font-poppins">
//       <Helmet>
//         <title>Shopping Cart | MediSYS Pharmacy</title>
//         <meta name="robots" content="index, follow" />
//       </Helmet>

//       <div className=" mx-auto px-4 sm:px-6 py-6 sm:mt-0 mt-36">
//         {/* Breadcrumb */}
//         <nav className="flex items-center gap-2 text-[12px] text-[#5a7a77] mb-4 font-medium flex-wrap">
//           <Link
//             to="/home"
//             className="hover:text-[#1e4a46] transition-colors text-[#5a7a77]"
//             style={{ textDecoration: "none" }}
//           >
//             Home
//           </Link>
//           <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
//             <path
//               d="M6 12l4-4-4-4"
//               stroke="#8faba9"
//               strokeWidth="1.8"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//           <span className="text-[#1e4a46] font-bold">My Cart</span>
//         </nav>

//         <div className="flex items-center justify-between mb-5">
//           <div>
//             <h1
//               className="text-[22px] font-black text-[#0a1715] mb-0.5"
//               style={{ fontFamily: "'Nunito',sans-serif" }}
//             >
//               My Cart
//             </h1>
//             <p className="text-[13px] text-[#5a7a77] font-medium">
//               Review your items before checkout
//             </p>
//           </div>
//         </div>

//         {loading ? (
//           <div className="flex flex-col items-center justify-center py-24 gap-4">
//             <img
//               src={loader}
//               alt="Loading"
//               className="w-14 h-14 animate-pulse"
//             />
//             <p className="text-[13px] text-[#2d5250] font-medium">
//               Loading cart…
//             </p>
//           </div>
//         ) : itemsInCartInCart.length > 0 ? (
//           <>
//             {/* ════ MAIN 2-COL GRID ════ */}
//             <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] xl:grid-cols-[1fr_400px] gap-5 items-start">
//               {/* ════ LEFT COLUMN ════ */}
//               <div className="flex flex-col gap-4 min-w-0">
//                 {/* ─ ROW 1: Delivery + Payment ─ */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   {/* Delivery Card */}
//                   <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
//                     <SCardHead
//                       title="Delivery Option"
//                       icon={
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="#5fbdb3"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <path d="M1 3h15v13H1z" />
//                           <path d="M16 8h4l3 3v5h-7V8z" />
//                           <circle cx="5.5" cy="18.5" r="2.5" />
//                           <circle cx="18.5" cy="18.5" r="2.5" />
//                         </svg>
//                       }
//                     />
//                     <div className="p-4 flex flex-col gap-3">
//                       {/* Toggle */}
//                       <div className="flex gap-1.5 p-1 bg-[#e8f5f4] rounded-xl border border-[#c8d8d7]">
//                         {[
//                           {
//                             val: "home",
//                             label: "Home Delivery",
//                             icon: (
//                               <>
//                                 <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//                                 <polyline points="9 22 9 12 15 12 15 22" />
//                               </>
//                             ),
//                           },
//                           {
//                             val: "pickup",
//                             label: "Store Pickup",
//                             icon: (
//                               <>
//                                 <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//                                 <circle cx="12" cy="10" r="3" />
//                               </>
//                             ),
//                           },
//                         ].map((opt) => (
//                           <button
//                             key={opt.val}
//                             onClick={() => setSelectedDeliveryOption(opt.val)}
//                             className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-[10px] text-[12px] font-bold transition-all duration-200 border-none cursor-pointer
//                               ${selectedDeliveryOption === opt.val ? "bg-[#1e4a46] text-white shadow-[0_2px_8px_rgba(22,44,42,0.3)]" : "bg-transparent text-[#2d5250] hover:text-[#1e4a46]"}`}
//                           >
//                             <svg
//                               width="11"
//                               height="11"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="2.5"
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                             >
//                               {opt.icon}
//                             </svg>
//                             {opt.label}
//                           </button>
//                         ))}
//                       </div>

//                       {/* Address / Branch */}
//                       {selectedDeliveryOption === "home" ? (
//                         addresses.length > 0 ? (
//                           <div className="flex flex-col gap-2.5">
//                             <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide">
//                               Deliver to
//                             </label>
//                             <div className="relative">
//                               <select
//                                 value={selectedAddressId || ""}
//                                 onChange={(e) => {
//                                   const id = e.target.value;
//                                   setSelectedAddressId(id);
//                                   setSelectedAddress(
//                                     addresses.find(
//                                       (a) => a.address_id === id,
//                                     ) || null,
//                                   );
//                                 }}
//                                 className="w-full appearance-none bg-[#e8f5f4] border-[1.5px] border-[#aac9c7] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer"
//                               >
//                                 {addresses.map((addr) => (
//                                   <option
//                                     key={addr.address_id}
//                                     value={addr.address_id}
//                                   >
//                                     {addr.address_title} — {addr.address_line_1}
//                                     , {addr.city}
//                                   </option>
//                                 ))}
//                               </select>
//                               <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
//                                 <svg
//                                   width="12"
//                                   height="12"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="#5fbdb3"
//                                   strokeWidth="2.5"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <path d="M6 9l6 6 6-6" />
//                                 </svg>
//                               </div>
//                             </div>
//                             {selectedAddrObj && (
//                               <div className="bg-[#e8f5f4] border border-[#aac9c7] rounded-[12px] px-3 py-2.5 flex items-start gap-2">
//                                 <MapPin
//                                   size={13}
//                                   className="text-[#5fbdb3] mt-0.5 flex-shrink-0"
//                                 />
//                                 <div className="flex-1 min-w-0">
//                                   <p className="text-[11px] text-[#1e3330] leading-relaxed">
//                                     {selectedAddrObj.address_line_1}
//                                     {selectedAddrObj.address_line_2
//                                       ? `, ${selectedAddrObj.address_line_2}`
//                                       : ""}
//                                     , {selectedAddrObj.city},{" "}
//                                     {selectedAddrObj.pincode},{" "}
//                                     {selectedAddrObj.state}
//                                   </p>
//                                   <p className="text-[10px] text-[#2d5250] mt-0.5">
//                                     📞 {selectedAddrObj.mobile_number}
//                                   </p>
//                                 </div>
//                                 <button
//                                   className="w-6 h-6 rounded-[7px] border border-[#aac9c7] bg-white flex items-center justify-center flex-shrink-0 hover:border-[#5fbdb3] transition-colors"
//                                   onClick={() => {
//                                     setSelectedAddress({
//                                       ...selectedAddrObj,
//                                       is_default:
//                                         selectedAddrObj.is_default === true ||
//                                         selectedAddrObj.is_default === "true",
//                                     });
//                                     setIsEditPopupOpen(true);
//                                   }}
//                                 >
//                                   <svg
//                                     width="10"
//                                     height="10"
//                                     viewBox="0 0 24 24"
//                                     fill="none"
//                                     stroke="#8faba9"
//                                     strokeWidth="2"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                   >
//                                     <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//                                     <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//                                   </svg>
//                                 </button>
//                               </div>
//                             )}
//                             <button
//                               onClick={() => setPopupOpen(true)}
//                               className="flex items-center gap-1.5 text-[12px] font-semibold text-[#5fbdb3] hover:text-[#1e4a46] transition-colors"
//                             >
//                               <svg
//                                 width="13"
//                                 height="13"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <circle cx="12" cy="12" r="10" />
//                                 <line x1="12" y1="8" x2="12" y2="16" />
//                                 <line x1="8" y1="12" x2="16" y2="12" />
//                               </svg>
//                               Add New Address
//                             </button>
//                           </div>
//                         ) : (
//                           <div className="flex flex-col gap-2 items-center py-3">
//                             <p className="text-[12px] text-[#2d5250] text-center">
//                               No addresses saved yet.
//                             </p>
//                             <button
//                               onClick={() => setPopupOpen(true)}
//                               className="text-[12px] font-semibold text-white bg-[#1e4a46] hover:bg-[#ff601e] px-4 py-2 rounded-xl transition-colors border-none cursor-pointer"
//                             >
//                               Add Address
//                             </button>
//                           </div>
//                         )
//                       ) : (
//                         <div className="flex flex-col gap-2.5">
//                           {branches.length > 0 ? (
//                             <>
//                               <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide">
//                                 Select Store
//                               </label>
//                               <div className="relative">
//                                 <select
//                                   value={selectedBranchId || ""}
//                                   onChange={(e) =>
//                                     setSelectedBranchId(e.target.value)
//                                   }
//                                   className="w-full appearance-none bg-[#e8f5f4] border-[1.5px] border-[#aac9c7] rounded-[12px] px-3 py-2.5 pr-8 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer"
//                                 >
//                                   <option value="">Choose a Store....</option>
//                                   {branches.map((b) => (
//                                     <option
//                                       key={b.branch_id}
//                                       value={b.branch_id}
//                                     >
//                                       {b.area} — {b.branch_address}
//                                     </option>
//                                   ))}
//                                 </select>
//                                 <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
//                                   <svg
//                                     width="12"
//                                     height="12"
//                                     viewBox="0 0 24 24"
//                                     fill="none"
//                                     stroke="#5fbdb3"
//                                     strokeWidth="2.5"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                   >
//                                     <path d="M6 9l6 6 6-6" />
//                                   </svg>
//                                 </div>
//                               </div>
//                               {selectedBranchObj && (
//                                 <div className="bg-[#e8f5f4] border border-[#aac9c7] rounded-[12px] px-3 py-2 flex items-center gap-2">
//                                   <MapPin
//                                     size={12}
//                                     className="text-[#5fbdb3] flex-shrink-0"
//                                   />
//                                   <p className="text-[11px] text-[#1e3330]">
//                                     {selectedBranchObj.area} -{" "}
//                                     {selectedBranchObj.branch_address},{" "}
//                                     {selectedBranchObj.pincode}
//                                   </p>
//                                 </div>
//                               )}
//                             </>
//                           ) : (
//                             <p className="text-[12px] text-[#2d5250] text-center py-2">
//                               No branches available.
//                             </p>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Payment Card */}
//                   <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
//                     <SCardHead
//                       title="Payment Mode"
//                       icon={
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="#5fbdb3"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <rect x="1" y="4" width="22" height="16" rx="2" />
//                           <line x1="1" y1="10" x2="23" y2="10" />
//                         </svg>
//                       }
//                     />
//                     <div className="p-4 flex flex-col gap-2.5">
//                       {[
//                         {
//                           val: "ONLINE",
//                           label: "Online Payment",
//                           sub: "UPI · Net Banking · Cards",
//                           icon: "💳",
//                         },
//                         {
//                           val: "COD",
//                           label: "Cash on Delivery",
//                           sub: "Pay when your order arrives",
//                           icon: "💵",
//                         },
//                       ].map((opt) => (
//                         <div
//                           key={opt.val}
//                           onClick={() => setPaymentMode(opt.val)}
//                           className={`flex items-center gap-3 p-3 rounded-xl border-[1.5px] cursor-pointer transition-all duration-200
//                             ${paymentMode === opt.val ? "border-[#5fbdb3] bg-[#e8f5f4] shadow-[0_2px_8px_rgba(95,189,179,0.15)]" : "border-[#c8d8d7] hover:border-[#5fbdb3]/50 hover:bg-[#f2f8f7]"}`}
//                         >
//                           <div
//                             className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg flex-shrink-0 ${paymentMode === opt.val ? "bg-[#ddf0ee] border border-[#aac9c7]" : "bg-[#f1f5f5]"}`}
//                           >
//                             {opt.icon}
//                           </div>
//                           <div className="flex-1 min-w-0">
//                             <p className="text-[13px] font-bold text-[#1e4a46]">
//                               {opt.label}
//                             </p>
//                             <p className="text-[11px] text-[#2d5250] mt-0.5">
//                               {opt.sub}
//                             </p>
//                           </div>
//                           <RadioDot active={paymentMode === opt.val} />
//                         </div>
//                       ))}
//                       <div className="flex items-center gap-2 mt-1 bg-[#e8f5f4] rounded-xl px-3 py-2 border border-[#c8d8d7]">
//                         <svg
//                           width="11"
//                           height="11"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="#5fbdb3"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//                         </svg>
//                         <p className="text-[10px] text-[#2d5250]">
//                           All transactions are 100% secure &amp; encrypted
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* ─ Prescription Banner (only if needed) ─ */}
//               {hasPrescriptionItems && (
//   <div
//     className={`rounded-2xl border-[1.5px] overflow-hidden transition-all duration-300 ${
//       prescriptionUploaded
//         ? "border-green-200 bg-green-50"
//         : "border-[#ffd5c2] bg-[#fff3ee]"
//     }`}
//   >
//     {/* Top Section */}
//     <div className="px-4 sm:px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">

//       {/* Icon + Text */}
//       <div className="flex items-start gap-3 flex-1 min-w-0">

//         {/* Icon */}
//         <div
//           className={`w-11 h-11 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
//             prescriptionUploaded
//               ? "bg-green-100 border border-green-200"
//               : "bg-[#fff3ee] border border-[#ffd5c2]"
//           }`}
//         >
//           {prescriptionUploaded ? (
//             <CheckCircle size={22} className="text-green-600" />
//           ) : (
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="#ff601e"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//               <polyline points="14 2 14 8 20 8" />
//               <line x1="12" y1="18" x2="12" y2="12" />
//               <line x1="9" y1="15" x2="15" y2="15" />
//             </svg>
//           )}
//         </div>

//         {/* Text */}
//         <div className="min-w-0">
//           <p
//             className={`text-[13px] font-bold ${
//               prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"
//             }`}
//           >
//             {prescriptionUploaded
//               ? "✓ Prescription Uploaded"
//               : "Prescription Required"}
//           </p>

//           <p
//             className={`text-[11px] mt-0.5 leading-snug break-words ${
//               prescriptionUploaded ? "text-green-600" : "text-[#2d5250]"
//             }`}
//           >
//             {prescriptionUploaded
//               ? prescriptionFile?.name ||
//                 "Your prescription has been added successfully"
//               : "One or more items in your cart require a valid doctor's prescription"}
//           </p>
//         </div>
//       </div>

//       {/* Button */}
//       {prescriptionUploaded ? (
//         <button
//           onClick={() => {
//             setPrescriptionUploaded(false);
//             setPrescriptionFile(null);
//             setPrescriptionUrl(null);
//           }}
//           className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-[11px] font-semibold text-green-600 border border-green-200 bg-white px-3 py-2 sm:py-1.5 rounded-xl hover:border-green-400 transition-all"
//         >
//           <svg
//             width="11"
//             height="11"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           >
//             <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
//             <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
//           </svg>
//           Change
//         </button>
//       ) : (
//         <button
//           onClick={() => setShowPrescriptionModal(true)}
//           className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-[12px] font-bold text-white bg-[#ff601e] hover:bg-[#e55519] px-4 py-2 rounded-xl transition-all border-none cursor-pointer shadow-[0_2px_10px_rgba(255,96,30,0.35)]"
//         >
//           <Upload size={13} />
//           Upload Now
//         </button>
//       )}
//     </div>

//     {/* Prescription Items */}
//     {!prescriptionUploaded && (
//       <div className="px-4 sm:px-5 pb-4">
//         <div className="flex flex-wrap gap-1.5 sm:gap-2">
//           {itemsInCartInCart
//             .filter((it) => it.prescription_required === "Yes")
//             .map((it) => (
//               <span
//                 key={it.variant_id}
//                 className="text-[9px] sm:text-[10px] font-semibold text-[#ff601e] bg-white border border-[#ffd5c2] px-2 py-1 rounded-full flex items-center gap-1 max-w-full"
//               >
//                 <svg
//                   width="9"
//                   height="9"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#ff601e"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                   <polyline points="14 2 14 8 20 8" />
//                 </svg>

//                 <span className="truncate">
//                   {it.name.length > 25
//                     ? it.name.slice(0, 25) + "…"
//                     : it.name}
//                 </span>
//               </span>
//             ))}
//         </div>
//       </div>
//     )}
//   </div>
// )}

//                 {/* ─ Cart Items ─ */}
//                 <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
//                   <SCardHead
//                     title="Cart Items"
//                     badge={`${itemsInCartInCart.length} item${itemsInCartInCart.length !== 1 ? "s" : ""}`}
//                     icon={
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#5fbdb3"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <circle cx="9" cy="21" r="1" />
//                         <circle cx="20" cy="21" r="1" />
//                         <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                       </svg>
//                     }
//                   />
//                   <div className="p-4">
//                     <div className="flex justify-end mb-3">
//                       <button
//                         onClick={() => setShowConfirm(true)}
//                         className="text-[12px] font-semibold text-[#ff601e] border border-[#ffd5c2] rounded-[10px] px-3 py-1.5 hover:bg-[#fff3ee] transition-colors"
//                       >
//                         Clear Cart
//                       </button>
//                     </div>
//                     <div className="flex flex-col gap-3">
//                       {itemsInCartInCart.map((item) => (
//                         <div
//                           key={`${item.product_id}-${item.variant_id}`}
//                           className="bg-[#f2f8f7] rounded-xl border-[1.5px] border-[#c8d8d7] hover:border-[#5fbdb3] p-3 flex gap-3 transition-all duration-200 group"
//                         >
//                           {/* Image */}
//                           <div
//                             className="w-[76px] h-[76px] min-w-[76px] rounded-[12px] border border-[#c8d8d7] bg-white flex items-center justify-center overflow-hidden cursor-pointer flex-shrink-0"
//                             onClick={() =>
//                               handleclickforfeaturedproduct(
//                                 item.product_id,
//                                 item,
//                               )
//                             }
//                           >
//                             <img
//                               src={item.image}
//                               alt={item.name}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "/default.svg";
//                               }}
//                               className="w-12 h-12 object-contain"
//                             />
//                           </div>

//                           {/* Body */}
//                           <div className="flex-1 min-w-0 flex flex-col gap-1">
//                             <div className="flex items-start gap-2 justify-between">
//                               <p
//                                 className="text-[12px] font-bold text-[#1e4a46] leading-snug cursor-pointer hover:text-[#ff601e] transition-colors line-clamp-2 flex-1"
//                                 onClick={() =>
//                                   handleclickforfeaturedproduct(
//                                     item.product_id,
//                                     item,
//                                   )
//                                 }
//                               >
//                                 {item.name}
//                               </p>
//                               {/* Prescription badge */}
//                               {item.prescription_required === "Yes" && (
//                                 <span
//                                   className={`flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-full flex-shrink-0 ${prescriptionUploaded ? "bg-green-100 text-green-700 border border-green-200" : "bg-[#fff3ee] text-[#ff601e] border border-[#ffd5c2]"}`}
//                                 >
//                                   {prescriptionUploaded ? (
//                                     <>
//                                       <CheckCircle size={9} />
//                                       Rx ✓
//                                     </>
//                                   ) : (
//                                     <>
//                                       <AlertCircle size={9} />
//                                       Rx Req
//                                     </>
//                                   )}
//                                 </span>
//                               )}
//                             </div>

//                             <p className="text-[10px] text-[#5a7a77] font-medium">
//                               By {item.manufacturer} · Pack: {item.pack_size}
//                             </p>

//                             {/* Price */}
//                             <div className="flex items-center gap-2 flex-wrap">
//                               {item.showDiscount && (
//                                 <span className="text-[10px] text-[#7a9b98] line-through">
//                                   ₹{(item.mrp * item.quantity).toFixed(2)}
//                                 </span>
//                               )}
//                               <span
//                                 className="text-[14px] font-black text-[#1e4a46]"
//                                 style={{ fontFamily: "'Nunito',sans-serif" }}
//                               >
//                                 ₹{(item.finalPrice * item.quantity).toFixed(2)}
//                               </span>
//                               {item.showDiscount &&
//                                 item.discount_percent > 0 && (
//                                   <span className="text-[9px] font-bold bg-[#ddf0ee] border border-[#aac9c7] text-[#1e4a46] px-1.5 py-0.5 rounded-full">
//                                     {item.discount_percent}% OFF
//                                   </span>
//                                 )}
//                             </div>

//                             {/* Qty + Delete */}
//                             <div className="flex items-center gap-2 mt-1">
//                               <div className="flex items-center bg-white border border-[#aac9c7] rounded-xl h-8 px-1 gap-0.5">
//                                 <button
//                                   onClick={(e) => handleDecrease(e, item)}
//                                   className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#ddf0ee] transition-colors"
//                                 >
//                                   −
//                                 </button>
//                                 <span
//                                   className="font-black text-[13px] text-[#1e4a46] min-w-[22px] text-center"
//                                   style={{ fontFamily: "'Nunito',sans-serif" }}
//                                 >
//                                   {quantities[item.variant_id] || item.quantity}
//                                 </span>
//                                 <button
//                                   onClick={(e) => handleIncrease(e, item)}
//                                   className="w-7 h-7 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-[#ddf0ee] transition-colors"
//                                 >
//                                   +
//                                 </button>
//                               </div>
//                               <button
//                                 className="ml-auto w-8 h-8 rounded-[10px] border border-[#c8d8d7] bg-white flex items-center justify-center text-[#2d5250] hover:border-red-300 hover:text-red-500 transition-all"
//                                 onClick={() =>
//                                   handleDeleteClick(
//                                     item.product_id,
//                                     item.variant_id,
//                                     item,
//                                   )
//                                 }
//                               >
//                                 <svg
//                                   width="13"
//                                   height="13"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   strokeWidth="2"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <polyline points="3 6 5 6 21 6" />
//                                   <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" />
//                                   <path d="M10 11v6M14 11v6" />
//                                   <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14" />
//                                 </svg>
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* ════ RIGHT COLUMN — Bill Summary ════ */}
//               <div className="lg:sticky lg:top-4 flex flex-col gap-4">
//                 <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
//                   <SCardHead
//                     title="Bill Summary"
//                     icon={
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#5fbdb3"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <line x1="8" y1="6" x2="21" y2="6" />
//                         <line x1="8" y1="12" x2="21" y2="12" />
//                         <line x1="8" y1="18" x2="21" y2="18" />
//                         <line x1="3" y1="6" x2="3.01" y2="6" />
//                         <line x1="3" y1="12" x2="3.01" y2="12" />
//                         <line x1="3" y1="18" x2="3.01" y2="18" />
//                       </svg>
//                     }
//                   />
//                   <div className="p-4 flex flex-col gap-3">
//                     {/* Item thumbnails */}
//                     <div className="bg-[#f2f8f7] rounded-xl border border-[#dde9e8] p-3 flex flex-col gap-2 mb-1">
//                       {itemsInCartInCart.slice(0, 3).map((item) => (
//                         <div
//                           key={item.variant_id}
//                           className="flex items-center gap-2"
//                         >
//                           <img
//                             src={item.image}
//                             alt={item.name}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "/default.svg";
//                             }}
//                             className="w-8 h-8 object-contain rounded-lg border border-[#c8d8d7] bg-white flex-shrink-0"
//                           />
//                           <p className="text-[11px] text-[#1e3330] line-clamp-1 flex-1">
//                             {item.name}
//                           </p>
//                           <span className="text-[11px] font-bold text-[#1e4a46] flex-shrink-0">
//                             ×{quantities[item.variant_id] || item.quantity}
//                           </span>
//                         </div>
//                       ))}
//                       {itemsInCartInCart.length > 3 && (
//                         <p className="text-[10px] text-[#2d5250] text-center">
//                           +{itemsInCartInCart.length - 3} more item
//                           {itemsInCartInCart.length - 3 !== 1 ? "s" : ""}
//                         </p>
//                       )}
//                     </div>

//                     {[
//                       {
//                         label: "Total MRP",
//                         val: `₹${originalTotal.toFixed(2)}`,
//                         color: "text-[#1e4a46] font-semibold",
//                       },
//                       {
//                         label: "Discount on MRP",
//                         val: `− ₹${totalSaved.toFixed(2)}`,
//                         color: "text-[#059669] font-semibold",
//                       },
//                       {
//                         label: "Delivery",
//                         val: shipping,
//                         color: "text-[#059669] font-semibold",
//                       },
//                     ].map((row) => (
//                       <div
//                         key={row.label}
//                         className="flex justify-between items-center"
//                       >
//                         <span className="text-[13px] text-[#2d5250] font-medium">
//                           {row.label}
//                         </span>
//                         <span className={`text-[13px] ${row.color}`}>
//                           {row.val}
//                         </span>
//                       </div>
//                     ))}

//                     <div className="h-px bg-[#f1f5f5] my-1" />
//                     <div className="flex justify-between items-center">
//                       <span className="text-[15px] font-bold text-[#0a1715]">
//                         Total
//                       </span>
//                       <span
//                         className="text-[18px] font-black text-[#1e4a46]"
//                         style={{ fontFamily: "'Nunito',sans-serif" }}
//                       >
//                         ₹{total.toFixed(2)}
//                       </span>
//                     </div>

//                     <div className="flex justify-between items-center bg-[#ddf0ee] border border-[#aac9c7] rounded-xl px-3.5 py-2.5">
//                       <div className="flex items-center gap-1.5">
//                         <svg
//                           width="12"
//                           height="12"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="#1e4a46"
//                           strokeWidth="2.5"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <polyline points="20 6 9 17 4 12" />
//                         </svg>
//                         <span className="text-[12px] font-bold text-[#1e4a46]">
//                           You save
//                         </span>
//                       </div>
//                       <span
//                         className="text-[14px] font-black text-[#1e4a46]"
//                         style={{ fontFamily: "'Nunito',sans-serif" }}
//                       >
//                         ₹{totalSaved.toFixed(2)}
//                       </span>
//                     </div>

//                     {/* Delivery summary */}
//                     <div className="flex items-center gap-2 bg-[#e8f5f4] border border-[#c8d8d7] rounded-xl px-3 py-2">
//                       <div className="w-6 h-6 rounded-lg bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center flex-shrink-0">
//                         {selectedDeliveryOption === "home" ? (
//                           <svg
//                             width="10"
//                             height="10"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="#5fbdb3"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           >
//                             <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//                             <polyline points="9 22 9 12 15 12 15 22" />
//                           </svg>
//                         ) : (
//                           <MapPin size={10} className="text-[#5fbdb3]" />
//                         )}
//                       </div>
//                       <p className="text-[11px] text-[#1e3330] line-clamp-1 flex-1">
//                         {selectedDeliveryOption === "home"
//                           ? selectedAddrObj
//                             ? `${selectedAddrObj.address_title} · ${selectedAddrObj.city}`
//                             : "No address selected"
//                           : selectedBranchObj
//                             ? selectedBranchObj.area
//                             : "No branch selected"}
//                       </p>
//                     </div>

//                     {/* Prescription status in bill */}
//                     {hasPrescriptionItems && (
//                       <div
//                         className={`flex items-center gap-2 rounded-xl px-3 py-2 border ${prescriptionUploaded ? "bg-green-50 border-green-200" : "bg-[#fff3ee] border-[#ffd5c2]"}`}
//                       >
//                         {prescriptionUploaded ? (
//                           <CheckCircle
//                             size={14}
//                             className="text-green-600 flex-shrink-0"
//                           />
//                         ) : (
//                           <AlertCircle
//                             size={14}
//                             className="text-[#ff601e] flex-shrink-0"
//                           />
//                         )}
//                         <p
//                           className={`text-[11px] font-semibold ${prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"}`}
//                         >
//                           {prescriptionUploaded
//                             ? "Prescription uploaded"
//                             : "Prescription required"}
//                         </p>
//                         {!prescriptionUploaded && (
//                           <button
//                             onClick={() => setShowPrescriptionModal(true)}
//                             className="ml-auto text-[10px] font-bold text-[#ff601e] underline cursor-pointer bg-transparent border-none"
//                           >
//                             Upload
//                           </button>
//                         )}
//                       </div>
//                     )}

//                     {/* Checkout button */}
//                     <button
//                       onClick={onPayment}
//                       disabled={
//                         isProcessing ||
//                         (hasPrescriptionItems && !prescriptionUploaded)
//                       }
//                       className={`w-full h-12 rounded-2xl text-white text-[14px] font-bold flex items-center justify-center gap-2 transition-all duration-200 border-none mt-1
//                         ${
//                           hasPrescriptionItems && !prescriptionUploaded
//                             ? "bg-[#c5d5d4] cursor-not-allowed shadow-none"
//                             : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_4px_18px_rgba(22,44,42,0.28)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.4)] cursor-pointer"
//                         } disabled:opacity-70`}
//                     >
//                       {isProcessing && (
//                         <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
//                       )}
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <path d="M5 12h14M12 5l7 7-7 7" />
//                       </svg>
//                       {hasPrescriptionItems && !prescriptionUploaded
//                         ? "Upload Prescription First"
//                         : "Proceed to Checkout"}
//                     </button>

//                     <p className="text-[10px] text-[#2d5250] text-center">
//                       {paymentMode === "ONLINE"
//                         ? "🔒 Secured by Razorpay"
//                         : "💵 Pay when your order arrives"}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* ════ TRENDING PRODUCTS ════ */}
//             {featuredProducts.length > 0 && (
//               <div className="mt-10">
//                 <div className="flex items-center justify-between mb-5">
//                   <div>
//                     <div className="flex items-center gap-2 mb-1.5">
//                       <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
//                       <span className="text-[10px] font-bold uppercase tracking-widest text-[#ff601e]">
//                         You May Also Like
//                       </span>
//                     </div>
//                     <h2
//                       className="text-[20px] font-black text-[#1e4a46]"
//                       style={{ fontFamily: "'Nunito',sans-serif" }}
//                     >
//                       Trending Products
//                     </h2>
//                   </div>
//                   <div className="flex items-center gap-2 grid-cols-8">
//                     <button
//                       onClick={() => setCurrentIndex((p) => Math.max(0, p - 1))}
//                       disabled={currentIndex === 0}
//                       className="w-9 h-9 rounded-[10px] border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#ddf0ee] disabled:opacity-30 transition-all cursor-pointer"
//                     >
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#374747"
//                         strokeWidth="2.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <path d="M19 12H5M12 5l-7 7 7 7" />
//                       </svg>
//                     </button>
//                     <button
//                       onClick={() =>
//                         setCurrentIndex((p) => Math.min(totalPages - 1, p + 1))
//                       }
//                       disabled={currentIndex >= totalPages - 1}
//                       className="w-9 h-9 rounded-[10px] border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#ddf0ee] disabled:opacity-30 transition-all cursor-pointer"
//                     >
//                       <svg
//                         width="13"
//                         height="13"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#374747"
//                         strokeWidth="2.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <path d="M5 12h14M12 5l7 7-7 7" />
//                       </svg>
//                     </button>
//                     <Link to="/featured-products">
//                       <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold text-[12px] px-4 h-9 rounded-[10px] transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] border-none cursor-pointer">
//                         View All{" "}
//                         <svg
//                           width="11"
//                           height="11"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           stroke="currentColor"
//                           strokeWidth="2.5"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         >
//                           <path d="M5 12h14M12 5l7 7-7 7" />
//                         </svg>
//                       </button>
//                     </Link>
//                   </div>
//                 </div>

//                 {/* Desktop grid — 4 cols */}
//                 <div className="hidden md:grid grid-cols-8 gap-4">
//                   {" "}
//                   {currentFeatured.map((item, index) => {
//                     const altQty = getCartQuantity(
//                       item.variant?.[0]?.variant_id,
//                     );
//                     const isOrange = index % 2 === 1;
//                     const isWish = wishlistItems.some(
//                       (w) =>
//                         w.product_id === item.product_id &&
//                         w.variant_id === item.variant?.[0]?.variant_id,
//                     );
//                     const isOOS = OutOfQuantityCheck(item.variant || []);
//                     /* price using mrp field */
//                     const {
//                       mrp: tMrp,
//                       finalPrice: tFinal,
//                       showDiscount: tDisc,
//                     } = getPriceFromVariant(
//                       item.variant?.[0]?.mrp,
//                       item.variant?.[0]?.discounted_price,
//                     );
//                     return (
//                       <div
//                         key={item.product_id || index}
//                         className={`group border-[1.5px] ${isOrange ? "border-[#ffd5c2] hover:border-[#ff601e]/60" : "border-[#c8d8d7] hover:border-[#5fbdb3]"} bg-white rounded-[18px] overflow-hidden flex flex-col cursor-pointer hover:-translate-y-2 hover:shadow-[0_12px_36px_rgba(22,44,42,0.15)] shadow-[0_2px_10px_rgba(22,44,42,0.07)] transition-all duration-300 relative`}
//                         style={{
//                           animation: `fadeInUp 0.35s ease ${index * 60}ms both`,
//                         }}
//                       >
//                         <div
//                           className={`absolute top-0 left-0 right-0 h-[3px] ${isOrange ? "bg-gradient-to-r from-[#ff601e] to-[#e55519]" : "bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]"} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
//                         />
//                         {tDisc && item.discount_percent > 0 && (
//                           <div className="absolute top-3 right-3 bg-[#ff601e] text-white text-[9px] font-bold w-9 h-9 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] z-10 leading-tight text-center">
//                             {item.discount_percent}%<br />
//                             OFF
//                           </div>
//                         )}
//                         <button
//                           className="absolute top-3 left-3 z-10 w-7 h-7 bg-white rounded-xl border border-[#c8d8d7] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#ddf0ee] transition-all duration-200"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             if (!localStorage.getItem("authToken")) {
//                               setShowLoginPopup(true);
//                               return;
//                             }
//                             isWish
//                               ? removeFromWishlist(
//                                   item.product_id,
//                                   item.variant?.[0]?.variant_id,
//                                 )
//                               : addToWishlist(item, item.variant?.[0]);
//                           }}
//                         >
//                           <img
//                             src={isWish ? wish : wishlist}
//                             alt="wish"
//                             className="w-3.5 h-3.5"
//                           />
//                         </button>
//                         <div
//                           className={`w-full h-[130px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#e8f5f4]"} flex items-center justify-center p-4 pt-8`}
//                           onClick={() =>
//                             handleclickforfeaturedproduct(item.product_id, item)
//                           }
//                         >
//                           <img
//                             src={
//                               item?.product_images?.image_url?.primary_image ||
//                               "/default.svg"
//                             }
//                             alt={item.name}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "/default.svg";
//                             }}
//                             className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
//                           />
//                         </div>
//                         <div className="w-full h-px bg-[#f1f5f5]" />
//                         <div
//                           className="p-3 flex-1 cursor-pointer"
//                           onClick={() =>
//                             handleclickforfeaturedproduct(item.product_id, item)
//                           }
//                         >
//                           <h3 className="font-semibold text-[11px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors mb-1.5">
//                             {item.name}
//                           </h3>
//                           <div className="flex items-baseline gap-1.5 flex-wrap">
//                             {tMrp > 0 ? (
//                               <>
//                                 {tDisc && (
//                                   <span className="text-[10px] text-[#7a9b98] line-through">
//                                     ₹{tMrp}
//                                   </span>
//                                 )}
//                                 <span
//                                   className="text-[13px] font-black text-[#1e4a46]"
//                                   style={{ fontFamily: "'Nunito',sans-serif" }}
//                                 >
//                                   ₹{tFinal}
//                                 </span>
//                                 {tDisc && item.discount_percent > 0 && (
//                                   <span
//                                     className={`text-[10px] font-semibold ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
//                                   >
//                                     {item.discount_percent}% off
//                                   </span>
//                                 )}
//                               </>
//                             ) : (
//                               <span className="text-[11px] text-[#1e3330]">
//                                 Price N/A
//                               </span>
//                             )}
//                           </div>
//                           {isOOS && (
//                             <span className="text-[9px] font-bold text-red-500 bg-red-50 border border-red-100 px-1.5 py-0.5 rounded-full mt-1 inline-block">
//                               Out of Stock
//                             </span>
//                           )}
//                         </div>
//                         <div className="px-3 pb-3">
//                           {altQty > 0 ? (
//                             <div className="flex items-center justify-between bg-[#ddf0ee] border border-[#aac9c7] rounded-xl h-9 px-2">
//                               <button
//                                 onClick={(e) =>
//                                   handleDecreaseForTrending(
//                                     e,
//                                     item.variant[0],
//                                     item,
//                                   )
//                                 }
//                                 className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
//                               >
//                                 −
//                               </button>
//                               <span className="font-black text-[13px] text-[#1e4a46]">
//                                 {altQty}
//                               </span>
//                               <button
//                                 onClick={(e) =>
//                                   handleIncreaseForTrending(
//                                     e,
//                                     item.variant[0],
//                                     item,
//                                   )
//                                 }
//                                 className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
//                               >
//                                 +
//                               </button>
//                             </div>
//                           ) : (
//                             <button
//                               disabled={isOOS}
//                               className={`w-full h-9 ${isOrange ? "bg-[#ff601e] hover:bg-[#e55519]" : "bg-[#1e4a46] hover:bg-[#ff601e]"} text-white text-[11px] font-bold rounded-[10px] flex items-center justify-center gap-1.5 transition-all duration-200 border-none disabled:bg-[#c5d5d4] disabled:cursor-not-allowed cursor-pointer`}
//                               onClick={async (e) => {
//                                 e.stopPropagation();
//                                 if (!localStorage.getItem("authToken")) {
//                                   setShowLoginPopup(true);
//                                   return;
//                                 }
//                                 await handleAddToCart(item, item.variant[0], 1);
//                                 await fetchCart();
//                               }}
//                             >
//                               <svg
//                                 width="13"
//                                 height="13"
//                                 viewBox="0 0 24 24"
//                                 fill="none"
//                                 stroke="white"
//                                 strokeWidth="2.5"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               >
//                                 <circle cx="9" cy="21" r="1" />
//                                 <circle cx="20" cy="21" r="1" />
//                                 <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                               </svg>
//                               Add to Cart
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>

//                 {/* Mobile scroll */}
//                 <div className="md:hidden relative">
//                   <button
//                     onClick={() =>
//                       scrollRef.current?.scrollBy({
//                         left: -200,
//                         behavior: "smooth",
//                       })
//                     }
//                     className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#c8d8d7] shadow flex items-center justify-center cursor-pointer"
//                   >
//                     <ChevronLeft size={15} />
//                   </button>
//                   <div
//                     ref={scrollRef}
//                     className="flex gap-3 overflow-x-auto scrollbar-hide px-6 py-2 scroll-smooth"
//                   >
//                     {featuredProducts.map((item, index) => {
//                       const altQty = getCartQuantity(
//                         item.variant?.[0]?.variant_id,
//                       );
//                       const isOrange = index % 2 === 1;
//                       const {
//                         mrp: tMrp,
//                         finalPrice: tFinal,
//                         showDiscount: tDisc,
//                       } = getPriceFromVariant(
//                         item.variant?.[0]?.mrp,
//                         item.variant?.[0]?.discounted_price,
//                       );
//                       const isOOS = OutOfQuantityCheck(item.variant || []);
//                       return (
//                         <div
//                           key={item.product_id || index}
//                           className={`flex-shrink-0 w-[150px] rounded-[18px] border-[1.5px] ${isOrange ? "border-[#ffd5c2]" : "border-[#c8d8d7]"} bg-white overflow-hidden flex flex-col cursor-pointer shadow-[0_2px_10px_rgba(22,44,42,0.07)]`}
//                         >
//                           <div
//                             className={`h-[110px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#e8f5f4]"} flex items-center justify-center p-3 pt-6`}
//                             onClick={() =>
//                               handleclickforfeaturedproduct(
//                                 item.product_id,
//                                 item,
//                               )
//                             }
//                           >
//                             <img
//                               src={
//                                 item?.product_images?.image_url
//                                   ?.primary_image || "/default.svg"
//                               }
//                               alt={item.name}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "/default.svg";
//                               }}
//                               className="max-h-full max-w-full object-contain"
//                             />
//                           </div>
//                           <div className="w-full h-px bg-[#f1f5f5]" />
//                           <div
//                             className="p-2.5 flex-1"
//                             onClick={() =>
//                               handleclickforfeaturedproduct(
//                                 item.product_id,
//                                 item,
//                               )
//                             }
//                           >
//                             <p className="text-[11px] font-semibold text-[#1e4a46] line-clamp-2 mb-1">
//                               {item.name}
//                             </p>
//                             {tMrp > 0 ? (
//                               <div className="flex items-baseline gap-1 flex-wrap">
//                                 {tDisc && (
//                                   <span className="text-[10px] text-[#7a9b98] line-through">
//                                     ₹{tMrp}
//                                   </span>
//                                 )}
//                                 <span className="text-[13px] font-black text-[#1e4a46]">
//                                   ₹{tFinal}
//                                 </span>
//                               </div>
//                             ) : (
//                               <span className="text-[11px] text-[#1e3330]">
//                                 N/A
//                               </span>
//                             )}
//                           </div>
//                           <div className="px-2.5 pb-2.5">
//                             {altQty > 0 ? (
//                               <div className="flex items-center justify-between bg-[#ddf0ee] border border-[#aac9c7] rounded-xl h-8 px-2">
//                                 <button
//                                   onClick={(e) =>
//                                     handleDecreaseForTrending(
//                                       e,
//                                       item.variant[0],
//                                       item,
//                                     )
//                                   }
//                                   className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base cursor-pointer"
//                                 >
//                                   −
//                                 </button>
//                                 <span className="font-black text-[12px] text-[#1e4a46]">
//                                   {altQty}
//                                 </span>
//                                 <button
//                                   onClick={(e) =>
//                                     handleIncreaseForTrending(
//                                       e,
//                                       item.variant[0],
//                                       item,
//                                     )
//                                   }
//                                   className="w-5 h-5 flex items-center justify-center text-[#1e4a46] font-black text-base cursor-pointer"
//                                 >
//                                   +
//                                 </button>
//                               </div>
//                             ) : (
//                               <button
//                                 disabled={isOOS}
//                                 className={`w-full h-8 ${isOrange ? "bg-[#ff601e]" : "bg-[#1e4a46]"} text-white text-[10px] font-bold rounded-[10px] flex items-center justify-center gap-1 border-none disabled:bg-[#c5d5d4] cursor-pointer`}
//                                 onClick={async (e) => {
//                                   e.stopPropagation();
//                                   if (!localStorage.getItem("authToken")) {
//                                     setShowLoginPopup(true);
//                                     return;
//                                   }
//                                   await handleAddToCart(
//                                     item,
//                                     item.variant[0],
//                                     1,
//                                   );
//                                   await fetchCart();
//                                 }}
//                               >
//                                 <svg
//                                   width="11"
//                                   height="11"
//                                   viewBox="0 0 24 24"
//                                   fill="none"
//                                   stroke="white"
//                                   strokeWidth="2.5"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 >
//                                   <circle cx="9" cy="21" r="1" />
//                                   <circle cx="20" cy="21" r="1" />
//                                   <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//                                 </svg>
//                                 Add
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                   <button
//                     onClick={() =>
//                       scrollRef.current?.scrollBy({
//                         left: 200,
//                         behavior: "smooth",
//                       })
//                     }
//                     className="absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white rounded-full border border-[#c8d8d7] shadow flex items-center justify-center cursor-pointer"
//                   >
//                     <ChevronRight size={15} />
//                   </button>
//                 </div>
//               </div>
//             )}
//           </>
//         ) : (
//           /* ── Empty cart ── */
//           <div className="flex flex-col items-center justify-center py-20 gap-5">
//             <div className="w-48 h-48">
//               <DotLottieReact
//                 src="https://lottie.host/66e677d4-91a1-4f1a-85e7-a7d1faf607b8/dBHVRTKEJU.lottie"
//                 loop
//                 autoplay
//               />
//             </div>
//             <div className="text-center">
//               <p
//                 className="font-black text-[22px] text-[#1e4a46] mb-2"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Your cart is empty
//               </p>
//               <p className="text-[14px] text-[#2d5250] max-w-[280px] mx-auto">
//                 Go ahead and add products to start shopping!
//               </p>
//             </div>
//             <Link to="/home">
//               <button className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[14px] px-8 h-11 rounded-2xl transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.28)] cursor-pointer">
//                 <svg
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
//                   <polyline points="9 22 9 12 15 12 15 22" />
//                 </svg>
//                 Start Shopping
//               </button>
//             </Link>
//           </div>
//         )}
//       </div>

//       {/* ══ DELETE MODAL ══ */}
//       <DeletePromptForCart
//         showModal={showModal}
//         onDelete={confirmDelete}
//         onCancel={() => setShowModal(false)}
//         data={deleteData}
//       />

//       {/* ══ PRESCRIPTION UPLOAD MODAL ══ */}
//       {showPrescriptionModal && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins p-4"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[480px] overflow-hidden">
//             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
//             <div className="px-6 py-5 border-b border-[#dde9e8] flex items-center justify-between">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl flex items-center justify-center">
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="#ff601e"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                     <polyline points="14 2 14 8 20 8" />
//                     <line x1="12" y1="18" x2="12" y2="12" />
//                     <line x1="9" y1="15" x2="15" y2="15" />
//                   </svg>
//                 </div>
//                 <div>
//                   <h2
//                     className="text-[16px] font-black text-[#1e4a46]"
//                     style={{ fontFamily: "'Nunito',sans-serif" }}
//                   >
//                     Upload Prescription
//                   </h2>
//                   <p className="text-[11px] text-[#1e3330]">
//                     JPG, PNG or PDF · Max 5MB
//                   </p>
//                 </div>
//               </div>
//               <button
//                 onClick={() => setShowPrescriptionModal(false)}
//                 className="w-8 h-8 rounded-xl border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] transition-all cursor-pointer"
//               >
//                 <X size={14} className="text-[#2d5250]" />
//               </button>
//             </div>

//             <div className="p-6 flex flex-col gap-4">
//               {/* Prescription items list */}
//               <div>
//                 <p className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2">
//                   Requires Prescription:
//                 </p>
//                 <div className="flex flex-col gap-1.5">
//                   {itemsInCartInCart
//                     .filter((it) => it.prescription_required === "Yes")
//                     .map((it) => (
//                       <div
//                         key={it.variant_id}
//                         className="flex items-center gap-2 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-3 py-2"
//                       >
//                         <img
//                           src={it.image}
//                           alt={it.name}
//                           className="w-8 h-8 object-contain rounded-lg bg-white border border-[#ffd5c2] flex-shrink-0"
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src = "/default.svg";
//                           }}
//                         />
//                         <p className="text-[12px] font-semibold text-[#ff601e] flex-1 line-clamp-1">
//                           {it.name}
//                         </p>
//                         <span className="text-[10px] font-bold text-[#ff601e] bg-white border border-[#ffd5c2] px-2 py-0.5 rounded-full flex-shrink-0">
//                           Rx
//                         </span>
//                       </div>
//                     ))}
//                 </div>
//               </div>

//               {/* Upload area */}
//               <div
//                 onClick={() => prescriptionInputRef.current?.click()}
//                 className={`border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer transition-all duration-200
//                   ${prescriptionFile ? "border-[#5fbdb3] bg-[#e8f5f4]" : "border-[#c8d8d7] hover:border-[#5fbdb3] hover:bg-[#e8f5f4]"}`}
//               >
//                 {prescriptionFile ? (
//                   <div className="flex items-center justify-center gap-3">
//                     <div className="w-10 h-10 bg-[#ddf0ee] border border-[#aac9c7] rounded-xl flex items-center justify-center flex-shrink-0">
//                       <svg
//                         width="18"
//                         height="18"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#5fbdb3"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                         <polyline points="14 2 14 8 20 8" />
//                       </svg>
//                     </div>
//                     <div className="text-left">
//                       <p className="text-[13px] font-bold text-[#1e4a46]">
//                         {prescriptionFile.name}
//                       </p>
//                       <p className="text-[11px] text-[#1e3330]">
//                         {(prescriptionFile.size / 1024 / 1024).toFixed(2)} MB ·
//                         Click to change
//                       </p>
//                     </div>
//                   </div>
//                 ) : (
//                   <>
//                     <div className="w-12 h-12 bg-[#ddf0ee] border border-[#aac9c7] rounded-2xl flex items-center justify-center mx-auto mb-3">
//                       <Upload size={20} className="text-[#5fbdb3]" />
//                     </div>
//                     <p className="text-[14px] font-bold text-[#1e4a46] mb-1">
//                       Click to upload your prescription
//                     </p>
//                     <p className="text-[12px] text-[#2d5250]">
//                       or drag and drop here
//                     </p>
//                     <p className="text-[11px] text-[#2d5250] mt-2">
//                       JPG, PNG or PDF · Maximum 5MB
//                     </p>
//                   </>
//                 )}
//               </div>

//               <input
//                 ref={prescriptionInputRef}
//                 type="file"
//                 accept=".jpg,.jpeg,.png,.pdf"
//                 className="hidden"
//                 onChange={(e) => {
//                   if (e.target.files?.[0])
//                     handlePrescriptionSelect(e.target.files[0]);
//                 }}
//               />

//               <div className="flex gap-3">
//                 <button
//                   onClick={() => {
//                     setShowPrescriptionModal(false);
//                     setPrescriptionFiles([]);
//                   }}
//                   className="flex-1 py-2.5 rounded-xl border border-[#c8d8d7] text-[#1e3330] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer bg-white"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={uploadPrescription}
//                   disabled={!prescriptionFile || uploadingPrescription}
//                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold flex items-center justify-center gap-2 transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
//                 >
//                   {uploadingPrescription && (
//                     <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
//                   )}
//                   {uploadingPrescription ? "Uploading…" : "Confirm Upload"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ CLEAR CART ══ */}
//       {showConfirm && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[320px] shadow-2xl">
//             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
//             <div className="p-6">
//               <h2
//                 className="text-[16px] font-bold text-white mb-2"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Clear entire cart?
//               </h2>
//               <p className="text-[13px] text-[#7abcb8] mb-5">
//                 All items will be removed permanently.
//               </p>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => setShowConfirm(false)}
//                   className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all bg-transparent cursor-pointer"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleClearCart}
//                   className="flex-1 py-2.5 rounded-xl bg-red-500 hover:bg-red-600 text-white text-[13px] font-extrabold uppercase tracking-widest transition-all border-none cursor-pointer"
//                 >
//                   Clear
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ COD CONFIRM ══ */}
//       {isCODConfirmPopUp && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[340px] shadow-2xl">
//             <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
//             <div className="p-6">
//               <h2
//                 className="text-[16px] font-bold text-white mb-2"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Confirm COD Order
//               </h2>
//               <p className="text-[13px] text-[#7abcb8] mb-5">
//                 Place this order with{" "}
//                 <strong className="text-white">Cash on Delivery</strong>?
//               </p>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => {
//                     setIsCODConfirmPopUp(false);
//                     setIsProcessing(false);
//                   }}
//                   disabled={isCODProcessing}
//                   className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all disabled:opacity-50 bg-transparent cursor-pointer"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleCODOrder}
//                   disabled={isCODProcessing}
//                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-extrabold uppercase tracking-widest flex items-center justify-center gap-2 transition-all border-none disabled:opacity-70 cursor-pointer"
//                 >
//                   {isCODProcessing && (
//                     <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
//                   )}
//                   Confirm
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ ADDRESS REQUIRED ══ */}
//       {showAddressPrompt && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
//             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
//             <div className="p-6 text-center">
//               <div className="w-14 h-14 bg-[#ddf0ee] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <MapPin size={24} className="text-[#1e4a46]" />
//               </div>
//               <h2
//                 className="text-[18px] font-bold text-[#1e4a46] mb-2"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Address Required
//               </h2>
//               <p className="text-[13px] text-[#2d5250] mb-6">
//                 Please add a delivery address to proceed.
//               </p>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => setShowAddressPrompt(false)}
//                   className="flex-1 py-2.5 rounded-xl border border-[#c8d8d7] text-[#1e3330] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={() => {
//                     setShowAddressPrompt(false);
//                     setPopupOpen(true);
//                   }}
//                   className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer"
//                 >
//                   Add Address
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ BRANCH REQUIRED ══ */}
//       {showBranchPrompt && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
//             <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
//             <div className="p-6 text-center">
//               <div className="w-14 h-14 bg-[#ddf0ee] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#1e4a46"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
//                   <circle cx="12" cy="10" r="3" />
//                 </svg>
//               </div>
//               <h2
//                 className="text-[18px] font-bold text-[#1e4a46] mb-2"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Branch Required
//               </h2>
//               <p className="text-[13px] text-[#2d5250] mb-6">
//                 Please select a store pickup location to proceed.
//               </p>
//               <button
//                 onClick={() => setShowBranchPrompt(false)}
//                 className="w-full py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer"
//               >
//                 Got it
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ EDIT ADDRESS ══ */}
//       {isEditPopupOpen && selectedAddress && (
//         <div
//           className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins p-4"
//           style={{ zIndex: 99999 }}
//         >
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[540px] overflow-hidden">
//             <div className="bg-[#162c2a] flex items-center justify-between px-6 py-4">
//               <img src={logo} alt="Logo" className="h-8 object-contain" />
//               <button
//                 onClick={() => {
//                   setIsEditPopupOpen(false);
//                   setSelectedAddress(null);
//                 }}
//                 className="text-white/70 hover:text-white transition-colors cursor-pointer"
//               >
//                 <X size={16} />
//               </button>
//             </div>
//             <div className="p-6 max-h-[80vh] overflow-y-auto">
//               <h2
//                 className="text-[18px] font-bold text-[#1e4a46] mb-5"
//                 style={{ fontFamily: "'Nunito',sans-serif" }}
//               >
//                 Edit Address
//               </h2>
//               <div className="flex flex-col gap-4">
//                 {[
//                   { label: "Name *", name: "address_title", max: 25 },
//                   {
//                     label: "Address Line 1 *",
//                     name: "address_line_1",
//                     max: 120,
//                   },
//                   { label: "Address Line 2", name: "address_line_2", max: 20 },
//                   {
//                     label: "Pincode *",
//                     name: "pincode",
//                     max: 6,
//                     inputMode: "numeric",
//                   },
//                   {
//                     label: "Mobile Number *",
//                     name: "mobile_number",
//                     max: 10,
//                     inputMode: "numeric",
//                   },
//                 ].map((f) => (
//                   <div key={f.name}>
//                     <label className="text-[12px] font-bold text-[#1e3330] mb-1.5 block">
//                       {f.label}
//                     </label>
//                     <input
//                       type="text"
//                       name={f.name}
//                       value={selectedAddress[f.name] || ""}
//                       maxLength={f.max}
//                       inputMode={f.inputMode}
//                       onChange={handleChange}
//                       className="w-full h-10 rounded-xl border border-[#c8d8d7] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors"
//                     />
//                     {addressErrors[f.name] && (
//                       <p className="text-[11px] text-red-500 mt-1">
//                         {addressErrors[f.name]}
//                       </p>
//                     )}
//                   </div>
//                 ))}
//                 <div>
//                   <label className="text-[12px] font-bold text-[#1e3330] mb-1.5 block">
//                     State *
//                   </label>
//                   <select
//                     name="state"
//                     value={selectedAddress.state || ""}
//                     onChange={handleChange}
//                     className="w-full h-10 rounded-xl border border-[#c8d8d7] px-3 text-[13px] text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors bg-white"
//                   >
//                     <option value="">Select State</option>
//                     {indianStates.map((st) => (
//                       <option key={st} value={st}>
//                         {st}
//                       </option>
//                     ))}
//                   </select>
//                   {addressErrors.state && (
//                     <p className="text-[11px] text-red-500 mt-1">
//                       {addressErrors.state}
//                     </p>
//                   )}
//                 </div>
//                 <div>
//                   <label className="text-[12px] font-bold text-[#1e3330] mb-2 block">
//                     Set as default?
//                   </label>
//                   <div className="flex gap-4">
//                     {[
//                       { val: true, label: "Yes" },
//                       { val: false, label: "No" },
//                     ].map((opt) => (
//                       <label
//                         key={String(opt.val)}
//                         className="flex items-center gap-2 cursor-pointer"
//                       >
//                         <RadioDot
//                           active={selectedAddress.is_default === opt.val}
//                         />
//                         <span
//                           className="text-[13px] text-[#1e3330]"
//                           onClick={() =>
//                             handleChange({
//                               target: { name: "is_default", value: opt.val },
//                             })
//                           }
//                         >
//                           {opt.label}
//                         </span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="flex gap-3 pt-2">
//                   <button
//                     onClick={() => {
//                       setIsEditPopupOpen(false);
//                       setSelectedAddress(null);
//                     }}
//                     className="flex-1 py-2.5 rounded-xl border border-[#c8d8d7] text-[#1e3330] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleUpdateAddress}
//                     disabled={!isEditFormValid}
//                     className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
//                   >
//                     Save Changes
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {isPopupOpen && (
//         <Adresspopup
//           onClose={() => setPopupOpen(false)}
//           fetchAddresses={fetchAddresses}
//         />
//       )}

//       <style>{`
//         @keyframes fadeInUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
//         .scrollbar-hide::-webkit-scrollbar { display:none; }
//         .scrollbar-hide { -ms-overflow-style:none; scrollbar-width:none; }
//       `}</style>
//     </div>
//   );
// };

// export default Cartpage;
import Adresspopup from "./Adresspopup";
import {
  ChevronLeft,
  ChevronRight,
  MapPin,
  Upload,
  CheckCircle,
  AlertCircle,
  X,
  ImagePlus,
} from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import logo from "../images/logo.png";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useCart, CART_SYNC_KEY } from "../Context/Createcontext";
import { toast } from "react-hot-toast";
import DeletePromptForCart from "../Components/common/DeletePromptForCart";
import { Helmet } from "react-helmet";
import { api_url } from "../config/config";
import addToCartIcon from "../Icons/addToCartIcon.svg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import wish from "../images/wish.svg";
import wishlist from "../images/wishlist_nofill.svg";
import { useWishlist } from "../Context/WishlistContext";
import loader from "../images/loaderimg.png";
import { toProductSlug } from "../utils/productSlug";
import { getFileKind } from "../utils/fileType";
import {
  clearCartPrescriptions,
  loadCartPrescriptions,
  saveCartPrescriptions,
} from "../utils/cartPrescriptionStorage";

/* ─────────────────────────────────────────────────────
   PRICE HELPER
───────────────────────────────────────────────────── */
const getPriceFromVariant = (mrp, discountedPrice) => {
  const _mrp = parseFloat(mrp) || 0;
  const _disc = parseFloat(discountedPrice) || 0;
  if (_mrp <= 0)
    return { mrp: 0, finalPrice: 0, showDiscount: false, pct: 0 };
  const showDiscount = _disc > 0 && _disc < _mrp;
  return {
    mrp: _mrp,
    finalPrice: showDiscount ? _disc : _mrp,
    showDiscount,
    // Computed from this variant's actual mrp/discounted_price, not the
    // product's separate discount_percent field — that field can be stale
    // or unrelated to what this specific variant is actually priced at.
    pct: showDiscount ? Math.round(((_mrp - _disc) / _mrp) * 100) : 0,
  };
};

/* ── Helpers ── */
const loadScript = (src) =>
  new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

const RadioDot = ({ active }) => (
  <div
    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${active ? "border-[#1e4a46]" : "border-[#c8d8d7]"}`}
  >
    {active && <div className="w-[7px] h-[7px] rounded-full bg-[#1e4a46]" />}
  </div>
);

const SCardHead = ({ icon, title, badge }) => (
  <div className="bg-[#e8f5f4] border-b border-[#c8d8d7] px-4 py-3 flex items-center gap-2.5 rounded-t-2xl">
    <div className="w-7 h-7 rounded-[8px] bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <span className="text-[13px] font-bold text-[#1e4a46] flex-1">{title}</span>
    {badge && (
      <span className="bg-[#ddf0ee] border border-[#aac9c7] text-[#1e4a46] text-[10px] font-bold px-2 py-0.5 rounded-full">
        {badge}
      </span>
    )}
  </div>
);

/* ── Wrap long option labels: first line up to 60 chars, remainder on the next line ── */
const wrapAt60 = (text) => {
  if (!text || text.length <= 60) return text;
  let idx = text.lastIndexOf(" ", 60);
  if (idx <= 0) idx = 60;
  return (
    text.slice(0, idx) + "\n" + text.slice(text[idx] === " " ? idx + 1 : idx)
  );
};

/* ── Custom dropdown: unlike a native <select>, its options can wrap onto multiple lines ── */
const WrapDropdown = ({ options, value, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const current = options.find((o) => o.id === value);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        className="w-full min-w-0 flex items-center justify-between gap-2 bg-[#e8f5f4] border-[1.5px] border-[#aac9c7] rounded-[12px] px-3 py-2.5 text-[12px] font-semibold text-[#1e4a46] outline-none focus:border-[#5fbdb3] transition-colors cursor-pointer text-left"
      >
        <span className="truncate min-w-0 flex-1">
          {current ? current.label : placeholder}
        </span>
        <svg
          className={`flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5fbdb3"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && (
        <div className="absolute left-0 top-[calc(100%+4px)] w-full bg-white border border-[#e2eaea] rounded-2xl shadow-[0_12px_40px_rgba(22,44,42,0.18)] z-[60] max-h-[240px] overflow-y-auto custom-scrollbar">
          {options.map((opt) => (
            <button
              key={opt.id}
              type="button"
              onClick={() => {
                onChange(opt.id);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-2.5 text-[12px] font-medium leading-relaxed whitespace-pre-line break-words border-b border-[#f1f5f5] last:border-0 transition-colors
                ${value === opt.id ? "bg-[#eaf4f3] text-[#1e4a46] font-semibold" : "text-[#374747] hover:bg-[#f8fafa]"}`}
            >
              {wrapAt60(opt.label)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

const plusPattern = `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`;

const InputField = ({ label, required, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-[12px] font-semibold text-[#374747] flex items-center gap-1">
      {label} {required && <span className="text-[#ff601e]">*</span>}
    </label>
    {children}
    {error && <p className="text-[11px] text-red-500">{error}</p>}
  </div>
);

const inputCls = (hasError) =>
  `w-full h-11 px-4 bg-white border-[1.5px] rounded-xl font-poppins text-[13px] text-[#1a2625] placeholder-[#8faba9] outline-none transition-all duration-200 ${
    hasError
      ? "border-red-400 focus:border-red-400 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.12)]"
      : "border-[#e2eaea] focus:border-[#1e4a46] focus:shadow-[0_0_0_3px_rgba(95,189,179,0.15)]"
  }`;

/* ════════════════════════════════════════════════════ */
const Cartpage = ({ onClose }) => {
  const navigate = useNavigate();
  const {
    handleAddToCart,
    showLoginPopup,
    setShowLoginPopup,
    handleRemoveFromCart,
    setCartCount,
    setCartItems,
    broadcastCartUpdate,
  } = useCart();
  const {
    wishlist: wishlistItems,
    addToWishlist,
    removeFromWishlist,
    loading: wishlistLoading,
  } = useWishlist();

  /* ── State ── */
  const [itemsInCartInCart, setCartItemsInCart] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [currentFeatured, setCurrentFeatured] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [quantities, setQuantities] = useState({});
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState("home");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCODProcessing, setIsCODProcessing] = useState(false);
  const [isCODConfirmPopUp, setIsCODConfirmPopUp] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [paymentMode, setPaymentMode] = useState("ONLINE");
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [hasFetchedBranches, setHasFetchedBranches] = useState(false);
  const [hasFetchedAddresses, setHasFetchedAddresses] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [originalTotal, setOriginalTotal] = useState(0);
  const [totalSaved, setTotalSaved] = useState(0);
  const [total, setTotal] = useState(0);
  const [bill, setBill] = useState({ discount: 0, delivery_fees: 0 });
  const [addressErrors, setAddressErrors] = useState({
    address_title: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    pincode: "",
    state: "",
    mobile_number: "",
  });
  const [showAddressPrompt, setShowAddressPrompt] = useState(false);
  const [showBranchPrompt, setShowBranchPrompt] = useState(false);

  /* ── Prescription state ──
     A cart can hold several Rx-required products that each came from a
     different doctor's prescription, so more than one prescription can be
     attached to a single order — each entry is either a fresh upload or
     one picked from the customer's previously uploaded prescriptions. */
  // An array so the file picker can be used with `multiple` — the customer
  // can select several prescription photos/files in one go, and each gets
  // uploaded as its own separate prescription record when they confirm.
  const [prescriptionFiles, setPrescriptionFiles] = useState([]);
  const [prescriptionNotes, setPrescriptionNotes] = useState("");
  const [additionalImages, setAdditionalImages] = useState([]); // array of File objects
  const [attachedPrescriptions, setAttachedPrescriptions] = useState(
    loadCartPrescriptions,
  ); // [{ prescription_id, image_url }]
  const prescriptionUploaded = attachedPrescriptions.length > 0;
  const [uploadingPrescription, setUploadingPrescription] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [previousPrescriptions, setPreviousPrescriptions] = useState([]);
  const [loadingPreviousPrescriptions, setLoadingPreviousPrescriptions] =
    useState(false);
  const prescriptionInputRef = useRef(null);
  const additionalImagesRef = useRef(null);

  const scrollRef = useRef(null);
  const shipping = "Free";
  const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
  const itemsPerPage = 8;
  const totalPages = Math.ceil(featuredProducts.length / itemsPerPage);

  const nameRegex = /^[A-Za-z\s]+$/;
  const cityRegex = /^[A-Za-z\s]+$/;
  const addressLineRegex = /^[A-Za-z0-9\s,./\-#]+$/;
  // Real Indian PIN codes never start with 0, so this also rejects
  // all-zero/placeholder values like "000000" that /^\d{6}$/ let through.
  const pincodeRegex = /^[1-9]\d{5}$/;
  const mobileRegex = /^\d{10}$/;

  /* ── Check if any cart item requires prescription ── */
  const hasPrescriptionItems = itemsInCartInCart.some(
    (it) => it.prescription_required === "Yes",
  );

  const getCartQuantity = (vid) => {
    const it = itemsInCartInCart.find((ci) => ci.variant_id === vid);
    return it ? it.quantity : 0;
  };
  // Validate ERP stock through the cart API when adding a Trending product.
  // The listing quantity alone must not prevent a stock validation request.
  const canAddTrendingProduct = (item) => Boolean(item.variant?.[0]?.variant_id);

  /* ── Lifecycle ── */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    saveCartPrescriptions(attachedPrescriptions);
  }, [attachedPrescriptions]);
  useEffect(() => {
    const upd = itemsInCartInCart.reduce((acc, it) => {
      acc[it.variant_id] = it.quantity;
      return acc;
    }, {});
    setQuantities(upd);
  }, [itemsInCartInCart]);
  useEffect(() => {
    if (itemsInCartInCart.length > 0) {
      let disc = 0,
        discTotal = 0;
      itemsInCartInCart.forEach((it) => {
        disc += (it.mrp - it.finalPrice) * it.quantity;
        discTotal += it.finalPrice * it.quantity;
      });
      setBill({ discount: disc, delivery_fees: 0, total: discTotal });
    }
  }, [itemsInCartInCart]);
  useEffect(() => {
    if (selectedDeliveryOption === "pickup" && !hasFetchedBranches) {
      fetchBranches();
      setHasFetchedBranches(true);
    }
    if (selectedDeliveryOption === "home" && !hasFetchedAddresses) {
      fetchAddresses();
      setHasFetchedAddresses(true);
    }
  }, [selectedDeliveryOption]);
  useEffect(() => {
    const s = currentIndex * itemsPerPage;
    setCurrentFeatured(featuredProducts.slice(s, s + itemsPerPage));
  }, [currentIndex, featuredProducts]);

  /* ── Fetch ── */
  const fetchCart = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${api_url}/cart`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      const data = await res.json();
      if (res.ok) {
        const fp = data.data.cartproduct.map((it) => {
          const { mrp, finalPrice, showDiscount, pct } = getPriceFromVariant(
            it.variant?.mrp,
            it.variant?.discounted_price,
          );
          return {
            product_id: it.product_id,
            variant_id: it.variant_id,
            quantity: Number(it.quantity),
            manufacturer:
              it.product?.Manufacturer?.manufacturer_name ??
              it.product?.manufacturer?.manufacturer_name ??
              "N/A",
            name: it.product?.name ?? "Unnamed Product",
            image:
              it.product?.product_images?.image_url?.primary_image ??
              `${api_url}/default-image.jpg`,
            mrp,
            finalPrice,
            showDiscount,
            discount_price: Math.max(mrp - finalPrice, 0),
            pack_size: it.variant?.packing_units ?? "-",
            discount_percent: pct,
            prescription_required: it.product?.prescription_required ?? "No",
          };
        });
        setCartItemsInCart(fp);
        if (fp.length === 0) {
          setAttachedPrescriptions([]);
          clearCartPrescriptions();
        }
        // Don't overwrite the shared cart-count badge with this page's own
        // line count — that's a different metric than /count-cart (which
        // is what the badge is driven by everywhere else), and writing it
        // here is exactly what made the badge disagree between pages.
        calculateSummary(fp);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const fetchFeaturedProduct = async () => {
    try {
      if (!localStorage.getItem("authToken")) return;
      const res = await fetch(`${api_url}/cart-list-products?instock=true`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "x-auth": "false",
        },
      });
      if (!res.ok) throw new Error("Failed to fetch trending products");
      const data = await res.json();
      // Keep the Admin Trending selection; the cart API validates ERP stock.
      setFeaturedProducts(Array.isArray(data.data) ? data.data : []);
    } catch {
      setFeaturedProducts([]);
    }
  };

  const fetchAddresses = async () => {
    try {
      if (!localStorage.getItem("authToken")) return;
      const res = await axios.get(`${api_url}/address/users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      if (res.data.data.length > 0) {
        const withBool = res.data.data.map((a) => ({
          ...a,
          is_default: a.is_default === true || a.is_default === "true",
        }));
        setAddresses(withBool);
        const def = withBool.find((a) => a.is_default) || withBool[0];
        setSelectedAddressId(def.address_id);
        setSelectedAddress(def);
      } else {
        setAddresses([]);
        setSelectedAddress(null);
      }
    } catch {}
  };

  const fetchBranches = async () => {
    try {
      const res = await axios.get(`${api_url}/branches`);
      const raw = res.data.results || [];
      setBranches([...new Map(raw.map((b) => [b.branch_id, b])).values()]);
    } catch {}
  };

  useEffect(() => {
    fetchCart();
    fetchFeaturedProduct();
    fetchAddresses();
  }, []);

  // Cross-tab sync: if an order was placed (or the cart otherwise cleared)
  // in another open tab, that tab writes CART_SYNC_KEY to localStorage,
  // which fires this "storage" event here. Every current broadcaster
  // (Razorpay success, COD success, Clear Cart) only fires once the cart
  // is already empty, so clear this tab's view immediately instead of
  // waiting on a round trip to /cart first — fetchCart() still runs right
  // after to reconcile with the server in case that assumption is ever
  // wrong, but the customer isn't left looking at stale, already-ordered
  // items in the meantime.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === CART_SYNC_KEY) {
        setCartItemsInCart([]);
        setAttachedPrescriptions([]);
        clearCartPrescriptions();
        calculateSummary([]);
        fetchCart();
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Same "/user-prescription" endpoint MyPrescription.js uses to list a
  // customer's uploads — fetched fresh every time the popup opens so a
  // prescription uploaded moments ago elsewhere shows up here too.
  const fetchPreviousPrescriptions = async () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return;
    setLoadingPreviousPrescriptions(true);
    try {
      const res = await axios.get(`${api_url}/user-prescription`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const list = res.data?.data || [];
      // Rejected/cancelled prescriptions are no longer valid and must not
      // be reusable on a new order — exclude them before slicing to the
      // most recent 10 so a rejected one never displaces a usable one.
      const recent = [...list]
        .filter(
          (p) => p.status !== "Rejected" && p.status !== "Cancelled",
        )
        .sort(
          (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0),
        )
        .slice(0, 10);
      setPreviousPrescriptions(recent);
    } catch {
      setPreviousPrescriptions([]);
    } finally {
      setLoadingPreviousPrescriptions(false);
    }
  };

  useEffect(() => {
    if (showPrescriptionModal) fetchPreviousPrescriptions();
  }, [showPrescriptionModal]);

  // Toggle a previously uploaded prescription in/out of this order's
  // attached list — doesn't close the modal, since more than one can be
  // picked (or picked alongside a fresh upload) before the customer is done.
  const toggleExistingPrescription = (prescription) => {
    setAttachedPrescriptions((prev) => {
      const already = prev.some(
        (p) => p.prescription_id === prescription.prescription_id,
      );
      if (already) {
        return prev.filter(
          (p) => p.prescription_id !== prescription.prescription_id,
        );
      }
      return [
        ...prev,
        {
          prescription_id: prescription.prescription_id,
          image_url: prescription.image_url || null,
        },
      ];
    });
  };

  const removeAttachedPrescription = (prescriptionId) => {
    setAttachedPrescriptions((prev) =>
      prev.filter((p) => p.prescription_id !== prescriptionId),
    );
  };

  const calculateSummary = (items) => {
    let orig = 0,
      sub = 0,
      saved = 0;
    items.forEach((it) => {
      const o = it.mrp * it.quantity;
      const d = it.finalPrice * it.quantity;
      orig += o;
      sub += d;
      saved += o - d;
    });
    setOriginalTotal(orig);
    setTotal(sub);
    setTotalSaved(saved);
  };

  /* ── Prescription file handlers ──
     Accepts a FileList so several prescription files can be picked in one
     go (the input has `multiple`) — each valid one is staged and later
     uploaded as its own separate prescription record. */
  const handlePrescriptionFilesSelect = (fileList) => {
    if (!fileList || fileList.length === 0) return;
    // Matches the file types MyPrescription.js accepts, so a prescription
    // valid there isn't rejected here.
    const allowed = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const validFiles = [];
    for (const file of Array.from(fileList)) {
      if (!allowed.includes(file.type)) {
        toast.error(`${file.name}: Only JPG, PNG, PDF, DOC or DOCX files allowed`);
        continue;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error(`${file.name}: File must be under 5MB`);
        continue;
      }
      validFiles.push(file);
    }
    if (validFiles.length) {
      setPrescriptionFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const removeStagedPrescriptionFile = (index) => {
    setPrescriptionFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAdditionalImagesSelect = (files) => {
    if (!files || files.length === 0) return;
    const allowed = ["image/jpeg", "image/jpg", "image/png"];
    const validFiles = [];
    for (const file of Array.from(files)) {
      if (!allowed.includes(file.type)) {
        toast.error(`${file.name}: Only JPG/PNG allowed for medicine images`);
        continue;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error(`${file.name}: File must be under 5MB`);
        continue;
      }
      validFiles.push(file);
    }
    setAdditionalImages((prev) => [...prev, ...validFiles].slice(0, 5)); // max 5 images
  };

  const removeAdditionalImage = (index) => {
    setAdditionalImages((prev) => prev.filter((_, i) => i !== index));
  };

  /* ── Upload prescription ── */
  // Uploads every staged file as its own separate prescription record —
  // the backend takes one file per request, so a batch of N staged files
  // means N sequential POSTs, each appended to attachedPrescriptions as it
  // succeeds. The modal stays open afterward so more can still be added.
  const uploadPrescription = async () => {
    if (uploadingPrescription) return;

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      toast.error("Please log in.");
      return;
    }
    if (prescriptionFiles.length === 0) {
      toast.error("No prescription file selected.");
      return;
    }

    setUploadingPrescription(true);
    setLoading(true);

    let successCount = 0;
    for (const file of prescriptionFiles) {
      try {
        const formData = new FormData();
        formData.append("prescription_file", file);
        if (prescriptionNotes.trim()) {
          formData.append("description_notes", prescriptionNotes.trim());
        }
        additionalImages.forEach((img) => {
          formData.append("additional_images", img);
        });

        const res = await axios.post(`${api_url}/prescription`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        });

        // Extract image_url + prescription_id from res.data.data
        const uploadedUrl =
          res.data?.data?.image_url || res.data?.url || res.data?.data?.url;
        const uploadedId = res.data?.data?.prescription_id || null;

        setAttachedPrescriptions((prev) => [
          ...prev,
          { prescription_id: uploadedId, image_url: uploadedUrl || null },
        ]);
        successCount += 1;
      } catch (error) {
        console.error(error);
        toast.error(`Failed to upload ${file.name}.`);
      }
    }

    setPrescriptionFiles([]);
    setPrescriptionNotes("");
    setAdditionalImages([]);
    if (successCount > 0) fetchPreviousPrescriptions();

    if (successCount > 0) {
      toast.success(
        successCount > 1
          ? `${successCount} prescriptions added. Upload more or tap Done when finished.`
          : "Prescription added. Upload more or tap Done when finished.",
      );
    }

    setUploadingPrescription(false);
    setLoading(false);
  };

  /* ── Cart actions ── */
  const handleQuantityChange = async (
    productId,
    variant_id,
    quantity,
    productName,
    operation,
  ) => {
    if (!productId || !variant_id || typeof quantity !== "number") return;
    const newQty = operation === "increase" ? quantity + 1 : quantity - 1;
    try {
      const res = await fetch(`${api_url}/cart`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          product_id: productId,
          quantity: newQty,
          variant_id,
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.message?.toLowerCase().includes("stock not available"))
          toast.error(`${productName} is out of stock`);
        return;
      }
      const updated = itemsInCartInCart.map((it) =>
        it.product_id === productId && it.variant_id === variant_id
          ? { ...it, quantity: newQty }
          : it,
      );
      setCartItemsInCart(updated);
      calculateSummary(updated);
      setCartItems((prev) =>
        prev.map((it) =>
          it.product_id === productId && it.variant_id === variant_id
            ? { ...it, quantity: newQty }
            : it,
        ),
      );
    } catch {}
  };

  const handleIncrease = (e, item) => {
    e.preventDefault();
    handleQuantityChange(
      item.product_id,
      item.variant_id,
      item.quantity,
      item.name,
      "increase",
    );
  };
  const handleDecrease = (e, item) => {
    e.preventDefault();
    if (item.quantity > 1)
      handleQuantityChange(
        item.product_id,
        item.variant_id,
        item.quantity,
        item.name,
        "decrease",
      );
  };

  const handleIncreaseForTrending = async (e, variant, item) => {
    e.preventDefault();
    const qty = getCartQuantity(variant.variant_id);
    const res = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: qty + 1,
        variant_id: variant.variant_id,
      }),
    });
    const d = await res.json();
    if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
      toast.error(`${item.name} is out of stock`);
      return;
    }
    const n = itemsInCartInCart.map((it) =>
      it.variant_id === variant.variant_id
        ? { ...it, quantity: it.quantity + 1 }
        : it,
    );
    setCartItemsInCart(n);
    calculateSummary(n);
    setCartItems(n);
  };

  const handleDecreaseForTrending = async (e, variant) => {
    e.preventDefault();
    const qty = getCartQuantity(variant.variant_id);
    if (qty === 1) {
      handleRemoveFromCart(variant.product_id, variant.variant_id);
      return;
    }
    const res = await fetch(`${api_url}/cart`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_id: variant.product_id,
        quantity: qty - 1,
        variant_id: variant.variant_id,
      }),
    });
    const d = await res.json();
    if (!res.ok || d.message?.toLowerCase().includes("stock not available")) {
      toast.error("Something went wrong");
      return;
    }
    const n = itemsInCartInCart.map((it) =>
      it.variant_id === variant.variant_id
        ? { ...it, quantity: it.quantity - 1 }
        : it,
    );
    setCartItemsInCart(n);
    calculateSummary(n);
    setCartItems(n);
  };

  const handleDeleteClick = (productId, variantId, data) => {
    setSelectedProduct({ productId, variantId });
    setDeleteData(data);
    setShowModal(true);
  };
  const confirmDelete = async () => {
    if (selectedProduct) {
      try {
        await handleRemoveFromCart(
          selectedProduct.productId,
          selectedProduct.variantId,
        );
      } catch {
      } finally {
        const remaining = itemsInCartInCart.filter(
          (it) =>
            !(
              it.product_id === selectedProduct.productId &&
              it.variant_id === selectedProduct.variantId
            ),
        );
        setCartItemsInCart(remaining);
        if (remaining.length === 0) {
          setAttachedPrescriptions([]);
          clearCartPrescriptions();
        }
        calculateSummary(remaining);
        setCartItems((p) =>
          p.filter(
            (it) =>
              !(
                it.product_id === selectedProduct.productId &&
                it.variant_id === selectedProduct.variantId
              ),
          ),
        );
        setSelectedProduct(null);
        setShowModal(false);
      }
    } else setShowModal(false);
  };

  const handleClearCart = async () => {
    try {
      const res = await axios.delete(`${api_url}/carts`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      if (res.status === 200) {
        setCartItemsInCart([]);
        setAttachedPrescriptions([]);
        clearCartPrescriptions();
        calculateSummary([]);
        setCartItems([]);
        setCartCount(0);
        setShowConfirm(false);
        toast.success("Cart cleared");
        broadcastCartUpdate();
      }
    } catch {
      toast.error("Failed to clear cart");
    }
  };

  const handleclickforfeaturedproduct = (product_id, product) =>
    navigate(`/products/${toProductSlug(product)}`, {
      state: { product_id },
    });

  /* ── Address edit ── */
  const handleChange = (e) => {
    const { name, value } = e.target;
    let s = value;
    if (name === "address_title" || name === "city")
      s = value.replace(/[^A-Za-z\s]/g, "");
    else if (name === "address_line_1" || name === "address_line_2")
      s = value.replace(/[^A-Za-z0-9\s,./\-#]/g, "");
    else if (name === "pincode") s = value.replace(/\D/g, "").slice(0, 6);
    else if (name === "mobile_number")
      s = value.replace(/\D/g, "").slice(0, 10);
    setSelectedAddress((prev) => ({ ...(prev || {}), [name]: s }));
  };

  const isEditFormValid = React.useMemo(() => {
    if (!selectedAddress) return false;
    const t = selectedAddress.address_title?.trim() || "";
    const l1 = selectedAddress.address_line_1?.trim() || "";
    const l2 = selectedAddress.address_line_2?.trim() || "";
    const c = selectedAddress.city?.trim() || "";
    const pin = (selectedAddress.pincode || "").toString();
    const mob = (selectedAddress.mobile_number || "").toString();
    const st = selectedAddress.state || "";
    return (
      nameRegex.test(t) &&
      l1.length > 0 &&
      addressLineRegex.test(l1) &&
      (l2 === "" || addressLineRegex.test(l2)) &&
      cityRegex.test(c) &&
      pincodeRegex.test(pin) &&
      mobileRegex.test(mob) &&
      st !== ""
    );
  }, [selectedAddress]);

  const updateAddress = async (addressId, addr) => {
    try {
      await axios.patch(
        `${api_url}/address/${addressId}`,
        {
          address_title: addr.address_title,
          address_line_1: addr.address_line_1,
          address_line_2: addr.address_line_2,
          pincode: addr.pincode,
          city: addr.city,
          state: addr.state,
          mobile_number: addr.mobile_number,
          is_default: addr.is_default,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        },
      );
      await fetchAddresses();
      toast.success("Address updated!");
      setIsEditPopupOpen(false);
    } catch {
      toast.error("Failed to update address.");
    }
  };

  // The default delivery address is no longer toggled manually in the edit
  // form — it's whichever address is picked here in the "Deliver to"
  // dropdown, so picking one sets it as the default on the backend too.
  const setAddressAsDefault = async (addressId) => {
    const addr = addresses.find((a) => a.address_id === addressId);
    if (!addr) return;
    const alreadyDefault =
      addr.is_default === true || addr.is_default === "true";
    if (alreadyDefault) return;
    try {
      await axios.patch(
        `${api_url}/address/${addressId}`,
        {
          address_title: addr.address_title,
          address_line_1: addr.address_line_1,
          address_line_2: addr.address_line_2,
          pincode: addr.pincode,
          city: addr.city,
          state: addr.state,
          mobile_number: addr.mobile_number,
          is_default: true,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        },
      );
      await fetchAddresses();
    } catch {
      toast.error("Failed to set default delivery address.");
    }
  };

  const handleUpdateAddress = () => {
    if (!selectedAddress) return;
    const errors = {
      address_title: !selectedAddress.address_title?.trim()
        ? "Required"
        : !nameRegex.test(selectedAddress.address_title.trim())
          ? "Letters only"
          : "",
      address_line_1: !selectedAddress.address_line_1?.trim() ? "Required" : "",
      address_line_2: "",
      city: !selectedAddress.city?.trim()
        ? "Required"
        : !cityRegex.test(selectedAddress.city.trim())
          ? "Letters only"
          : "",
      pincode: !pincodeRegex.test((selectedAddress.pincode || "").toString())
        ? "6-digit pincode"
        : "",
      state: !selectedAddress.state ? "Required" : "",
      mobile_number: !mobileRegex.test(
        (selectedAddress.mobile_number || "").toString(),
      )
        ? "10-digit number"
        : "",
    };
    setAddressErrors(errors);
    if (Object.values(errors).some((m) => m)) {
      toast.error("Please fix the highlighted fields");
      return;
    }
    updateAddress(selectedAddress.address_id, selectedAddress);
  };

  /* ── Payment ── */
  const getOutOfStockProductName = (msg) => {
    const m = msg?.match(/Product (.*?) is out of stock/);
    return m
      ? itemsInCartInCart.find((p) => p.id === m[1])?.name || null
      : null;
  };

  // Build order payload — attachedPrescriptions holds every prescription
  // the customer attached to this order (a fresh upload or one picked
  // from previous uploads). Send only the singular ID for one prescription
  // or the ID array for multiple prescriptions; image URLs stay in the UI.
  const buildOrderPayload = (paymentType) => ({
    products: itemsInCartInCart.map((it) => ({
      product_id: it.product_id,
      variant_id: it.variant_id,
      quantity: it.quantity,
      price: it.finalPrice,
      mrp: it.mrp,
    })),
    amount: itemsInCartInCart.reduce(
      (acc, it) => acc + it.finalPrice * it.quantity,
      0,
    ),
    bill,
    address_id: selectedDeliveryOption === "home" ? selectedAddressId : null,
    branch_id: selectedDeliveryOption === "pickup" ? selectedBranchId : null,
    payment_status: "PENDING",
    payment_type: paymentType,
    delivery_type:
      selectedDeliveryOption === "home" ? "Home_Delivery" : "Store_Pickup",
    ...(attachedPrescriptions.length === 1
      ? { prescription_id: attachedPrescriptions[0].prescription_id }
      : attachedPrescriptions.length > 1
        ? {
            prescription_ids: attachedPrescriptions.map((p) => p.prescription_id),
          }
        : {}),
  });

  const onPayment = async () => {
    setIsProcessing(true);
    if (itemsInCartInCart.length === 0) {
      toast.error("Cart is empty.");
      setIsProcessing(false);
      return;
    }
    if (hasPrescriptionItems && !prescriptionUploaded) {
      toast.error("Please upload a prescription before proceeding.");
      setShowPrescriptionModal(true);
      setIsProcessing(false);
      return;
    }
    if (selectedDeliveryOption === "home" && !selectedAddressId) {
      setIsProcessing(false);
      setShowAddressPrompt(true);
      return;
    }
    if (selectedDeliveryOption === "pickup" && !selectedBranchId) {
      setIsProcessing(false);
      setShowBranchPrompt(true);
      return;
    }
    if (paymentMode === "COD") {
      setIsProcessing(false);
      setIsCODConfirmPopUp(true);
      return;
    }

    const ok = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!ok) {
      setIsProcessing(false);
      return;
    }
    try {
      const uRes = await axios.get(`${api_url}/user`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      const uData = uRes.data.data;
      if (!uData?.name?.trim()) {
        toast.error("Please complete your profile before payment.");
        setTimeout(() => navigate("/profilepage"), 1500);
        return;
      }

      const res = await fetch(`${api_url}/api/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify(buildOrderPayload("ONLINE")),
      });
      const orderData = await res.json();
      if (!res.ok || !orderData?.razorpayOrder?.id) {
        const pn = getOutOfStockProductName(orderData?.message);
        toast.error(
          pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
        );
        setIsProcessing(false);
        return;
      }

      const confirmationState = {
        // Always provide something the customer can record immediately.
        // Prefer the customer-facing order number when create-order returns
        // it, then fall back to our internal/Razorpay reference.
        order_number:
          orderData?.data?.orderId ||
          orderData?.data?.details?.[0]?.orderId ||
          orderData?.orderId ||
          orderData?.data?.order_id ||
          orderData?.razorpayOrder?.id,
        order_id: orderData?.data?.order_id || null,
        lookup_order_id:
          orderData?.data?.razorpay_order_id ||
          orderData?.razorpayOrder?.id ||
          orderData?.data?.order_id ||
          null,
      };

      // Do not allow a server-provided Checkout configuration to hide UPI.
      // The remaining order fields (amount, currency, name, prefill, etc.)
      // are still forwarded to Razorpay below.
      const checkoutOptions = { ...orderData };
      delete checkoutOptions.config;
      delete checkoutOptions.checkout_config_id;

      const payObj = new window.Razorpay({
        ...checkoutOptions,
        key: razorpayKey,
        order_id: orderData.razorpayOrder.id,
        config: {
          display: {
            blocks: {
              upi: {
                name: "Pay via UPI",
                instruments: [{ method: "upi" }],
              },
            },
            sequence: ["block.upi"],
            preferences: {
              // Keep cards, netbanking and every other account-enabled
              // Razorpay method available after the highlighted UPI block.
              show_default_blocks: true,
            },
          },
        },
        handler: async (resp) => {
          setCartItemsInCart([]);
          setAttachedPrescriptions([]);
          clearCartPrescriptions();
          setCartItems([]);
          setCartCount(0);
          // Tell any other open tab this cart just got emptied by a
          // completed order, so it can't be checked out again from there.
          broadcastCartUpdate();
          // Pass the real order id through so the Thank You page shows the
          // same Order ID as My Orders / Order Details, instead of a
          // fabricated random number unrelated to the actual order.
          navigate("/ThankYou", {
            state: confirmationState,
          });
          try {
            await fetch(`${api_url}/api/verify-order`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
              body: JSON.stringify({
                order_id: resp.razorpay_order_id,
                payment_id: resp.razorpay_payment_id,
                signature: resp.razorpay_signature,
                orderId: orderData?.data?.order_id,
              }),
            });
          } catch {}
        },
        modal: {
          ondismiss: async () => {
            try {
              await axios.post(
                `${api_url}/api/failed-payment`,
                {
                  order_id: orderData?.data?.order_id,
                  razorpay_payment_id: `DISMISSED_${orderData?.data?.order_id}`,
                  error_source: "popup_closed",
                  error_description: "User dismissed",
                  error_step: "payment_initiation",
                  error_code: "USER_DISMISS",
                  error_reason: "User cancelled",
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                  },
                },
              );
            } catch {}
            toast.error("Payment cancelled");
            setIsProcessing(false);
          },
        },
      });
      payObj.on("payment.failed", async (resp) => {
        try {
          await axios.post(
            `${api_url}/api/failed-payment`,
            {
              order_id: resp.error.metadata.order_id,
              razorpay_payment_id: resp.error.metadata.payment_id,
              error_source: resp.error.source,
              error_description: resp.error.description,
              error_step: resp.error.step,
              error_code: resp.error.code,
              error_reason: resp.error.reason,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
            },
          );
        } catch {}
        toast.error("Payment Failed");
        setIsProcessing(false);
      });
      payObj.open();
    } catch {
      toast.error("An error occurred. Please try again.");
      setIsProcessing(false);
    }
  };

  const handleCODOrder = async () => {
    try {
      setIsCODProcessing(true);
      const res = await fetch(`${api_url}/api/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify(buildOrderPayload("COD")),
      });
      const orderData = await res.json();
      if (!res.ok) {
        const pn = getOutOfStockProductName(orderData?.message);
        toast.error(
          pn ? `${pn} is out of stock.` : orderData?.message || "Server Error",
        );
        return;
      }
      toast.success("Order placed with COD!");
      setCartItemsInCart([]);
      setAttachedPrescriptions([]);
      clearCartPrescriptions();
      setCartItems([]);
      setCartCount(0);
      setIsCODConfirmPopUp(false);
      // Tell any other open tab this cart just got emptied by a completed
      // order, so it can't be checked out again from there.
      broadcastCartUpdate();
      const confirmationState = {
        order_number:
          orderData?.data?.orderId ||
          orderData?.data?.details?.[0]?.orderId ||
          orderData?.orderId ||
          orderData?.data?.order_id ||
          orderData?.razorpayOrder?.id,
        order_id: orderData?.data?.order_id || null,
        lookup_order_id:
          orderData?.data?.razorpay_order_id ||
          orderData?.razorpayOrder?.id ||
          orderData?.data?.order_id ||
          null,
      };
      // Pass the real order id through so the Thank You page shows the
      // same Order ID as My Orders / Order Details, instead of a
      // fabricated random number unrelated to the actual order.
      navigate("/ThankYou", {
        state: confirmationState,
      });
    } catch {
      toast.error("Failed to place COD order");
    } finally {
      setIsCODProcessing(false);
      setIsProcessing(false);
    }
  };

  const selectedAddrObj = addresses.find(
    (a) => a.address_id === selectedAddressId,
  );
  const selectedBranchObj = branches.find(
    (b) => b.branch_id === selectedBranchId,
  );

  /* ══════════════════ RENDER ══════════════════ */
  return (
    <div className="min-h-screen bg-[#f2f8f7] font-poppins">
      <Helmet>
        <title>Shopping Cart | MediSYS Pharmacy</title>
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="mx-auto px-4 sm:px-6 py-6 sm:mt-0 mt-36">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-[12px] text-[#5a7a77] mb-4 font-medium flex-wrap">
          <Link
            to="/home"
            className="hover:text-[#1e4a46] transition-colors text-[#5a7a77]"
            style={{ textDecoration: "none" }}
          >
            Home
          </Link>
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
            <path
              d="M6 12l4-4-4-4"
              stroke="#8faba9"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-[#1e4a46] font-bold">My Cart</span>
        </nav>

        <div className="flex items-center justify-between mb-5">
          <div>
            <h1
              className="text-[22px] font-black text-[#0a1715] mb-0.5"
              style={{ fontFamily: "'Nunito',sans-serif" }}
            >
              My Cart
            </h1>
            <p className="text-[13px] text-[#5a7a77] font-medium">
              Review your items before checkout
            </p>
          </div>
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-24 gap-4">
            <img
              src={loader}
              alt="Loading"
              className="w-14 h-14 animate-pulse"
            />
            <p className="text-[13px] text-[#2d5250] font-medium">
              Loading cart…
            </p>
          </div>
        ) : itemsInCartInCart.length > 0 ? (
          <>
            {/* ════ MAIN 2-COL GRID — 60/40 split ════ */}
            <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-5 items-start">
              {/* ════ LEFT COLUMN ════ */}
              <div className="flex flex-col gap-4 min-w-0">
                {/* ─ Prescription Banner ─ */}
                {hasPrescriptionItems && (
                  <div
                    className={`rounded-2xl border-[1.5px] overflow-hidden transition-all duration-300 ${prescriptionUploaded ? "border-green-200 bg-green-50" : "border-[#ffd5c2] bg-[#fff3ee]"}`}
                  >
                    <div className="px-4 sm:px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                      <div className="flex items-start gap-3 flex-1 min-w-0">
                        <div
                          className={`w-11 h-11 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${prescriptionUploaded ? "bg-green-100 border border-green-200" : "bg-[#fff3ee] border border-[#ffd5c2]"}`}
                        >
                          {prescriptionUploaded ? (
                            <CheckCircle size={22} className="text-green-600" />
                          ) : (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#ff601e"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline points="14 2 14 8 20 8" />
                              <line x1="12" y1="18" x2="12" y2="12" />
                              <line x1="9" y1="15" x2="15" y2="15" />
                            </svg>
                          )}
                        </div>
                        <div className="min-w-0">
                          <p
                            className={`text-[13px] font-bold ${prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"}`}
                          >
                            {prescriptionUploaded
                              ? "✓ Prescription Uploaded"
                              : "Prescription Required"}
                          </p>
                          <p
                            className={`text-[11px] mt-0.5 leading-snug break-words ${prescriptionUploaded ? "text-green-600" : "text-[#2d5250]"}`}
                          >
                            {prescriptionUploaded
                              ? `${attachedPrescriptions.length} prescription${attachedPrescriptions.length > 1 ? "s" : ""} added`
                              : "One or more items in your cart require a valid doctor's prescription"}
                          </p>
                        </div>
                      </div>
                      {prescriptionUploaded ? (
                        <button
                          onClick={() => setShowPrescriptionModal(true)}
                          className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-[11px] font-semibold text-green-600 border border-green-200 bg-white px-3 py-2 sm:py-1.5 rounded-xl hover:border-green-400 transition-all"
                        >
                          <svg
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                          Manage
                        </button>
                      ) : (
                        <button
                          onClick={() => setShowPrescriptionModal(true)}
                          className="w-full sm:w-auto justify-center flex items-center gap-1.5 text-[12px] font-bold text-white bg-[#ff601e] hover:bg-[#e55519] px-4 py-2 rounded-xl transition-all border-none cursor-pointer shadow-[0_2px_10px_rgba(255,96,30,0.35)]"
                        >
                          <Upload size={13} />
                          Upload Now
                        </button>
                      )}
                    </div>
                    {!prescriptionUploaded && (
                      <div className="px-4 sm:px-5 pb-4">
                        <div className="flex flex-wrap gap-1.5 sm:gap-2">
                          {itemsInCartInCart
                            .filter((it) => it.prescription_required === "Yes")
                            .map((it) => (
                              <span
                                key={it.variant_id}
                                className="text-[9px] sm:text-[10px] font-semibold text-[#ff601e] bg-white border border-[#ffd5c2] px-2 py-1 rounded-full flex items-center gap-1 max-w-full"
                              >
                                <svg
                                  width="9"
                                  height="9"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#ff601e"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                  <polyline points="14 2 14 8 20 8" />
                                </svg>
                                <span className="truncate">
                                  {it.name.length > 25
                                    ? it.name.slice(0, 25) + "…"
                                    : it.name}
                                </span>
                              </span>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* ─ Cart Items ─ */}
                <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
                  <SCardHead
                    title="Cart Items"
                    badge={`${itemsInCartInCart.length} item${itemsInCartInCart.length !== 1 ? "s" : ""}`}
                    icon={
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5fbdb3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="9" cy="21" r="1" />
                        <circle cx="20" cy="21" r="1" />
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                      </svg>
                    }
                  />
                  <div className="p-4">
                    <div className="flex justify-end mb-3">
                      <button
                        onClick={() => setShowConfirm(true)}
                        className="text-[12px] font-semibold text-[#ff601e] border border-[#ffd5c2] rounded-[10px] px-3 py-1.5 hover:bg-[#fff3ee] transition-colors"
                      >
                        Clear Cart
                      </button>
                    </div>
                    <div className="flex flex-col gap-3">
                      {itemsInCartInCart.map((item) => (
                        <div
                          key={`${item.product_id}-${item.variant_id}`}
                          className="bg-[#f2f8f7] rounded-xl border-[1.5px] border-[#c8d8d7] hover:border-[#5fbdb3] p-3 grid grid-cols-[64px_minmax(0,1fr)] sm:flex gap-3 transition-all duration-200 group"
                        >
                          <div
                            className="w-16 h-16 sm:w-[96px] sm:h-[96px] sm:min-w-[96px] rounded-[12px] border border-[#c8d8d7] overflow-hidden cursor-pointer flex-shrink-0 group"
                            onClick={() =>
                              handleclickforfeaturedproduct(
                                item.product_id,
                                item,
                              )
                            }
                          >
                            <img
                              src={item.image || "/default.svg"}
                              alt={item.name}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/default.svg";
                              }}
                              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                            />
                          </div>
                          <div className="flex-1 min-w-0 flex flex-col gap-1">
                            <div className="flex flex-col sm:flex-row items-start gap-2">
                              <p
                                className="text-[12px] font-bold text-[#1e4a46] leading-snug cursor-pointer hover:text-[#ff601e] transition-colors whitespace-normal [overflow-wrap:anywhere] sm:line-clamp-2 min-w-0 flex-1"
                                onClick={() =>
                                  handleclickforfeaturedproduct(
                                    item.product_id,
                                    item,
                                  )
                                }
                              >
                                {item.name}
                              </p>
                              {item.prescription_required === "Yes" && (
                                <span
                                  className={`flex items-center gap-1 text-[9px] font-bold px-2 py-0.5 rounded-full flex-shrink-0 ${prescriptionUploaded ? "bg-green-100 text-green-700 border border-green-200" : "bg-[#fff3ee] text-[#ff601e] border border-[#ffd5c2]"}`}
                                >
                                  {prescriptionUploaded ? (
                                    <>
                                      <CheckCircle size={9} />
                                      Rx ✓
                                    </>
                                  ) : (
                                    <>
                                      <AlertCircle size={9} />
                                      Rx Req
                                    </>
                                  )}
                                </span>
                              )}
                            </div>
                            <p className="text-[10px] text-[#5a7a77] font-medium whitespace-normal [overflow-wrap:anywhere]">
                              By {item.manufacturer} · Pack: {item.pack_size}
                            </p>
                            <div className="flex items-center gap-2 flex-wrap">
                              {item.showDiscount && (
                                <span className="text-[10px] text-[#7a9b98] line-through">
                                  ₹{(item.mrp * item.quantity).toFixed(2)}
                                </span>
                              )}
                              <span
                                className="text-[14px] font-black text-[#1e4a46]"
                                style={{ fontFamily: "'Nunito',sans-serif" }}
                              >
                                ₹{(item.finalPrice * item.quantity).toFixed(2)}
                              </span>
                              {item.showDiscount &&
                                item.discount_percent > 0 && (
                                  <span className="text-[9px] font-bold bg-[#ddf0ee] border border-[#aac9c7] text-[#1e4a46] px-1.5 py-0.5 rounded-full">
                                    {item.discount_percent}% OFF
                                  </span>
                                )}
                            </div>
                          </div>

                          {/* Mobile actions sit below the details to leave room for full names. */}
                          <div className="col-span-2 flex flex-row justify-between items-center sm:flex-col sm:justify-start sm:items-end gap-2 flex-shrink-0">
  {/* Delete button - top */}
  <button
    className="w-8 h-8 rounded-[8px] border border-[#c8d8d7] bg-white flex items-center justify-center text-[#2d5250] hover:border-red-300 hover:text-red-500 transition-all flex-shrink-0"
    onClick={() =>
      handleDeleteClick(item.product_id, item.variant_id, item)
    }
  >
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6" />
      <path d="M8 6V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2" />
      <path d="M10 11v6M14 11v6" />
      <path d="M5 6l1 14c.1 1.1.9 2 2 2h8c1.1 0 1.9-.9 2-2l1-14" />
    </svg>
  </button>

  {/* Quantity stepper - bottom */}
  <div className="flex items-center bg-white border border-[#aac9c7] rounded-xl h-10 px-1.5 gap-1">
    <button
      onClick={(e) => handleDecrease(e, item)}
      className="w-9 h-9 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-xl hover:bg-[#ddf0ee] transition-colors"
    >
      −
    </button>
    <span
      className="font-black text-[15px] text-[#1e4a46] min-w-[26px] text-center"
      style={{ fontFamily: "'Nunito',sans-serif" }}
    >
      {quantities[item.variant_id] || item.quantity}
    </span>
    <button
      onClick={(e) => handleIncrease(e, item)}
      className="w-9 h-9 rounded-[8px] flex items-center justify-center text-[#1e4a46] font-black text-xl hover:bg-[#ddf0ee] transition-colors"
    >
      +
    </button>
  </div>
</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* ════ TRENDING PRODUCTS — placed right below the cart items
                    list (not above it, not after the whole checkout column)
                    so it's visible without much scrolling. ════ */}
                {featuredProducts.length > 0 && (
                  <div className="mb-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-5 gap-4">
                      {/* LEFT SECTION */}
                      <div>
                        <div className="flex items-center gap-2 mb-1.5">
                          <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
                          <span className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-[#ff601e]">
                            You May Also Like
                          </span>
                        </div>
    
                        <h2
                          className="text-[18px] sm:text-[20px] font-black text-[#1e4a46]"
                          style={{ fontFamily: "'Nunito',sans-serif" }}
                        >
                          Trending Products
                        </h2>
                      </div>
    
                      {/* RIGHT SECTION */}
                      <div className="hidden lg:flex items-center justify-end gap-2">
                        <div className="flex items-center gap-2">
                          {/* PREV */}
                          <button
                            onClick={() =>
                              setCurrentIndex((p) => Math.max(0, p - 1))
                            }
                            disabled={currentIndex === 0}
                            className="w-8 h-8 sm:w-9 sm:h-9 rounded-[8px] sm:rounded-[10px] border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#ddf0ee] disabled:opacity-30 transition-all"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#374747"
                              strokeWidth="2.5"
                            >
                              <path d="M19 12H5M12 5l-7 7 7 7" />
                            </svg>
                          </button>
    
                          {/* NEXT */}
                          <button
                            onClick={() =>
                              setCurrentIndex((p) =>
                                Math.min(totalPages - 1, p + 1),
                              )
                            }
                            disabled={currentIndex >= totalPages - 1}
                            className="w-8 h-8 sm:w-9 sm:h-9 rounded-[8px] sm:rounded-[10px] border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] hover:bg-[#ddf0ee] disabled:opacity-30 transition-all"
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#374747"
                              strokeWidth="2.5"
                            >
                              <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                          </button>
                        </div>
    
                        {/* VIEW ALL */}
                        {/* <Link to="/featured-products">
                          <button className="flex items-center gap-1 text-[11px] sm:text-[12px] px-3 sm:px-4 h-8 sm:h-9 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold rounded-[8px] sm:rounded-[10px] transition-all shadow-[0_2px_8px_rgba(22,44,42,0.25)]">
                            View All
                            <svg
                              width="10"
                              height="10"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.5"
                            >
                              <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                          </button>
                        </Link> */}
                      </div>
                    </div>
    
                    {/* Desktop grid — 4 columns (not 8) since this section now
                        lives inside the narrower left column rather than
                        spanning the full page width; 8 columns here made
                        every card too cramped. */}
                    <div className="hidden lg:grid grid-cols-4 gap-4">
                      {" "}
                      {currentFeatured.map((item, index) => {
                        const altQty = getCartQuantity(
                          item.variant?.[0]?.variant_id,
                        );
                        const isOrange = index % 2 === 1;
                        const isWish = wishlistItems.some(
                          (w) =>
                            w.product_id === item.product_id &&
                            w.variant_id === item.variant?.[0]?.variant_id,
                        );
                        const canAdd = canAddTrendingProduct(item);
                        const {
                          mrp: tMrp,
                          finalPrice: tFinal,
                          showDiscount: tDisc,
                          pct: tPct,
                        } = getPriceFromVariant(
                          item.variant?.[0]?.mrp,
                          item.variant?.[0]?.discounted_price,
                        );
                        return (
                          <div
                            key={item.product_id || index}
                            className={`group border-[1.5px] ${isOrange ? "border-[#ffd5c2] hover:border-[#ff601e]/60" : "border-[#c8d8d7] hover:border-[#5fbdb3]"} bg-white rounded-[18px] overflow-hidden flex flex-col cursor-pointer hover:-translate-y-2 hover:shadow-[0_12px_36px_rgba(22,44,42,0.15)] shadow-[0_2px_10px_rgba(22,44,42,0.07)] transition-all duration-300 relative`}
                            style={{
                              animation: `fadeInUp 0.35s ease ${index * 60}ms both`,
                            }}
                          >
                            <div
                              className={`absolute top-0 left-0 right-0 h-[3px] ${isOrange ? "bg-gradient-to-r from-[#ff601e] to-[#e55519]" : "bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]"} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
                            />
                            {tDisc && tPct > 0 && (
                              <div className="absolute top-3 right-3 bg-[#ff601e] text-white text-[9px] font-bold w-9 h-9 rounded-full flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(255,96,30,0.45)] z-10 leading-tight text-center">
                                {tPct}%<br />
                                OFF
                              </div>
                            )}
                            <button
                              className="absolute top-3 left-3 z-10 w-7 h-7 bg-white rounded-xl border border-[#c8d8d7] flex items-center justify-center shadow-sm hover:border-[#5fbdb3] hover:bg-[#ddf0ee] transition-all duration-200"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!localStorage.getItem("authToken")) {
                                  setShowLoginPopup(true);
                                  return;
                                }
                                isWish
                                  ? removeFromWishlist(
                                      item.product_id,
                                      item.variant?.[0]?.variant_id,
                                    )
                                  : addToWishlist(item, item.variant?.[0]);
                              }}
                            >
                              <img
                                src={isWish ? wish : wishlist}
                                alt="wish"
                                className="w-3.5 h-3.5"
                              />
                            </button>
                            <div
                              className="w-full h-[150px] flex items-center justify-center cursor-pointer group overflow-hidden bg-[#1E4A46]"
                              onClick={() =>
                                handleclickforfeaturedproduct(item.product_id, item)
                              }
                            >
                              <img
                                src={
                                  item?.product_images?.image_url?.primary_image ||
                                  "/default.svg"
                                }
                                alt={item.name}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/default.svg";
                                }}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                              />
                            </div>
                            <div className="w-full h-px bg-[#f1f5f5]" />
                            <div
                              className="p-3 flex-1 cursor-pointer"
                              onClick={() =>
                                handleclickforfeaturedproduct(item.product_id, item)
                              }
                            >
                              <h3 className="font-semibold text-[11px] text-[#1e4a46] line-clamp-2 leading-snug group-hover:text-[#ff601e] transition-colors mb-1.5">
                                {item.name}
                              </h3>
                              <div className="flex items-baseline gap-1.5 flex-wrap">
                                {tMrp > 0 ? (
                                  <>
                                    {tDisc && (
                                      <span className="text-[10px] text-[#7a9b98] line-through">
                                        ₹{tMrp}
                                      </span>
                                    )}
                                    <span
                                      className="text-[13px] font-black text-[#1e4a46]"
                                      style={{ fontFamily: "'Nunito',sans-serif" }}
                                    >
                                      ₹{tFinal}
                                    </span>
                                    {tDisc && tPct > 0 && (
                                      <span
                                        className={`text-[10px] font-semibold ${isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
                                      >
                                        {tPct}% off
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  <span className="text-[11px] text-[#1e3330]">
                                    Price N/A
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="px-3 pb-3">
                              {altQty > 0 ? (
                                <div className="flex items-center justify-between bg-[#ddf0ee] border border-[#aac9c7] rounded-xl h-9 px-2">
                                  <button
                                    onClick={(e) =>
                                      handleDecreaseForTrending(
                                        e,
                                        item.variant[0],
                                        item,
                                      )
                                    }
                                    className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
                                  >
                                    −
                                  </button>
                                  <span className="font-black text-[13px] text-[#1e4a46]">
                                    {altQty}
                                  </span>
                                  <button
                                    onClick={(e) =>
                                      handleIncreaseForTrending(
                                        e,
                                        item.variant[0],
                                        item,
                                      )
                                    }
                                    className="w-6 h-6 flex items-center justify-center text-[#1e4a46] font-black text-lg hover:bg-white rounded-lg transition-colors"
                                  >
                                    +
                                  </button>
                                </div>
                              ) : (
                                <button
                                  disabled={!canAdd}
                                  className={`w-full h-9 ${isOrange ? "bg-[#ff601e] hover:bg-[#e55519]" : "bg-[#1e4a46] hover:bg-[#ff601e]"} text-white text-[13px] font-bold rounded-[10px] flex items-center justify-center gap-1.5 transition-all duration-200 border-none disabled:bg-[#c5d5d4] disabled:cursor-not-allowed cursor-pointer`}
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    if (!localStorage.getItem("authToken")) {
                                      setShowLoginPopup(true);
                                      return;
                                    }
                                    await handleAddToCart(item, item.variant[0], 1);
                                    await fetchCart();
                                  }}
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="white"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <circle cx="9" cy="21" r="1" />
                                    <circle cx="20" cy="21" r="1" />
                                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                  </svg>
                                  Add to Cart
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
    
                    {/* Mobile scroll */}
                    <div className="lg:hidden relative pt-14">
                      <p className="absolute left-0 top-3 text-[12px] font-medium text-[#5a7a77]">Swipe to explore</p>
                      <button
                        onClick={() =>
                          scrollRef.current?.scrollBy({
                            left: -(scrollRef.current?.firstElementChild?.getBoundingClientRect().width + 12 || 240),
                            behavior: "smooth",
                          })
                        }
                        type="button"
                        aria-label="Previous trending product"
                        className="absolute right-14 top-0 w-11 h-11 bg-white rounded-xl border border-[#c8d8d7] flex items-center justify-center text-[#1e4a46] active:bg-[#ddf0ee] focus-visible:outline-2 focus-visible:outline-[#1e4a46] cursor-pointer"
                      >
                        <ChevronLeft size={15} />
                      </button>
                      <div
                        ref={scrollRef}
                        role="region"
                        aria-label="Trending products"
                        tabIndex={0}
                        className="flex items-stretch gap-3 overflow-x-auto overscroll-x-contain snap-x snap-mandatory scrollbar-hide pb-3 scroll-smooth motion-reduce:scroll-auto"
                      >
                        {featuredProducts.map((item, index) => {
                          const altQty = getCartQuantity(
                            item.variant?.[0]?.variant_id,
                          );
                          const isOrange = index % 2 === 1;
                          const {
                            mrp: tMrp,
                            finalPrice: tFinal,
                            showDiscount: tDisc,
                            pct: tPct,
                          } = getPriceFromVariant(
                            item.variant?.[0]?.mrp,
                            item.variant?.[0]?.discounted_price,
                          );
                          const canAdd = canAddTrendingProduct(item);
                          return (
                            <div
                              key={item.product_id || index}
                              className={`snap-start flex-shrink-0 w-[78%] max-w-[260px] sm:w-[220px] rounded-[18px] border-[1.5px] ${isOrange ? "border-[#ffd5c2]" : "border-[#c8d8d7]"} bg-white overflow-hidden flex flex-col cursor-pointer shadow-[0_2px_10px_rgba(22,44,42,0.07)]`}
                            >
                              <div
                                className={`h-[150px] ${isOrange ? "bg-[#fff8f5]" : "bg-[#e8f5f4]"} flex items-center justify-center p-4`}
                                onClick={() =>
                                  handleclickforfeaturedproduct(
                                    item.product_id,
                                    item,
                                  )
                                }
                              >
                                <img
                                  src={
                                    item?.product_images?.image_url
                                      ?.primary_image || "/default.svg"
                                  }
                                  alt={item.name}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/default.svg";
                                  }}
                                  className="max-h-full max-w-full object-contain"
                                />
                              </div>
                              <div className="w-full h-px bg-[#f1f5f5]" />
                              <div
                                className="p-3 flex-1"
                                onClick={() =>
                                  handleclickforfeaturedproduct(
                                    item.product_id,
                                    item,
                                  )
                                }
                              >
                                <p className="text-[13px] font-semibold text-[#1e4a46] leading-5 whitespace-normal [overflow-wrap:anywhere] mb-2">
                                  {item.name}
                                </p>
                                {tMrp > 0 ? (
                                  <div className="flex items-baseline gap-1 flex-wrap">
                                    {tDisc && (
                                      <span className="text-[10px] text-[#7a9b98] line-through">
                                        ₹{tMrp}
                                      </span>
                                    )}
                                    <span className="text-[16px] font-black text-[#1e4a46]">
                                      ₹{tFinal}
                                    </span>
                                    {tDisc && tPct > 0 && (
                                      <span className="text-[9px] font-bold text-[#5fbdb3]">
                                        {tPct}% off
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  <span className="text-[11px] text-[#1e3330]">
                                    N/A
                                  </span>
                                )}
                              </div>
                              <div className="px-3 pb-3 mt-auto">
                                {altQty > 0 ? (
                                  <div className="flex items-center justify-between bg-[#ddf0ee] border border-[#aac9c7] rounded-xl min-h-11 px-1">
                                    <button
                                      aria-label={`Decrease quantity of ${item.name}`}
                                      onClick={(e) =>
                                        handleDecreaseForTrending(
                                          e,
                                          item.variant[0],
                                          item,
                                        )
                                      }
                                      className="w-11 h-11 flex items-center justify-center text-[#1e4a46] font-black text-xl rounded-lg active:bg-[#c8e5e2] cursor-pointer"
                                    >
                                      −
                                    </button>
                                    <span className="font-black text-[12px] text-[#1e4a46]">
                                      {altQty}
                                    </span>
                                    <button
                                      aria-label={`Increase quantity of ${item.name}`}
                                      onClick={(e) =>
                                        handleIncreaseForTrending(
                                          e,
                                          item.variant[0],
                                          item,
                                        )
                                      }
                                      className="w-11 h-11 flex items-center justify-center text-[#1e4a46] font-black text-xl rounded-lg active:bg-[#c8e5e2] cursor-pointer"
                                    >
                                      +
                                    </button>
                                  </div>
                                ) : (
                                  <button
                                    disabled={!canAdd}
                                    className={`w-full min-h-11 ${isOrange ? "bg-[#ff601e]" : "bg-[#1e4a46]"} text-white text-[13px] font-bold rounded-[10px] flex items-center justify-center gap-1 border-none disabled:bg-[#c5d5d4] cursor-pointer`}
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      if (!localStorage.getItem("authToken")) {
                                        setShowLoginPopup(true);
                                        return;
                                      }
                                      await handleAddToCart(
                                        item,
                                        item.variant[0],
                                        1,
                                      );
                                      await fetchCart();
                                    }}
                                  >
                                    <svg
                                      width="11"
                                      height="11"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="white"
                                      strokeWidth="2.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <circle cx="9" cy="21" r="1" />
                                      <circle cx="20" cy="21" r="1" />
                                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                    </svg>
                                    Add to Cart
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <button
                        onClick={() =>
                          scrollRef.current?.scrollBy({
                            left: scrollRef.current?.firstElementChild?.getBoundingClientRect().width + 12 || 240,
                            behavior: "smooth",
                          })
                        }
                        type="button"
                        aria-label="Next trending product"
                        className="absolute right-0 top-0 w-11 h-11 bg-white rounded-xl border border-[#c8d8d7] flex items-center justify-center text-[#1e4a46] active:bg-[#ddf0ee] focus-visible:outline-2 focus-visible:outline-[#1e4a46] cursor-pointer"
                      >
                        <ChevronRight size={15} />
                      </button>
                    </div>
                  </div>
                )}

              </div>

              {/* ════ RIGHT COLUMN — Bill Summary ════ */}
              <div className="lg:sticky lg:top-4 flex flex-col gap-4 min-w-0">
                {/* Delivery Card */}
                <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
                  <SCardHead
                    title="Delivery Option"
                    icon={
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5fbdb3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M1 3h15v13H1z" />
                        <path d="M16 8h4l3 3v5h-7V8z" />
                        <circle cx="5.5" cy="18.5" r="2.5" />
                        <circle cx="18.5" cy="18.5" r="2.5" />
                      </svg>
                    }
                  />
                  <div className="p-4 flex flex-col gap-3">
                    {/* Toggle */}
                    <div className="flex gap-1.5 p-1 bg-[#e8f5f4] rounded-xl border border-[#c8d8d7]">
                      {[
                        {
                          val: "home",
                          label: "Home Delivery",
                          icon: (
                            <>
                              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                              <polyline points="9 22 9 12 15 12 15 22" />
                            </>
                          ),
                        },
                        {
                          val: "pickup",
                          label: "Store Pickup",
                          icon: (
                            <>
                              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                              <circle cx="12" cy="10" r="3" />
                            </>
                          ),
                        },
                      ].map((opt) => (
                        <button
                          key={opt.val}
                          onClick={() => setSelectedDeliveryOption(opt.val)}
                          className={`flex-1 flex items-center justify-center gap-1.5 py-2 rounded-[10px] text-[12px] font-bold transition-all duration-200 border-none cursor-pointer
                              ${selectedDeliveryOption === opt.val ? "bg-[#1e4a46] text-white shadow-[0_2px_8px_rgba(22,44,42,0.3)]" : "bg-transparent text-[#2d5250] hover:text-[#1e4a46]"}`}
                        >
                          <svg
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            {opt.icon}
                          </svg>
                          {opt.label}
                        </button>
                      ))}
                    </div>

                    {/* Address / Branch */}
                    {selectedDeliveryOption === "home" ? (
                      addresses.length > 0 ? (
                        <div className="flex flex-col gap-2.5">
                          <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide">
                            Deliver to
                          </label>
                          <WrapDropdown
                            value={selectedAddressId || ""}
                            placeholder="Select an address"
                            options={addresses.map((addr) => ({
                              id: addr.address_id,
                              label: `${addr.address_title} — ${addr.address_line_1}, ${addr.city}`,
                            }))}
                            onChange={(id) => {
                              setSelectedAddressId(id);
                              setSelectedAddress(
                                addresses.find((a) => a.address_id === id) ||
                                  null,
                              );
                              setAddressAsDefault(id);
                            }}
                          />
                          {selectedAddrObj && (
                            <div className="bg-[#e8f5f4] border border-[#aac9c7] rounded-[12px] px-3 py-2.5 flex items-start gap-2">
                              <MapPin
                                size={13}
                                className="text-[#5fbdb3] mt-0.5 flex-shrink-0"
                              />
                              <div className="flex-1 min-w-0">
                                <p className="text-[11px] text-[#1e3330] leading-relaxed">
                                  {selectedAddrObj.address_line_1}
                                  {selectedAddrObj.address_line_2
                                    ? `, ${selectedAddrObj.address_line_2}`
                                    : ""}
                                  , {selectedAddrObj.city},{" "}
                                  {selectedAddrObj.pincode},{" "}
                                  {selectedAddrObj.state}
                                </p>
                                <p className="text-[10px] text-[#2d5250] mt-0.5">
                                  📞 {selectedAddrObj.mobile_number}
                                </p>
                              </div>
                              <button
                                className="w-6 h-6 rounded-[7px] border border-[#aac9c7] bg-white flex items-center justify-center flex-shrink-0 hover:border-[#5fbdb3] transition-colors"
                                onClick={() => {
                                  setSelectedAddress({
                                    ...selectedAddrObj,
                                    is_default:
                                      selectedAddrObj.is_default === true ||
                                      selectedAddrObj.is_default === "true",
                                  });
                                  setIsEditPopupOpen(true);
                                }}
                              >
                                <svg
                                  width="10"
                                  height="10"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#8faba9"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                </svg>
                              </button>
                            </div>
                          )}
                          <button
                            onClick={() => setPopupOpen(true)}
                            className="flex items-center gap-1.5 text-[12px] font-semibold text-[#5fbdb3] hover:text-[#1e4a46] transition-colors"
                          >
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <line x1="12" y1="8" x2="12" y2="16" />
                              <line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                            Add New Address
                          </button>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-2 items-center py-3">
                          <p className="text-[12px] text-[#2d5250] text-center">
                            No addresses saved yet.
                          </p>
                          <button
                            onClick={() => setPopupOpen(true)}
                            className="text-[12px] font-semibold text-white bg-[#1e4a46] hover:bg-[#ff601e] px-4 py-2 rounded-xl transition-colors border-none cursor-pointer"
                          >
                            Add Address
                          </button>
                        </div>
                      )
                    ) : (
                      <div className="flex flex-col gap-2.5">
                        {branches.length > 0 ? (
                          <>
                            <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide">
                              Select Store
                            </label>
                            <WrapDropdown
                              value={selectedBranchId || ""}
                              placeholder="Choose a Store...."
                              options={branches.map((b) => ({
                                id: b.branch_id,
                                label: `${b.area} — ${b.branch_address}`,
                              }))}
                              onChange={(id) => setSelectedBranchId(id)}
                            />
                            {selectedBranchObj && (
                              <div className="bg-[#e8f5f4] border border-[#aac9c7] rounded-[12px] px-3 py-2 flex items-start gap-2">
                                <MapPin
                                  size={12}
                                  className="text-[#5fbdb3] flex-shrink-0 mt-0.5"
                                />
                                <p className="text-[11px] text-[#1e3330] leading-relaxed break-words min-w-0 flex-1">
                                  {selectedBranchObj.area} -{" "}
                                  {selectedBranchObj.branch_address},{" "}
                                  {selectedBranchObj.pincode}
                                </p>
                              </div>
                            )}
                          </>
                        ) : (
                          <p className="text-[12px] text-[#2d5250] text-center py-2">
                            No branches available.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Payment Card */}
                <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
                  <SCardHead
                    title="Payment Mode"
                    icon={
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5fbdb3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="1" y="4" width="22" height="16" rx="2" />
                        <line x1="1" y1="10" x2="23" y2="10" />
                      </svg>
                    }
                  />
                  <div className="p-4 flex flex-col gap-2.5">
                    {[
                      {
                        val: "ONLINE",
                        label: "Online Payment",
                        sub: "UPI · Net Banking · Cards",
                        icon: "💳",
                      },
                      {
                        val: "COD",
                        label: "Cash on Delivery",
                        sub: "Pay when your order arrives",
                        icon: "💵",
                      },
                    ].map((opt) => (
                      <div
                        key={opt.val}
                        onClick={() => setPaymentMode(opt.val)}
                        className={`flex items-center gap-3 p-3 rounded-xl border-[1.5px] cursor-pointer transition-all duration-200
                            ${paymentMode === opt.val ? "border-[#5fbdb3] bg-[#e8f5f4] shadow-[0_2px_8px_rgba(95,189,179,0.15)]" : "border-[#c8d8d7] hover:border-[#5fbdb3]/50 hover:bg-[#f2f8f7]"}`}
                      >
                        <div
                          className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg flex-shrink-0 ${paymentMode === opt.val ? "bg-[#ddf0ee] border border-[#aac9c7]" : "bg-[#f1f5f5]"}`}
                        >
                          {opt.icon}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-[13px] font-bold text-[#1e4a46]">
                            {opt.label}
                          </p>
                          <p className="text-[11px] text-[#2d5250] mt-0.5">
                            {opt.sub}
                          </p>
                        </div>
                        <RadioDot active={paymentMode === opt.val} />
                      </div>
                    ))}
                    <div className="flex items-center gap-2 mt-1 bg-[#e8f5f4] rounded-xl px-3 py-2 border border-[#c8d8d7]">
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5fbdb3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                      <p className="text-[10px] text-[#2d5250]">
                        All transactions are 100% secure &amp; encrypted
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-2xl border-[1.5px] border-[#c8d8d7] overflow-hidden shadow-[0_2px_12px_rgba(22,44,42,0.06)]">
                  <SCardHead
                    title="Bill Summary"
                    icon={
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#5fbdb3"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="8" y1="6" x2="21" y2="6" />
                        <line x1="8" y1="12" x2="21" y2="12" />
                        <line x1="8" y1="18" x2="21" y2="18" />
                        <line x1="3" y1="6" x2="3.01" y2="6" />
                        <line x1="3" y1="12" x2="3.01" y2="12" />
                        <line x1="3" y1="18" x2="3.01" y2="18" />
                      </svg>
                    }
                  />
                  <div className="p-4 flex flex-col gap-3">
                    <div className="bg-[#f2f8f7] rounded-xl border border-[#dde9e8] p-3 flex flex-col gap-2 mb-1">
                      {itemsInCartInCart.slice(0, 3).map((item) => (
                        <div
                          key={item.variant_id}
                          className="flex items-center gap-2"
                        >
                          <img
                            src={item.image}
                            alt={item.name}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/default.svg";
                            }}
                            className="w-8 h-8 object-contain rounded-lg border border-[#c8d8d7] bg-white flex-shrink-0"
                          />
                          <p className="text-[11px] text-[#1e3330] line-clamp-1 flex-1">
                            {item.name}
                          </p>
                          <span className="text-[11px] font-bold text-[#1e4a46] flex-shrink-0">
                            ×{quantities[item.variant_id] || item.quantity}
                          </span>
                        </div>
                      ))}
                      {itemsInCartInCart.length > 3 && (
                        <p className="text-[10px] text-[#2d5250] text-center">
                          +{itemsInCartInCart.length - 3} more item
                          {itemsInCartInCart.length - 3 !== 1 ? "s" : ""}
                        </p>
                      )}
                    </div>

                    {[
                      {
                        label: "Total MRP",
                        val: `₹${originalTotal.toFixed(2)}`,
                        color: "text-[#1e4a46] font-semibold",
                      },
                      {
                        label: "Discount on MRP",
                        val: `− ₹${totalSaved.toFixed(2)}`,
                        color: "text-[#059669] font-semibold",
                      },
                      {
                        label: "Delivery",
                        val: shipping,
                        color: "text-[#059669] font-semibold",
                      },
                    ].map((row) => (
                      <div
                        key={row.label}
                        className="flex justify-between items-center"
                      >
                        <span className="text-[13px] text-[#2d5250] font-medium">
                          {row.label}
                        </span>
                        <span className={`text-[13px] ${row.color}`}>
                          {row.val}
                        </span>
                      </div>
                    ))}

                    <div className="h-px bg-[#f1f5f5] my-1" />
                    <div className="flex justify-between items-center">
                      <span className="text-[15px] font-bold text-[#0a1715]">
                        Total
                      </span>
                      <span
                        className="text-[18px] font-black text-[#1e4a46]"
                        style={{ fontFamily: "'Nunito',sans-serif" }}
                      >
                        ₹{total.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex justify-between items-center bg-[#ddf0ee] border border-[#aac9c7] rounded-xl px-3.5 py-2.5">
                      <div className="flex items-center gap-1.5">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#1e4a46"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span className="text-[12px] font-bold text-[#1e4a46]">
                          You save
                        </span>
                      </div>
                      <span
                        className="text-[14px] font-black text-[#1e4a46]"
                        style={{ fontFamily: "'Nunito',sans-serif" }}
                      >
                        ₹{totalSaved.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex items-center gap-2 bg-[#e8f5f4] border border-[#c8d8d7] rounded-xl px-3 py-2">
                      <div className="w-6 h-6 rounded-lg bg-[#ddf0ee] border border-[#aac9c7] flex items-center justify-center flex-shrink-0">
                        {selectedDeliveryOption === "home" ? (
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#5fbdb3"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                          </svg>
                        ) : (
                          <MapPin size={10} className="text-[#5fbdb3]" />
                        )}
                      </div>
                      <p className="text-[11px] text-[#1e3330] line-clamp-1 flex-1">
                        {selectedDeliveryOption === "home"
                          ? selectedAddrObj
                            ? `${selectedAddrObj.address_title} · ${selectedAddrObj.city}`
                            : "No address selected"
                          : selectedBranchObj
                            ? selectedBranchObj.area
                            : "No branch selected"}
                      </p>
                    </div>

                    {hasPrescriptionItems && (
                      <div
                        className={`flex items-center gap-2 rounded-xl px-3 py-2 border ${prescriptionUploaded ? "bg-green-50 border-green-200" : "bg-[#fff3ee] border-[#ffd5c2]"}`}
                      >
                        {prescriptionUploaded ? (
                          <CheckCircle
                            size={14}
                            className="text-green-600 flex-shrink-0"
                          />
                        ) : (
                          <AlertCircle
                            size={14}
                            className="text-[#ff601e] flex-shrink-0"
                          />
                        )}
                        <p
                          className={`text-[11px] font-semibold ${prescriptionUploaded ? "text-green-700" : "text-[#ff601e]"}`}
                        >
                          {prescriptionUploaded
                            ? "Prescription uploaded"
                            : "Prescription required"}
                        </p>
                        {!prescriptionUploaded && (
                          <button
                            onClick={() => setShowPrescriptionModal(true)}
                            className="ml-auto text-[10px] font-bold text-[#ff601e] underline cursor-pointer bg-transparent border-none"
                          >
                            Upload
                          </button>
                        )}
                      </div>
                    )}

                    <button
                      onClick={onPayment}
                      disabled={
                        isProcessing ||
                        (hasPrescriptionItems && !prescriptionUploaded)
                      }
                      className={`w-full h-12 rounded-2xl text-white text-[14px] font-bold flex items-center justify-center gap-2 transition-all duration-200 border-none mt-1
                        ${
                          hasPrescriptionItems && !prescriptionUploaded
                            ? "bg-[#c5d5d4] cursor-not-allowed shadow-none"
                            : "bg-[#1e4a46] hover:bg-[#ff601e] shadow-[0_4px_18px_rgba(22,44,42,0.28)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.4)] cursor-pointer"
                        } disabled:opacity-70`}
                    >
                      {isProcessing && (
                        <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                      )}
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                      {hasPrescriptionItems && !prescriptionUploaded
                        ? "Upload Prescription First"
                        : "Proceed to Checkout"}
                    </button>

                    <p className="text-[10px] text-[#2d5250] text-center">
                      {paymentMode === "ONLINE"
                        ? "🔒 Secured by Razorpay"
                        : "💵 Pay when your order arrives"}
                    </p>

                    {paymentMode === "ONLINE" && (
                      <div className="flex items-center justify-center gap-1.5 flex-wrap">
                        {["UPI", "Visa", "Mastercard", "Netbanking"].map(
                          (label) => (
                            <span
                              key={label}
                              className="text-[9px] font-semibold text-[#2d5250] bg-[#eaf4f3] border border-[#c8d8d7] rounded-md px-2 py-1"
                            >
                              {label}
                            </span>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          /* ── Empty cart ── */
          <div className="flex flex-col items-center justify-center py-20 gap-5">
            <div className="w-48 h-48">
              <DotLottieReact
                src="https://lottie.host/66e677d4-91a1-4f1a-85e7-a7d1faf607b8/dBHVRTKEJU.lottie"
                loop
                autoplay
              />
            </div>
            <div className="text-center">
              <p
                className="font-black text-[22px] text-[#1e4a46] mb-2"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Your cart is empty
              </p>
              <p className="text-[14px] text-[#2d5250] max-w-[280px] mx-auto">
                Go ahead and add products to start shopping!
              </p>
            </div>
            <Link to="/home">
              <button className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[14px] px-8 h-11 rounded-2xl transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.28)] cursor-pointer">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                Start Shopping
              </button>
            </Link>
          </div>
        )}
      </div>

      {/* ══ DELETE MODAL ══ */}
      <DeletePromptForCart
        showModal={showModal}
        onDelete={confirmDelete}
        onCancel={() => setShowModal(false)}
        data={deleteData}
      />

      {/* ══════════════════════════════════════════════
          PRESCRIPTION UPLOAD MODAL — with Notes + Medicine Images
      ══════════════════════════════════════════════ */}
      {showPrescriptionModal && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins p-4"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[520px] overflow-hidden max-h-[95vh] flex flex-col">
            {/* Gradient bar */}
            <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e] flex-shrink-0" />

            {/* Header */}
            <div className="px-6 py-4 border-b border-[#dde9e8] flex items-center justify-between flex-shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl flex items-center justify-center">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ff601e"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="12" y1="18" x2="12" y2="12" />
                    <line x1="9" y1="15" x2="15" y2="15" />
                  </svg>
                </div>
                <div>
                  <h2
                    className="text-[16px] font-black text-[#1e4a46]"
                    style={{ fontFamily: "'Nunito',sans-serif" }}
                  >
                    Upload Prescription
                  </h2>
                  <p className="text-[11px] text-[#5a7a77]">
                    JPG, PNG, PDF, DOC or DOCX · Max 5MB per file
                  </p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowPrescriptionModal(false);
                  setPrescriptionFiles([]);
                  setPrescriptionNotes("");
                  setAdditionalImages([]);
                }}
                className="w-8 h-8 rounded-xl border border-[#c8d8d7] bg-white flex items-center justify-center hover:border-[#5fbdb3] transition-all cursor-pointer"
              >
                <X size={14} className="text-[#2d5250]" />
              </button>
            </div>

            {/* Scrollable body */}
            <div className="p-6 flex flex-col gap-5 overflow-y-auto scrollbar-hide">
              {/* ── Attached prescriptions — a cart can need more than one,
                  so these are shown as a removable list rather than a
                  single slot. ── */}
              {attachedPrescriptions.length > 0 && (
                <div>
                  <p className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2">
                    Attached ({attachedPrescriptions.length})
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {attachedPrescriptions.map((p, i) => {
                      const kind = getFileKind(p.image_url);
                      const content =
                        p.image_url && kind.isImage ? (
                          <img
                            src={p.image_url}
                            alt={`Prescription ${i + 1}`}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/default.svg";
                            }}
                          />
                        ) : p.image_url ? (
                          <div className="w-full h-full flex flex-col items-center justify-center gap-0.5 bg-[#f8fafa] hover:bg-[#eaf4f3] transition-colors">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#5fbdb3"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline points="14 2 14 8 20 8" />
                            </svg>
                            <span className="text-[9px] font-bold text-[#1e4a46]">
                              {kind.label}
                            </span>
                          </div>
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-[10px] text-[#5a7a77] text-center px-1">
                            Rx {i + 1}
                          </div>
                        );
                      return (
                        <div
                          key={p.prescription_id || i}
                          className="relative w-16 h-16 rounded-xl overflow-hidden border-[1.5px] border-[#aac9c7] bg-[#e8f5f4] flex-shrink-0"
                        >
                          {/* Whole tile opens the file in a new tab so a
                              document (not just an image) can actually be
                              viewed/confirmed, not just identified by its
                              type badge. */}
                          {p.image_url ? (
                            <a
                              href={p.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block w-full h-full"
                              title={`View ${kind.label} prescription`}
                            >
                              {content}
                            </a>
                          ) : (
                            content
                          )}
                          <button
                            type="button"
                            onClick={() =>
                              removeAttachedPrescription(p.prescription_id)
                            }
                            className="absolute top-0.5 right-0.5 w-4.5 h-4.5 bg-red-500 rounded-full flex items-center justify-center border-none cursor-pointer"
                            style={{ width: 16, height: 16 }}
                          >
                            <X size={9} color="white" />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Prescription items list */}
              <div>
                <p className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2">
                  Requires Prescription:
                </p>
                <div className="flex flex-col gap-1.5">
                  {itemsInCartInCart
                    .filter((it) => it.prescription_required === "Yes")
                    .map((it) => (
                      <div
                        key={it.variant_id}
                        className="flex items-center gap-2 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-3 py-2"
                      >
                        <img
                          src={it.image}
                          alt={it.name}
                          className="w-8 h-8 object-contain rounded-lg bg-white border border-[#ffd5c2] flex-shrink-0"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/default.svg";
                          }}
                        />
                        <p className="text-[12px] font-semibold text-[#ff601e] flex-1 line-clamp-1">
                          {it.name}
                        </p>
                        <span className="text-[10px] font-bold text-[#ff601e] bg-white border border-[#ffd5c2] px-2 py-0.5 rounded-full flex-shrink-0">
                          Rx
                        </span>
                      </div>
                    ))}
                </div>
              </div>

              {/* ── Select from previously uploaded prescriptions ── */}
              {(loadingPreviousPrescriptions ||
                previousPrescriptions.length > 0) && (
                <div>
                  <p className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2">
                    Or choose from previously uploaded prescriptions{" "}
                    <span className="text-[#8faba9] font-normal normal-case">
                      (tap to select — multiple allowed)
                    </span>
                  </p>
                  {loadingPreviousPrescriptions ? (
                    <p className="text-[12px] text-[#8faba9] py-2">
                      Loading your recent prescriptions…
                    </p>
                  ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                      {previousPrescriptions.map((p) => {
                        const selected = attachedPrescriptions.some(
                          (x) => x.prescription_id === p.prescription_id,
                        );
                        const kind = getFileKind(p.image_url);
                        return (
                          <button
                            key={p.prescription_id}
                            type="button"
                            onClick={() => toggleExistingPrescription(p)}
                            className={`relative flex flex-col gap-1 rounded-xl border-[1.5px] p-2 text-left transition-all ${
                              selected
                                ? "border-[#5fbdb3] bg-[#e8f5f4]"
                                : "border-[#e2eaea] hover:border-[#5fbdb3] hover:bg-[#f4fbfa]"
                            }`}
                          >
                            <div className="w-full aspect-square rounded-lg overflow-hidden bg-[#f8fafa] border border-[#e2eaea] flex items-center justify-center">
                              {kind.isImage ? (
                                <img
                                  src={p.image_url}
                                  alt="Prescription"
                                  className="w-full h-full object-cover"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/default.svg";
                                  }}
                                />
                              ) : (
                                <div className="w-full h-full flex flex-col items-center justify-center gap-1">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#5fbdb3"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  >
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                    <polyline points="14 2 14 8 20 8" />
                                  </svg>
                                  <span className="text-[10px] font-bold text-[#1e4a46]">
                                    {kind.label}
                                  </span>
                                </div>
                              )}
                            </div>
                            {/* Separate from the select/toggle click on the
                                rest of the card — opens the actual file so
                                a document can be viewed, not just
                                identified by its type badge. Can't nest an
                                <a> inside this <button>, so window.open +
                                stopPropagation instead. */}
                            {p.image_url && (
                              <span
                                role="button"
                                tabIndex={0}
                                title={`View ${kind.label} prescription`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(
                                    p.image_url,
                                    "_blank",
                                    "noopener,noreferrer",
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    window.open(
                                      p.image_url,
                                      "_blank",
                                      "noopener,noreferrer",
                                    );
                                  }
                                }}
                                className="absolute top-1.5 left-1.5 w-6 h-6 rounded-lg bg-white/90 border border-[#e2eaea] flex items-center justify-center shadow-sm hover:bg-white hover:border-[#5fbdb3] transition-colors cursor-pointer"
                              >
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#1e4a46"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                  <circle cx="12" cy="12" r="3" />
                                </svg>
                              </span>
                            )}
                            <p className="text-[10px] text-[#5a7a77] truncate">
                              {p.created_at
                                ? new Date(p.created_at).toLocaleDateString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    },
                                  )
                                : "Unknown date"}
                            </p>
                            {selected && (
                              <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-[#1e4a46] flex items-center justify-center">
                                <svg
                                  width="10"
                                  height="10"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="white"
                                  strokeWidth="3"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <polyline points="20 6 9 17 4 12" />
                                </svg>
                              </span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* ── Prescription File Upload — `multiple` lets the
                  customer pick several prescription files in one go; each
                  becomes its own separate prescription when uploaded. ── */}
              <div>
                <p className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2">
                  {previousPrescriptions.length > 0
                    ? "Or upload new prescriptions"
                    : "Prescription File(s)"}
                </p>
                <div
                  onClick={() => prescriptionInputRef.current?.click()}
                  className={`border-2 border-dashed rounded-2xl p-5 text-center cursor-pointer transition-all duration-200
                    ${prescriptionFiles.length > 0 ? "border-[#5fbdb3] bg-[#e8f5f4]" : "border-[#c8d8d7] hover:border-[#5fbdb3] hover:bg-[#e8f5f4]"}`}
                >
                  <div className="w-12 h-12 bg-[#ddf0ee] border border-[#aac9c7] rounded-2xl flex items-center justify-center mx-auto mb-3">
                    <Upload size={20} className="text-[#5fbdb3]" />
                  </div>
                  <p className="text-[14px] font-bold text-[#1e4a46] mb-1">
                    Click to upload your prescription(s)
                  </p>
                  <p className="text-[12px] text-[#2d5250]">
                    or drag and drop here — select multiple files at once
                  </p>
                  <p className="text-[11px] text-[#2d5250] mt-1.5">
                    JPG, PNG, PDF, DOC or DOCX · Maximum 5MB each
                  </p>
                </div>
                <input
                  ref={prescriptionInputRef}
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                  className="hidden"
                  onChange={(e) => {
                    if (e.target.files?.length)
                      handlePrescriptionFilesSelect(e.target.files);
                    e.target.value = "";
                  }}
                />

                {/* Staged files — selected but not yet uploaded */}
                {prescriptionFiles.length > 0 && (
                  <div className="flex flex-col gap-1.5 mt-3">
                    <p className="text-[10px] font-bold text-[#5a7a77] uppercase tracking-wide">
                      Ready to upload ({prescriptionFiles.length})
                    </p>
                    {prescriptionFiles.map((file, i) => (
                      <div
                        key={i}
                        className="flex items-center gap-2.5 bg-[#f8fafa] border border-[#e2eaea] rounded-xl px-3 py-2"
                      >
                        <div className="w-8 h-8 bg-[#ddf0ee] border border-[#aac9c7] rounded-lg flex items-center justify-center flex-shrink-0">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#5fbdb3"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <polyline points="14 2 14 8 20 8" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-[12px] font-bold text-[#1e4a46] truncate">
                            {file.name}
                          </p>
                          <p className="text-[10px] text-[#8faba9]">
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                          </p>
                        </div>
                        <button
                          type="button"
                          onClick={() => removeStagedPrescriptionFile(i)}
                          className="w-6 h-6 rounded-lg flex items-center justify-center text-[#8faba9] hover:text-red-500 hover:bg-red-50 transition-colors border-none bg-transparent cursor-pointer flex-shrink-0"
                        >
                          <X size={13} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* ── Notes / Description ── */}
              <div>
                <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide mb-2 block">
                  Notes / Description{" "}
                  <span className="text-[#8faba9] font-normal normal-case">
                    (optional)
                  </span>
                </label>
                <textarea
                  value={prescriptionNotes}
                  onChange={(e) => setPrescriptionNotes(e.target.value)}
                  placeholder="e.g. Dr. Sharma's prescription for 30-day course, diabetic medication, etc."
                  maxLength={500}
                  rows={3}
                  className="w-full rounded-xl border border-[#c8d8d7] px-3 py-2.5 text-[13px] text-[#1e4a46] placeholder-[#aac9c7] outline-none focus:border-[#5fbdb3] transition-colors resize-none"
                />
                <p className="text-[10px] text-[#8faba9] text-right mt-1">
                  {prescriptionNotes.length}/500
                </p>
              </div>

              {/* ── Medicine Images (optional) ── */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="text-[11px] font-bold text-[#1e3330] uppercase tracking-wide">
                    Medicine Images{" "}
                    <span className="text-[#8faba9] font-normal normal-case">
                      (optional · max 5)
                    </span>
                  </label>
                  {/* {additionalImages.length < 5 && (
                    <button
                      onClick={() => additionalImagesRef.current?.click()}
                      className="flex items-center gap-1 text-[11px] font-semibold text-[#5fbdb3] hover:text-[#1e4a46] transition-colors"
                    >
                      <ImagePlus size={13} />
                      Add Photos
                    </button>
                  )} */}
                </div>

                {additionalImages.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {additionalImages.map((img, i) => (
                      <div
                        key={i}
                        className="relative w-16 h-16 rounded-xl overflow-hidden border-[1.5px] border-[#aac9c7] bg-[#e8f5f4] flex-shrink-0"
                      >
                        <img
                          src={URL.createObjectURL(img)}
                          alt={`medicine-${i}`}
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={() => removeAdditionalImage(i)}
                          className="absolute top-0.5 right-0.5 w-4.5 h-4.5 bg-red-500 rounded-full flex items-center justify-center"
                          style={{ width: 16, height: 16 }}
                        >
                          <X size={9} color="white" />
                        </button>
                      </div>
                    ))}
                    {additionalImages.length < 5 && (
                      <button
                        onClick={() => additionalImagesRef.current?.click()}
                        className="w-16 h-16 rounded-xl border-2 border-dashed border-[#c8d8d7] hover:border-[#5fbdb3] bg-[#f2f8f7] hover:bg-[#e8f5f4] flex flex-col items-center justify-center transition-all cursor-pointer"
                      >
                        <ImagePlus size={16} className="text-[#aac9c7]" />
                        <span className="text-[9px] text-[#aac9c7] mt-0.5">
                          Add
                        </span>
                      </button>
                    )}
                  </div>
                ) : (
                  <div
                    onClick={() => additionalImagesRef.current?.click()}
                    className="border-2 border-dashed border-[#c8d8d7] hover:border-[#5fbdb3] rounded-xl px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-[#e8f5f4] transition-all"
                  >
                    <div className="w-9 h-9 bg-[#e8f5f4] border border-[#aac9c7] rounded-xl flex items-center justify-center flex-shrink-0">
                      <ImagePlus size={16} className="text-[#5fbdb3]" />
                    </div>
                    <div>
                      <p className="text-[12px] font-semibold text-[#1e4a46]">
                        Add medicine photos
                      </p>
                      <p className="text-[10px] text-[#2d5250]">
                        JPG or PNG · up to 5 images · 5MB each
                      </p>
                    </div>
                  </div>
                )}

                <input
                  ref={additionalImagesRef}
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  multiple
                  className="hidden"
                  onChange={(e) => {
                    if (e.target.files?.length)
                      handleAdditionalImagesSelect(e.target.files);
                    e.target.value = "";
                  }}
                />
              </div>

              {/* Action buttons */}
              <div className="flex gap-3 pt-1">
                <button
                  onClick={() => {
                    setShowPrescriptionModal(false);
                    setPrescriptionFiles([]);
                    setPrescriptionNotes("");
                    setAdditionalImages([]);
                  }}
                  className="flex-1 py-2.5 rounded-xl border border-[#c8d8d7] text-[#1e3330] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer bg-white"
                >
                  Cancel
                </button>
                {prescriptionFiles.length > 0 ? (
                  <button
                    onClick={uploadPrescription}
                    disabled={uploadingPrescription}
                    className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold flex items-center justify-center gap-2 transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    {uploadingPrescription && (
                      <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                    )}
                    {uploadingPrescription
                      ? "Uploading…"
                      : prescriptionFiles.length > 1
                        ? `Add ${prescriptionFiles.length} Prescriptions`
                        : "Add Prescription"}
                  </button>
                ) : (
                  <button
                    onClick={() => setShowPrescriptionModal(false)}
                    disabled={attachedPrescriptions.length === 0}
                    className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold flex items-center justify-center gap-2 transition-all border-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  >
                    Done
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ CLEAR CART ══ */}
      {showConfirm && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[320px] shadow-2xl">
            <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
            <div className="p-6">
              <h2
                className="text-[16px] font-bold text-white mb-2"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Clear entire cart?
              </h2>
              <p className="text-[13px] text-[#7abcb8] mb-5">
                All items will be removed permanently.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowConfirm(false)}
                  className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all bg-transparent cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  onClick={handleClearCart}
                  className="flex-1 py-2.5 rounded-xl bg-red-500 hover:bg-red-600 text-white text-[13px] font-extrabold uppercase tracking-widest transition-all border-none cursor-pointer"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ COD CONFIRM ══ */}
      {isCODConfirmPopUp && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm font-poppins"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-[#0e1e1c] border border-[#1e4a46] rounded-2xl overflow-hidden w-[340px] shadow-2xl">
            <div className="h-[3px] bg-gradient-to-r from-[#162c2a] via-[#5fbdb3] to-[#ff601e]" />
            <div className="p-6">
              <h2
                className="text-[16px] font-bold text-white mb-2"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Confirm COD Order
              </h2>
              <p className="text-[13px] text-[#7abcb8] mb-5">
                Place this order with{" "}
                <strong className="text-white">Cash on Delivery</strong>?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setIsCODConfirmPopUp(false);
                    setIsProcessing(false);
                  }}
                  disabled={isCODProcessing}
                  className="flex-1 py-2.5 rounded-xl border border-[#1e4a46] text-[#7abcb8] text-[13px] font-semibold hover:border-[#5fbdb3] hover:text-white transition-all disabled:opacity-50 bg-transparent cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  onClick={handleCODOrder}
                  disabled={isCODProcessing}
                  className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-extrabold uppercase tracking-widest flex items-center justify-center gap-2 transition-all border-none disabled:opacity-70 cursor-pointer"
                >
                  {isCODProcessing && (
                    <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                  )}
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ ADDRESS REQUIRED ══ */}
      {showAddressPrompt && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
            <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
            <div className="p-6 text-center">
              <div className="w-14 h-14 bg-[#ddf0ee] rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin size={24} className="text-[#1e4a46]" />
              </div>
              <h2
                className="text-[18px] font-bold text-[#1e4a46] mb-2"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Address Required
              </h2>
              <p className="text-[13px] text-[#2d5250] mb-6">
                Please add a delivery address to proceed.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowAddressPrompt(false)}
                  className="flex-1 py-2.5 rounded-xl border border-[#c8d8d7] text-[#1e3330] text-[13px] font-semibold hover:border-[#5fbdb3] transition-all cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowAddressPrompt(false);
                    setPopupOpen(true);
                  }}
                  className="flex-1 py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer"
                >
                  Add Address
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══ BRANCH REQUIRED ══ */}
      {showBranchPrompt && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm font-poppins"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-white rounded-2xl overflow-hidden w-[360px] shadow-2xl">
            <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
            <div className="p-6 text-center">
              <div className="w-14 h-14 bg-[#ddf0ee] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#1e4a46"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <h2
                className="text-[18px] font-bold text-[#1e4a46] mb-2"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Store Selection is Required
              </h2>
              <p className="text-[13px] text-[#2d5250] mb-6">
                Please select a store pickup location to proceed.
              </p>
              <button
                onClick={() => setShowBranchPrompt(false)}
                className="w-full py-2.5 rounded-xl bg-[#1e4a46] hover:bg-[#ff601e] text-white text-[13px] font-bold transition-all border-none cursor-pointer"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ EDIT ADDRESS ══ — same header/grid/footer layout as Add New
          Address (Adresspopup.js) so the two screens look the same. No
          default-address toggle here: which address is default is driven
          by the "Deliver to" dropdown selection instead (setAddressAsDefault). */}
      {isEditPopupOpen && selectedAddress && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-[#0a1715]/60 backdrop-blur-sm px-4 font-poppins">
          <div className="bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.3)] w-full max-w-[700px] max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header — same layout as Add New Address */}
            <div className="relative bg-[#162c2a] px-6 py-5 flex-shrink-0">
              <div
                className="absolute inset-0 opacity-[0.05] pointer-events-none"
                style={{
                  backgroundImage: plusPattern,
                  backgroundRepeat: "repeat",
                  backgroundSize: "40px 40px",
                }}
              />
              <div className="relative flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src={logo}
                    alt="MediSYS"
                    className="h-8 w-auto object-contain"
                  />
                  <div className="w-px h-6 bg-white/20" />
                  <div>
                    <p className="font-bold text-[15px] text-white leading-tight">
                      Edit Address
                    </p>
                    <p className="text-[11px] text-white/45 mt-0.5">
                      Update your delivery address details
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setIsEditPopupOpen(false);
                    setSelectedAddress(null);
                  }}
                  className="w-8 h-8 rounded-xl bg-white/[0.1] hover:bg-white/[0.2] flex items-center justify-center transition-colors flex-shrink-0"
                >
                  <X size={14} className="text-white" />
                </button>
              </div>
            </div>

            {/* Body — same 2-column grid as Add New Address */}
            <div className="overflow-y-auto scrollbar-hide p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                <InputField
                  label="Address Name"
                  required
                  error={addressErrors.address_title}
                >
                  <input
                    type="text"
                    name="address_title"
                    placeholder="Home, Office…"
                    value={selectedAddress.address_title || ""}
                    onChange={handleChange}
                    maxLength={25}
                    className={inputCls(!!addressErrors.address_title)}
                  />
                </InputField>

                <InputField
                  label="Mobile Number"
                  required
                  error={addressErrors.mobile_number}
                >
                  <div className="flex">
                    <div className="flex items-center gap-1.5 px-3 bg-[#f8fafa] border-[1.5px] border-r-0 border-[#e2eaea] rounded-l-xl h-11 flex-shrink-0">
                      <span className="text-[14px]">🇮🇳</span>
                      <span className="text-[13px] font-semibold text-[#374747]">
                        +91
                      </span>
                    </div>
                    <input
                      type="tel"
                      name="mobile_number"
                      placeholder="10-digit number"
                      value={selectedAddress.mobile_number || ""}
                      onChange={handleChange}
                      maxLength={10}
                      inputMode="numeric"
                      className={`flex-1 h-11 px-3 bg-white border-[1.5px] rounded-r-xl outline-none text-[13px] text-[#1a2625] ${addressErrors.mobile_number ? "border-red-400" : "border-[#e2eaea] focus:border-[#1e4a46]"}`}
                    />
                  </div>
                </InputField>

                <div className="sm:col-span-2">
                  <InputField
                    label="Address Line 1"
                    required
                    error={addressErrors.address_line_1}
                  >
                    <input
                      type="text"
                      name="address_line_1"
                      placeholder="Street, Building"
                      value={selectedAddress.address_line_1 || ""}
                      onChange={handleChange}
                      maxLength={120}
                      className={inputCls(!!addressErrors.address_line_1)}
                    />
                  </InputField>
                </div>

                <div className="sm:col-span-2">
                  <InputField
                    label="Address Line 2"
                    error={addressErrors.address_line_2}
                  >
                    <input
                      type="text"
                      name="address_line_2"
                      placeholder="Area, Landmark (optional)"
                      value={selectedAddress.address_line_2 || ""}
                      onChange={handleChange}
                      maxLength={20}
                      className={inputCls(!!addressErrors.address_line_2)}
                    />
                  </InputField>
                </div>

                <InputField
                  label="City"
                  required
                  error={addressErrors.city}
                >
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={selectedAddress.city || ""}
                    onChange={handleChange}
                    maxLength={20}
                    className={inputCls(!!addressErrors.city)}
                  />
                </InputField>

                <InputField
                  label="Pincode"
                  required
                  error={addressErrors.pincode}
                >
                  <input
                    type="text"
                    name="pincode"
                    placeholder="6-digit"
                    value={selectedAddress.pincode || ""}
                    onChange={handleChange}
                    maxLength={6}
                    inputMode="numeric"
                    className={inputCls(!!addressErrors.pincode)}
                  />
                </InputField>

                <div className="sm:col-span-2">
                  <InputField label="State" required error={addressErrors.state}>
                    <select
                      name="state"
                      value={selectedAddress.state || ""}
                      onChange={handleChange}
                      className={`${inputCls(!!addressErrors.state)} cursor-pointer`}
                    >
                      <option value="">Select State</option>
                      {indianStates.map((st) => (
                        <option key={st} value={st}>
                          {st}
                        </option>
                      ))}
                    </select>
                  </InputField>
                </div>
              </div>
            </div>

            {/* Footer — same layout as Add New Address */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#f1f5f5] flex-shrink-0 bg-[#f8fafa]">
              <button
                onClick={() => {
                  setIsEditPopupOpen(false);
                  setSelectedAddress(null);
                }}
                className="h-11 px-6 rounded-xl border-[1.5px] border-[#e2eaea] text-[#374747] text-[13px] font-semibold hover:bg-[#f1f5f5] hover:border-[#c5d5d4] transition-all duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateAddress}
                disabled={!isEditFormValid}
                className="h-11 px-6 rounded-xl bg-[#162c2a] hover:bg-[#1e4a46] text-white text-[13px] font-semibold transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-[0_2px_10px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_16px_rgba(22,44,42,0.35)] hover:-translate-y-px flex items-center gap-2"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                  <polyline points="17 21 17 13 7 13 7 21" />
                  <polyline points="7 3 7 8 15 8" />
                </svg>
                Save Address
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Always mounted (gated by isOpen, not conditional rendering) so an
          accidental outside-click close doesn't unmount the form and lose
          whatever the customer had already typed. */}
      <Adresspopup
        isOpen={isPopupOpen}
        onClose={() => setPopupOpen(false)}
        fetchAddresses={fetchAddresses}
        hasExistingAddresses={addresses.length > 0}
      />

      <style>{`
        @keyframes fadeInUp { from { opacity:0; transform:translateY(14px); } to { opacity:1; transform:translateY(0); } }
        .scrollbar-hide::-webkit-scrollbar { display:none; }
        .scrollbar-hide { -ms-overflow-style:none; scrollbar-width:none; }
      `}</style>
    </div>
  );
};

export default Cartpage;
